import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Decimal2: { input: string; output: string; }
  Decimal4: { input: string; output: string; }
};

/**
 * In order to create account, there should be an account fee paid.
 * AccountInvoice represents this pending payment for broker account.
 */
export type AccountInvoice = {
  __typename?: 'AccountInvoice';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoiceNo: Scalars['String']['output'];
  paymentMethod: AccountInvoicePaymentMethod;
  /** Is provided only if paymentMethod is QPay. */
  qpayInvoice?: Maybe<QPayInvoice>;
  status: AccountInvoiceStatus;
  updatedAt: Scalars['Float']['output'];
  user: User;
};

export enum AccountInvoicePaymentMethod {
  PostPayment = 'PostPayment',
  QPay = 'QPay'
}

export enum AccountInvoiceStatus {
  Paid = 'Paid',
  Pending = 'Pending'
}

export type Activity = {
  __typename?: 'Activity';
  _id?: Maybe<Scalars['ID']['output']>;
  body: Scalars['String']['output'];
  createdAt: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  type: ActivityType;
  user: User;
};

export enum ActivityType {
  Basic = 'BASIC',
  Order = 'ORDER',
  Purchase = 'PURCHASE'
}

export type AddActivityInput = {
  body: Scalars['String']['input'];
  createdAt: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  type: ActivityType;
  users: Array<Scalars['ID']['input']>;
};

export type AddBondInput = {
  active: Scalars['Boolean']['input'];
  /** String in format of "1y 2m" */
  duration: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Float']['input']>;
  interestRate: Scalars['Float']['input'];
  localizedDescription?: InputMaybe<LocalizedStringInput>;
  localizedName?: InputMaybe<LocalizedStringInput>;
  name: Scalars['String']['input'];
  paymentSchedules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  symbol: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddBondPurchaseInput = {
  amount: Scalars['Float']['input'];
  bond: Scalars['ID']['input'];
  fee: Scalars['Float']['input'];
};

export type AddConfigInput = {
  description: Scalars['String']['input'];
  key: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type AddDepositAccountInput = {
  accountName: Scalars['String']['input'];
  accountNo: Scalars['String']['input'];
  bank: DepositAccountBank;
  iBan?: InputMaybe<Scalars['String']['input']>;
  txDescriptionFormat: DepositTxDescriptionFormat;
};

export type AddFaqInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type AddImageInput = {
  path: Scalars['String']['input'];
};

export type AddKycQuestionnaireInput = {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  localizedDescription: LocalizedStringInput;
  localizedName: LocalizedStringInput;
  name: Scalars['String']['input'];
  questions: Array<KycQuestionnaireQuestionInput>;
};

export type AddOrderInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  type: OrderType;
  userId: Scalars['ID']['input'];
};

export type AddPortfolioBondInput = {
  value: Scalars['Float']['input'];
};

export type AddPortfolioInput = {
  active: Scalars['Boolean']['input'];
  bond: AddPortfolioBondInput;
  description: Scalars['String']['input'];
  duration: Duration;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  localizedDescription: LocalizedStringInput;
  localizedName: LocalizedStringInput;
  name: Scalars['String']['input'];
  riskLevel: Scalars['Int']['input'];
  saving: AddPortfolioSavingInput;
  stocks: Array<AddPortfolioStockInput>;
};

export type AddPortfolioSavingInput = {
  value: Scalars['Float']['input'];
};

export type AddPortfolioStockInput = {
  stock: Scalars['ID']['input'];
  value: Scalars['Float']['input'];
};

export type AddPurchasesInput = {
  bonds: Array<AddBondPurchaseInput>;
  savings: Array<AddSavingPurchaseInput>;
  stocks: Array<AddStockPurchaseInput>;
  type: PurchaseType;
  usdRate: Scalars['Float']['input'];
};

export type AddSavingInput = {
  accountNo: Scalars['String']['input'];
  balance: Scalars['Float']['input'];
  bankName: Scalars['String']['input'];
  currency: Currency;
  /** String in format of "1y 2m" */
  duration: Scalars['String']['input'];
  interestRate: Scalars['Float']['input'];
  localizedDescription?: InputMaybe<LocalizedStringInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddSavingPurchaseInput = {
  amount: Scalars['Float']['input'];
  fee: Scalars['Float']['input'];
  saving: Scalars['ID']['input'];
};

export type AddStockInput = {
  image?: InputMaybe<AddImageInput>;
  localizedDescription: LocalizedStringInput;
  localizedName: LocalizedStringInput;
  symbol: Scalars['String']['input'];
  type: StockType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddStockPurchaseInput = {
  quantity: Scalars['Float']['input'];
  symbol: Scalars['String']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type AddSuggestionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  expireAt: Scalars['Float']['input'];
  portfolioInfos: Array<PortfolioInfoInput>;
  stocks: Array<Scalars['String']['input']>;
  suggestionCount: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddSurveyInput = {
  active: Scalars['Boolean']['input'];
  completeText: Scalars['String']['input'];
  introText: Scalars['String']['input'];
  localizedCompleteText: LocalizedStringInput;
  localizedIntroText: LocalizedStringInput;
  localizedName: LocalizedStringInput;
  name: Scalars['String']['input'];
  questions?: InputMaybe<Array<QuestionInput>>;
};

export type AddUserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  bankInfo?: InputMaybe<BankInfo>;
  birthDate?: InputMaybe<Scalars['Float']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
  role: Role;
  type: UserType;
};

export type AdvancedSearchInput = {
  date?: InputMaybe<DateRange>;
  mscdAccountFilter?: InputMaybe<MscdAccountFilter>;
  role?: InputMaybe<Role>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
  type?: InputMaybe<UserType>;
};

export type AmountAndQuantity = {
  __typename?: 'AmountAndQuantity';
  quantity: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type Answer = {
  __typename?: 'Answer';
  durationPoints: Scalars['Int']['output'];
  localizedValue?: Maybe<LocalizedString>;
  riskPoints: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type AnswerInput = {
  durationPoints: Scalars['Int']['input'];
  localizedValue: LocalizedStringInput;
  riskPoints: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AssetPerformance = {
  __typename?: 'AssetPerformance';
  currentValue: Scalars['Float']['output'];
  interestEarned?: Maybe<Scalars['Float']['output']>;
  invested: Scalars['Float']['output'];
  profitLoss: Scalars['Float']['output'];
};

export type Auth = {
  __typename?: 'Auth';
  /**
   * Whether if user has email, first and last names set
   * @deprecated Use verificationStage field on User type
   */
  isRegistered: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  /** Token expiration time in ISO format */
  tokenExpiresAt: Scalars['String']['output'];
  user: User;
};

export type Balance = {
  __typename?: 'Balance';
  _id?: Maybe<Scalars['ID']['output']>;
  balanceHistory: Array<Purchase>;
  bonds: Array<BalanceBond>;
  cashAmount: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  holdAmount: Scalars['Float']['output'];
  netAssetValue: Scalars['Float']['output'];
  orderHistory: Array<Order>;
  processingAmount: Scalars['Float']['output'];
  savings: Array<BalanceSaving>;
  stocks: Array<BalanceStock>;
  /** Total amount of money deposited to this balance */
  totalDeposit?: Maybe<Scalars['Float']['output']>;
  user: User;
};

export type BalanceAmountsResult = {
  __typename?: 'BalanceAmountsResult';
  _id?: Maybe<Scalars['ID']['output']>;
  bonds: AmountAndQuantity;
  cashAmount: Scalars['Float']['output'];
  holdAmount: Scalars['Float']['output'];
  netAssetValue: Scalars['Float']['output'];
  savings: AmountAndQuantity;
  stocks: AmountAndQuantity;
  user: User;
};

export type BalanceBond = {
  __typename?: 'BalanceBond';
  /** @deprecated This field has invalid values and should not be used. Use @avta-mata/logic libary for interest calculations. */
  accumulatedAmount: Scalars['Float']['output'];
  bond: Bond;
  /** @deprecated This field has invalid values and should not be used. Use @avta-mata/logic libary for interest calculations. */
  estimatedTotalEarnings: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  history: Array<BalanceBondHistory>;
  principleAmount: Scalars['Float']['output'];
};

export type BalanceBondHistory = {
  __typename?: 'BalanceBondHistory';
  _id: Scalars['ID']['output'];
  /** @deprecated This field has invalid values and should not be used. Use @avta-mata/logic libary for interest calculations. */
  accumulatedAmount: Scalars['Float']['output'];
  createdAt: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  lastPayoutAt?: Maybe<Scalars['String']['output']>;
  principleAmount: Scalars['Float']['output'];
};

export type BalanceExportTask = {
  __typename?: 'BalanceExportTask';
  _id: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Float']['output'];
  /** Failure reason. Only present when status is FAILED. */
  error?: Maybe<Scalars['String']['output']>;
  status: BalanceExportTaskStatus;
  /** Pre-signed download URL. Only present when status is DONE. */
  url?: Maybe<Scalars['String']['output']>;
  withMnt: Scalars['Boolean']['output'];
};

export enum BalanceExportTaskStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type BalanceFormationItem = {
  __typename?: 'BalanceFormationItem';
  amount: Scalars['Float']['output'];
  date: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  runningBalance: Scalars['Float']['output'];
  type: UserReportTransactionType;
};

export type BalanceSaving = {
  __typename?: 'BalanceSaving';
  /** @deprecated This field has invalid values and should not be used. Use @avta-mata/logic libary for interest calculations. */
  accumulatedAmount: Scalars['Float']['output'];
  /** @deprecated This field has invalid values and should not be used. Use @avta-mata/logic libary for interest calculations. */
  estimatedTotalEarnings: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  history: Array<BalanceSavingHistory>;
  principleAmount: Scalars['Float']['output'];
  saving: Saving;
};

export type BalanceSavingHistory = {
  __typename?: 'BalanceSavingHistory';
  _id: Scalars['ID']['output'];
  /** @deprecated This field has invalid values and should not be used. Use @avta-mata/logic libary for interest calculations. */
  accumulatedAmount: Scalars['Float']['output'];
  createdAt: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  principleAmount: Scalars['Float']['output'];
};

export type BalanceStock = {
  __typename?: 'BalanceStock';
  allTimeProfitAndLoss: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  history: Array<BalanceStockHistory>;
  lastDayProfitAndLoss: Scalars['Float']['output'];
  stock: Stock;
  totalAmount: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  totalPriceByUsd: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type BalanceStockHistory = {
  __typename?: 'BalanceStockHistory';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  holdAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  usdRate: Scalars['Float']['output'];
};

export type BalanceUnholdHistoryRecord = {
  __typename?: 'BalanceUnholdHistoryRecord';
  _id: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Float']['output'];
  endBalance: Scalars['Float']['output'];
  purchaseId?: Maybe<Scalars['ID']['output']>;
  purchaseTitle?: Maybe<Scalars['String']['output']>;
  startBalance: Scalars['Float']['output'];
  user?: Maybe<User>;
};

export type BalanceUnholdHistoryResult = {
  __typename?: 'BalanceUnholdHistoryResult';
  items: Array<BalanceUnholdHistoryRecord>;
  totalPages: Scalars['Int']['output'];
};

export type BankInfo = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNo: Scalars['String']['input'];
  /** Bank codes are provided by DBX API. Please refer to `brokerAccountBankList` query. */
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankName: Scalars['String']['input'];
};

export type Bond = {
  __typename?: 'Bond';
  _id?: Maybe<Scalars['ID']['output']>;
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** String in format of "1y 2m" */
  duration?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is never used */
  endDate?: Maybe<Scalars['Float']['output']>;
  interestRate: Scalars['Float']['output'];
  localizedName?: Maybe<LocalizedString>;
  name: Scalars['String']['output'];
  paymentSchedules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  paymentType?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is never used */
  startDate?: Maybe<Scalars['Float']['output']>;
  symbol: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type BondHolder = {
  __typename?: 'BondHolder';
  bondName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  historyId: Scalars['ID']['output'];
  interestRate?: Maybe<Scalars['Float']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPayoutAt?: Maybe<Scalars['Float']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  principleAmount: Scalars['Float']['output'];
  purchaseDate: Scalars['Float']['output'];
  registerNo?: Maybe<Scalars['String']['output']>;
  taxPayerNo?: Maybe<Scalars['String']['output']>;
  totalInterest?: Maybe<Scalars['Float']['output']>;
  totalTax?: Maybe<Scalars['Float']['output']>;
  userId: Scalars['ID']['output'];
};

export type BondHoldersResult = {
  __typename?: 'BondHoldersResult';
  holders: Array<BondHolder>;
  totalAmount: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
};

export type BondInterestPreview = {
  __typename?: 'BondInterestPreview';
  bondIndex: Scalars['Int']['output'];
  bondName: Scalars['String']['output'];
  correctedInterest: Scalars['Float']['output'];
  createdAt: Scalars['Float']['output'];
  currentInterest: Scalars['Float']['output'];
  difference: Scalars['Float']['output'];
  historyEntryId: Scalars['ID']['output'];
  principalDifference: Scalars['Float']['output'];
  principleAmount: Scalars['Float']['output'];
  purchaseId?: Maybe<Scalars['ID']['output']>;
};

export type BondInterestRecalcInput = {
  bondIndex: Scalars['Int']['input'];
  correctedAmount: Scalars['Float']['input'];
  historyIndex: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type BondInterestRecalcPreview = {
  __typename?: 'BondInterestRecalcPreview';
  entries: Array<BondInterestPreview>;
  totalCorrectedInterest: Scalars['Float']['output'];
  totalCorrection: Scalars['Float']['output'];
  totalCurrentInterest: Scalars['Float']['output'];
  totalDifference: Scalars['Float']['output'];
  totalPrincipalDifference: Scalars['Float']['output'];
};

export type BondPayoutBatch = {
  __typename?: 'BondPayoutBatch';
  _id: Scalars['ID']['output'];
  batchId: Scalars['String']['output'];
  bondId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['Float']['output']>;
  completedTasks: Scalars['Int']['output'];
  createdAt: Scalars['Float']['output'];
  failedTasks: Scalars['Int']['output'];
  initiatedBy?: Maybe<Scalars['ID']['output']>;
  startedAt: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  totalTasks: Scalars['Int']['output'];
  updatedAt: Scalars['Float']['output'];
};

export type BondPayoutEntry = {
  __typename?: 'BondPayoutEntry';
  batchId: Scalars['String']['output'];
  createdAt: Scalars['Float']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  interest: Scalars['Float']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  principleAmount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  userId: Scalars['ID']['output'];
};

export type BondPayoutHistoryResult = {
  __typename?: 'BondPayoutHistoryResult';
  payouts: Array<BondPayoutEntry>;
  totalCount: Scalars['Int']['output'];
};

export type BondWithdrawalEntry = {
  __typename?: 'BondWithdrawalEntry';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Float']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  purchasedAt: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
  withdrawnAmount?: Maybe<Scalars['Float']['output']>;
};

export type BondWithdrawalHistoryResult = {
  __typename?: 'BondWithdrawalHistoryResult';
  totalCount: Scalars['Int']['output'];
  withdrawals: Array<BondWithdrawalEntry>;
};

/** BrokerAccountBank is a bank supported by the broker. */
export type BrokerAccountBank = {
  __typename?: 'BrokerAccountBank';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BrokerAccountMissingInfo = {
  __typename?: 'BrokerAccountMissingInfo';
  /** Currently is always true. */
  bankAccount: Scalars['Boolean']['output'];
  email: Scalars['Boolean']['output'];
  phoneNo: Scalars['Boolean']['output'];
};

export type BrokerAccountPendingInvoicesList = {
  __typename?: 'BrokerAccountPendingInvoicesList';
  invoices?: Maybe<Array<AccountInvoice>>;
  totalPages: Scalars['Int']['output'];
};

export type BrokerAccountRequest = {
  bankAccountNo: Scalars['String']['input'];
  /** bankCode must be a bank code provided by DBX */
  bankCode: Scalars['String']['input'];
  /** bankName must be a bank from list provided by DBX */
  bankName: Scalars['String']['input'];
  /** Optional only if BrokerAccountMissingInfo.email is false */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Optional only if BrokerAccountMissingInfo.phoneNo is false */
  phoneNo?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Current status of broker account request. At first, status will be NonExisting.
 * If user submits his information, status will be become PendingPayment.
 * After payment, actual request is sent to DBX and status will become PendingCreation.
 * After each deposit, user status will be synced with DBX.
 */
export enum BrokerAccountStatus {
  /** User's account was verified and created */
  Created = 'Created',
  /** User has submitted incorrect information */
  InvalidInfo = 'InvalidInfo',
  /** User did not submit broker account request */
  NonExisting = 'NonExisting',
  /** Account request was created, but was not sent to DBX yet */
  PendingCreation = 'PendingCreation',
  /** Waiting for user payment. You can check if invoice was already created by calling `brokerAccountInvoice` query. */
  PendingPayment = 'PendingPayment',
  /** User's inforation was received, but was not sent to Mongolian Central Securities Depository */
  PendingVerification = 'PendingVerification'
}

export type BulkAddOrderBatch = {
  __typename?: 'BulkAddOrderBatch';
  actor?: Maybe<User>;
  batchId: Scalars['ID']['output'];
  createdAt: Scalars['Float']['output'];
  failedCount: Scalars['Int']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  pendingCount: Scalars['Int']['output'];
  revertedCount: Scalars['Int']['output'];
  rows: Array<BulkAddOrderBatchRow>;
  status: BulkAddOrderBatchStatus;
  successCount: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
  totalRows: Scalars['Int']['output'];
  updatedAt: Scalars['Float']['output'];
};

export type BulkAddOrderBatchRow = {
  __typename?: 'BulkAddOrderBatchRow';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  email: Scalars['String']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  processedAt?: Maybe<Scalars['Float']['output']>;
  reverted: Scalars['Boolean']['output'];
  rowNumber: Scalars['Int']['output'];
  status: BulkAddOrderBatchRowStatus;
  user?: Maybe<User>;
};

export enum BulkAddOrderBatchRowStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Success = 'Success'
}

export enum BulkAddOrderBatchStatus {
  Done = 'Done',
  DoneWithFailures = 'DoneWithFailures',
  PartiallyReverted = 'PartiallyReverted',
  Processing = 'Processing',
  Reverted = 'Reverted'
}

export type BulkAddOrderInput = {
  /** false = dry-run preview, true = бодит цэнэглэлт */
  confirm: Scalars['Boolean']['input'];
  /** Excel файлын base64 encoded контент */
  fileBase64: Scalars['String']['input'];
  /** Файлын нэр (GCS-д хадгалахдаа ашиглана) */
  filename: Scalars['String']['input'];
};

export type BulkAddOrderResult = {
  __typename?: 'BulkAddOrderResult';
  /** Зөвхөн confirm=true үед буцна. Энэ ID-аар batch явцыг харна. */
  batchId?: Maybe<Scalars['ID']['output']>;
  /** Зөвхөн confirm=true амжилттай үед буцна (GCS signed URL) */
  fileUrl?: Maybe<Scalars['String']['output']>;
  invalidRows: Scalars['Int']['output'];
  rows: Array<BulkAddOrderRowResult>;
  totalAmount: Scalars['Float']['output'];
  totalRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
};

export type BulkAddOrderRowResult = {
  __typename?: 'BulkAddOrderRowResult';
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Excel-ийн мөрийн дугаар (header дараа 2-оос эхэлнэ) */
  row: Scalars['Int']['output'];
  status: BulkAddOrderRowStatus;
  user?: Maybe<User>;
};

export enum BulkAddOrderRowStatus {
  Invalid = 'Invalid',
  Processed = 'Processed',
  Valid = 'Valid'
}

export type CashCorrectionInput = {
  amount: Scalars['Float']['input'];
  fromHold?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type ClosedPosition = {
  __typename?: 'ClosedPosition';
  assetId: Scalars['ID']['output'];
  assetName: Scalars['String']['output'];
  assetType: UserReportAssetType;
  closeDate: Scalars['Float']['output'];
  principleAmount: Scalars['Float']['output'];
  profitLoss: Scalars['Float']['output'];
  purchaseDate: Scalars['Float']['output'];
  saleAmount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
};

export type Config = {
  __typename?: 'Config';
  _id?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  createdAt: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  /** Одоогийн хэрэглэгч энэ гэрээг зурсан эсэх. */
  isSigned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  portfolio?: Maybe<Portfolio>;
  previewUrl: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CorrectionOrder = {
  __typename?: 'CorrectionOrder';
  _id: Scalars['ID']['output'];
  adminId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  correctionType: CorrectionType;
  createdAt: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  newValue?: Maybe<Scalars['Float']['output']>;
  oldValue?: Maybe<Scalars['Float']['output']>;
  reason: Scalars['String']['output'];
  status: OrderStatus;
  user: User;
};

export type CorrectionOrdersResult = {
  __typename?: 'CorrectionOrdersResult';
  orders: Array<CorrectionOrder>;
  totalPages: Scalars['Int']['output'];
};

export type CorrectionResult = {
  __typename?: 'CorrectionResult';
  correctionAmount?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  withdrawalOrderId?: Maybe<Scalars['ID']['output']>;
};

export enum CorrectionType {
  BondInterestRecalc = 'BOND_INTEREST_RECALC',
  CashWithdrawal = 'CASH_WITHDRAWAL',
  HoldWithdrawal = 'HOLD_WITHDRAWAL',
  StockAdjustment = 'STOCK_ADJUSTMENT'
}

export enum Currency {
  Mnt = 'MNT',
  Usd = 'USD'
}

export type DailyAmount = {
  __typename?: 'DailyAmount';
  amount: Scalars['Float']['output'];
  date: Scalars['String']['output'];
};

export type DashboardData = {
  __typename?: 'DashboardData';
  bondInterestChartData: Array<DailyAmount>;
  depositChartData: Array<DailyAmount>;
  totalFee: Scalars['Float']['output'];
  totalInvestment: Scalars['Float']['output'];
  totalReadyToInvest: Scalars['Int']['output'];
  totalUser: Scalars['Int']['output'];
  totalValue: Scalars['Float']['output'];
  totalWaitingOrders: Scalars['Int']['output'];
  totalWithdrawal: Scalars['Float']['output'];
  withdrawalChartData: Array<DailyAmount>;
};

export type DateRange = {
  endDate: Scalars['Float']['input'];
  startDate: Scalars['Float']['input'];
};

export type DepositAccount = {
  __typename?: 'DepositAccount';
  accountName: Scalars['String']['output'];
  accountNo: Scalars['String']['output'];
  bank: DepositAccountBank;
  iBan?: Maybe<Scalars['String']['output']>;
  txDescriptionFormat: DepositTxDescriptionFormat;
};

export enum DepositAccountBank {
  Golomt = 'Golomt',
  Khaan = 'Khaan'
}

/** This is a bank account to place deposits. */
export type DepositInfo = {
  __typename?: 'DepositInfo';
  accountNumber: Scalars['String']['output'];
  txDescription: Scalars['String']['output'];
};

export enum DepositTxDescriptionFormat {
  /** Request tx description from `depositInfo` query */
  Automated = 'Automated',
  /** Show user phone number or email */
  Manual = 'Manual'
}

export type DispatchAccountCreationResult = {
  __typename?: 'DispatchAccountCreationResult';
  dispatched: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type DispatchMonthlyFeeResult = {
  __typename?: 'DispatchMonthlyFeeResult';
  batchId: Scalars['String']['output'];
  dispatched: Scalars['Int']['output'];
};

export type DividendPayout = {
  __typename?: 'DividendPayout';
  /** Stock amount owned by the user at the time of dividend record date. */
  amount: Scalars['Float']['output'];
  /** Stock dividend amount in USD. */
  dividend: Scalars['Float']['output'];
  user: User;
};

export type DividendReport = {
  __typename?: 'DividendReport';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payouts: Array<DividendPayout>;
  /** Record date of the dividend report as an ISO date string. */
  recordDate: Scalars['String']['output'];
  stock: Stock;
  /** Total dividend amount for all users in USD. */
  totalAmount: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum Duration {
  Long = 'LONG',
  Medium = 'MEDIUM',
  Short = 'SHORT'
}

export type EditActivityInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ActivityType>;
  users?: InputMaybe<Scalars['ID']['input']>;
};

export type EditBondInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** String in format of "1y 2m" */
  duration?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Float']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  localizedDescription?: InputMaybe<LocalizedStringInput>;
  localizedName?: InputMaybe<LocalizedStringInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentSchedules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type EditConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type EditDepositAccountInput = {
  accountName: Scalars['String']['input'];
  accountNo: Scalars['String']['input'];
  bank: DepositAccountBank;
  iBan?: InputMaybe<Scalars['String']['input']>;
  txDescriptionFormat: DepositTxDescriptionFormat;
};

export type EditFaqInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type EditImageInput = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type EditKycQuestionnaireInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  localizedDescription?: InputMaybe<LocalizedStringInput>;
  localizedName?: InputMaybe<LocalizedStringInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<KycQuestionnaireQuestionInput>>;
};

export type EditPortfolioBondInput = {
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type EditPortfolioInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bond: EditPortfolioBondInput;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Duration>;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  localizedDescription?: InputMaybe<LocalizedStringInput>;
  localizedName?: InputMaybe<LocalizedStringInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Scalars['Int']['input']>;
  saving: EditPortfolioSavingInput;
  stocks?: InputMaybe<Array<AddPortfolioStockInput>>;
};

export type EditPortfolioSavingInput = {
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type EditSavingInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  balance?: InputMaybe<Scalars['Float']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  /** String in format of "1y 2m" */
  duration?: InputMaybe<Scalars['String']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  localizedDescription?: InputMaybe<LocalizedStringInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type EditStockInput = {
  image?: InputMaybe<EditImageInput>;
  localizedDescription?: InputMaybe<LocalizedStringInput>;
  localizedName?: InputMaybe<LocalizedStringInput>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StockType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type EditSurveyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  completeText?: InputMaybe<Scalars['String']['input']>;
  introText?: InputMaybe<Scalars['String']['input']>;
  localizedCompleteText?: InputMaybe<LocalizedStringInput>;
  localizedIntroText?: InputMaybe<LocalizedStringInput>;
  localizedName?: InputMaybe<LocalizedStringInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<QuestionInput>>;
};

export type EditUserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  bankInfo?: InputMaybe<BankInfo>;
  birthDate?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  type?: InputMaybe<UserType>;
};

export type Faq = {
  __typename?: 'FAQ';
  _id?: Maybe<Scalars['ID']['output']>;
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type FileUploadData = {
  __typename?: 'FileUploadData';
  filePath: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FileUploadRequest = {
  mimeType: Scalars['String']['input'];
  originalName: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type FixMissingBankCodesResult = {
  __typename?: 'FixMissingBankCodesResult';
  fixed: Scalars['Int']['output'];
  notFound: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GetActivitiesResult = {
  __typename?: 'GetActivitiesResult';
  activities?: Maybe<Array<Activity>>;
  totalPages: Scalars['Int']['output'];
};

export type GetAvailableBalancesAdvancedInput = {
  isProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetAvailableBalancesOptionsInput = {
  pagination: Scalars['Boolean']['input'];
};

export type GetBalancesResult = {
  __typename?: 'GetBalancesResult';
  balances: Array<Balance>;
  totalPages: Scalars['Int']['output'];
};

export type GetBondsResult = {
  __typename?: 'GetBondsResult';
  bonds?: Maybe<Array<Bond>>;
  totalPages: Scalars['Int']['output'];
};

export type GetCorrectionOrdersInput = {
  correctionType?: InputMaybe<CorrectionType>;
  date?: InputMaybe<DateRange>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetGroupActivitiesResult = {
  __typename?: 'GetGroupActivitiesResult';
  groupActivities: Array<GroupActivity>;
  totalPages: Scalars['Int']['output'];
};

export type GetKyCsResult = {
  __typename?: 'GetKYCsResult';
  kycs?: Maybe<Array<Kyc>>;
  totalPages: Scalars['Int']['output'];
};

export type GetKycQuestionnaireSendsResult = {
  __typename?: 'GetKycQuestionnaireSendsResult';
  sends: Array<KycQuestionnaireSend>;
  totalPages: Scalars['Int']['output'];
};

export type GetKycQuestionnairesResult = {
  __typename?: 'GetKycQuestionnairesResult';
  questionnaires: Array<KycQuestionnaire>;
  totalPages: Scalars['Int']['output'];
};

export type GetOrderHistoryResult = {
  __typename?: 'GetOrderHistoryResult';
  orders?: Maybe<Array<Order>>;
  totalPages: Scalars['Int']['output'];
};

export type GetOrderListResult = {
  __typename?: 'GetOrderListResult';
  orderLists: Array<OrderList>;
  totalPages: Scalars['Int']['output'];
};

export type GetOrders = {
  date?: InputMaybe<DateRange>;
  search?: InputMaybe<Scalars['String']['input']>;
  status: OrderStatus;
};

export type GetPortfoliosResult = {
  __typename?: 'GetPortfoliosResult';
  portfolios?: Maybe<Array<Portfolio>>;
  totalPages: Scalars['Int']['output'];
};

export type GetRecommendedPortfoliosResult = {
  __typename?: 'GetRecommendedPortfoliosResult';
  portfolio: Portfolio;
  recommended: Scalars['Boolean']['output'];
};

export type GetSavingsResult = {
  __typename?: 'GetSavingsResult';
  savings?: Maybe<Array<Saving>>;
  totalPages: Scalars['Int']['output'];
};

export type GetStocksResult = {
  __typename?: 'GetStocksResult';
  stocks?: Maybe<Array<Stock>>;
  totalPages: Scalars['Int']['output'];
};

export type GetUserDeletionRequestResponse = {
  __typename?: 'GetUserDeletionRequestResponse';
  requests: Array<UserDeletionRequest>;
  totalPages: Scalars['Int']['output'];
};

export type GetUsersResult = {
  __typename?: 'GetUsersResult';
  totalPages: Scalars['Int']['output'];
  users?: Maybe<Array<User>>;
};

export type GroupActivity = {
  __typename?: 'GroupActivity';
  _id?: Maybe<Scalars['ID']['output']>;
  activities: Array<Activity>;
};

export enum HistoryType {
  Daily = 'DAILY',
  Purchase = 'PURCHASE'
}

export type HoldingItem = {
  __typename?: 'HoldingItem';
  assetId: Scalars['ID']['output'];
  assetName: Scalars['String']['output'];
  assetType: UserReportAssetType;
  currentValue: Scalars['Float']['output'];
  principleAmount: Scalars['Float']['output'];
  profitLoss: Scalars['Float']['output'];
  profitLossPercentage: Scalars['Float']['output'];
  purchaseDate: Scalars['Float']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type Image = {
  __typename?: 'Image';
  _id?: Maybe<Scalars['ID']['output']>;
  path: Scalars['String']['output'];
};

export type ImageListResult = {
  __typename?: 'ImageListResult';
  images?: Maybe<Array<Image>>;
  totalPages: Scalars['Int']['output'];
};

export type InfographicSummary = {
  __typename?: 'InfographicSummary';
  cashAmount: Scalars['Float']['output'];
  currentBalance: Scalars['Float']['output'];
  holdAmount: Scalars['Float']['output'];
  processingAmount: Scalars['Float']['output'];
  totalIncome: Scalars['Float']['output'];
  totalPurchases: Scalars['Float']['output'];
  totalReturns: Scalars['Float']['output'];
};

export type Kyc = {
  __typename?: 'KYC';
  _id?: Maybe<Scalars['ID']['output']>;
  address: Scalars['String']['output'];
  birthDate: Scalars['Float']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  info: UserKycInfo;
  registerNo: Scalars['String']['output'];
  taxPayerNo?: Maybe<Scalars['String']['output']>;
  user: User;
};

export enum KycDocumentType {
  Idcard = 'IDCARD',
  Passport = 'PASSPORT'
}

export enum KycQuestionType {
  Date = 'DATE',
  FileUpload = 'FILE_UPLOAD',
  FreeText = 'FREE_TEXT',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Number = 'NUMBER',
  SingleChoice = 'SINGLE_CHOICE'
}

export type KycQuestionnaire = {
  __typename?: 'KycQuestionnaire';
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Float']['output'];
  createdBy?: Maybe<User>;
  description: Scalars['String']['output'];
  localizedDescription?: Maybe<LocalizedString>;
  localizedName?: Maybe<LocalizedString>;
  name: Scalars['String']['output'];
  questions: Array<KycQuestionnaireQuestion>;
  updatedAt: Scalars['Float']['output'];
};

export type KycQuestionnaireAnswer = {
  __typename?: 'KycQuestionnaireAnswer';
  additionalText?: Maybe<Scalars['String']['output']>;
  dateValue?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  questionId: Scalars['ID']['output'];
  selectedOption?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<Scalars['String']['output']>>;
  textValue?: Maybe<Scalars['String']['output']>;
  type: KycQuestionType;
};

export type KycQuestionnaireAnswerInput = {
  additionalText?: InputMaybe<Scalars['String']['input']>;
  dateValue?: InputMaybe<Scalars['Float']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  questionId: Scalars['ID']['input'];
  selectedOption?: InputMaybe<Scalars['String']['input']>;
  selectedOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  textValue?: InputMaybe<Scalars['String']['input']>;
  type: KycQuestionType;
};

export type KycQuestionnaireChoiceOption = {
  __typename?: 'KycQuestionnaireChoiceOption';
  localizedValue?: Maybe<LocalizedString>;
  requiresInput?: Maybe<Scalars['Boolean']['output']>;
  triggersSubQuestions?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['String']['output'];
};

export type KycQuestionnaireChoiceOptionInput = {
  localizedValue: LocalizedStringInput;
  requiresInput?: InputMaybe<Scalars['Boolean']['input']>;
  triggersSubQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type KycQuestionnaireQuestion = {
  __typename?: 'KycQuestionnaireQuestion';
  _id: Scalars['ID']['output'];
  localizedQuestion?: Maybe<LocalizedString>;
  options?: Maybe<Array<KycQuestionnaireChoiceOption>>;
  order: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  subQuestions?: Maybe<Array<KycQuestionnaireQuestion>>;
  type: KycQuestionType;
};

export type KycQuestionnaireQuestionInput = {
  localizedQuestion: LocalizedStringInput;
  options?: InputMaybe<Array<KycQuestionnaireChoiceOptionInput>>;
  order: Scalars['Int']['input'];
  question: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  subQuestions?: InputMaybe<Array<KycQuestionnaireQuestionInput>>;
  type: KycQuestionType;
};

export type KycQuestionnaireResponse = {
  __typename?: 'KycQuestionnaireResponse';
  _id: Scalars['ID']['output'];
  answers: Array<KycQuestionnaireAnswer>;
  createdAt: Scalars['Float']['output'];
  questionnaire?: Maybe<KycQuestionnaire>;
  send: Scalars['ID']['output'];
  submittedAt: Scalars['Float']['output'];
  user?: Maybe<User>;
};

export type KycQuestionnaireSend = {
  __typename?: 'KycQuestionnaireSend';
  _id: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Float']['output'];
  expiresAt?: Maybe<Scalars['Float']['output']>;
  notificationSent: Scalars['Boolean']['output'];
  questionnaire?: Maybe<KycQuestionnaire>;
  response?: Maybe<KycQuestionnaireResponse>;
  sentAt: Scalars['Float']['output'];
  sentBy?: Maybe<User>;
  status: KycQuestionnaireSendStatus;
  updatedAt: Scalars['Float']['output'];
  user?: Maybe<User>;
};

export enum KycQuestionnaireSendStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type KycUserSegmentInput = {
  brokerAccountStatus?: InputMaybe<BrokerAccountStatus>;
  createdAfter?: InputMaybe<Scalars['Float']['input']>;
  createdBefore?: InputMaybe<Scalars['Float']['input']>;
  hasPurchases?: InputMaybe<Scalars['Boolean']['input']>;
  kycStatus?: InputMaybe<Status>;
  minBalance?: InputMaybe<Scalars['Float']['input']>;
  userType?: InputMaybe<UserType>;
};

export enum Locale {
  En = 'en',
  Mn = 'mn'
}

export type LocalizedString = {
  __typename?: 'LocalizedString';
  en?: Maybe<Scalars['String']['output']>;
  mn?: Maybe<Scalars['String']['output']>;
};

export type LocalizedStringInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  mn?: InputMaybe<Scalars['String']['input']>;
};

/** Internal MSCD account record with creation status and error info. */
export type MscdAccountInfo = {
  __typename?: 'MSCDAccountInfo';
  _id: Scalars['ID']['output'];
  accountNo: Scalars['String']['output'];
  accountSequentialId: Scalars['Int']['output'];
  attemptCount: Scalars['Int']['output'];
  createdAt: Scalars['Float']['output'];
  lastAttemptAt?: Maybe<Scalars['Float']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  /** MSCD талын алдааны мэдээлэл */
  mscdErrorMessage?: Maybe<Scalars['String']['output']>;
  /** MSCD талын данс нээлтийн төлөв. 0=нээгдээгүй, 1=нээгдсэн, 2=алдаа, null=мэдээлэл байхгүй */
  mscdStatus?: Maybe<Scalars['String']['output']>;
  status: BrokerAccountStatus;
  updatedAt: Scalars['Float']['output'];
};

export type MscdApiAccount = {
  __typename?: 'MSCDApiAccount';
  _id: Scalars['ID']['output'];
  accountNumber: Scalars['String']['output'];
  bdcAccountId: Scalars['String']['output'];
  bdcId: Scalars['String']['output'];
  clientSuffix: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  customerType: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mitPrefix: Scalars['String']['output'];
  msxAccountId: Scalars['String']['output'];
  registryNumber: Scalars['String']['output'];
  syncedAt: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
};

export type MscdApiAccountFilterInput = {
  bdcAccountId?: InputMaybe<Scalars['String']['input']>;
  registryNumber?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MscdApiAccountsResult = {
  __typename?: 'MSCDApiAccountsResult';
  accounts: Array<MscdApiAccount>;
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type MscdErrorAccount = {
  __typename?: 'MSCDErrorAccount';
  BDCAccountId: Scalars['String']['output'];
  BDCAccountNumber: Scalars['Int']['output'];
  BankAccountNumber?: Maybe<Scalars['Float']['output']>;
  BankCode?: Maybe<Scalars['String']['output']>;
  BankName?: Maybe<Scalars['String']['output']>;
  BirthDate?: Maybe<Scalars['String']['output']>;
  CheckStatus?: Maybe<Scalars['Int']['output']>;
  ErrorMessage?: Maybe<Scalars['String']['output']>;
  FirstName: Scalars['String']['output'];
  Gender?: Maybe<Scalars['String']['output']>;
  HomeAddress?: Maybe<Scalars['String']['output']>;
  HomePhone?: Maybe<Scalars['String']['output']>;
  LastName: Scalars['String']['output'];
  MobilePhone?: Maybe<Scalars['String']['output']>;
  Occupation?: Maybe<Scalars['String']['output']>;
  /** MCSD талын мэдээлэл (API-аас шууд ирсэн) */
  PkId: Scalars['Int']['output'];
  RecievedDate?: Maybe<Scalars['String']['output']>;
  RegistryNumber: Scalars['String']['output'];
  Status: Scalars['Int']['output'];
  localAccountNo?: Maybe<Scalars['String']['output']>;
  localBankAccountNo?: Maybe<Scalars['String']['output']>;
  localBankCode?: Maybe<Scalars['String']['output']>;
  localBankName?: Maybe<Scalars['String']['output']>;
  localBirthDate?: Maybe<Scalars['String']['output']>;
  localFirstName?: Maybe<Scalars['String']['output']>;
  localGender?: Maybe<Scalars['String']['output']>;
  localHomeAddress?: Maybe<Scalars['String']['output']>;
  localLastName?: Maybe<Scalars['String']['output']>;
  localOccupation?: Maybe<Scalars['String']['output']>;
  localPhoneNo?: Maybe<Scalars['String']['output']>;
  localRegisterNo?: Maybe<Scalars['String']['output']>;
  /** Манай DB дээрх мэдээлэл (match хийгдсэн бол) */
  localUserId?: Maybe<Scalars['ID']['output']>;
};

export type MscdLinkCandidate = {
  __typename?: 'MSCDLinkCandidate';
  email?: Maybe<Scalars['String']['output']>;
  /** Existing MSCDAccount accountNo if already linked */
  existingAccountNo?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** How the user was found: "bdcAccountId", "bdcAccountNumber", "phoneNo", "registerNo" */
  matchedBy: Scalars['String']['output'];
  phoneNo?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type MonthlyFeeError = {
  __typename?: 'MonthlyFeeError';
  error: Scalars['String']['output'];
  purchaseId: Scalars['String']['output'];
};

export type MonthlyFeeResult = {
  __typename?: 'MonthlyFeeResult';
  errors: Array<MonthlyFeeError>;
  processedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  totalFeeAmount: Scalars['Float']['output'];
};

export enum MscdAccountFilter {
  /** Users who have an MSCD account created */
  HasAccount = 'HAS_ACCOUNT',
  /** Users who have an MSCD account with an error (lastError is not null) */
  HasError = 'HAS_ERROR',
  /** Users who have deposits but no MSCD account (eligible for account creation) */
  ShouldCreateAccount = 'SHOULD_CREATE_ACCOUNT'
}

export type Mutation = {
  __typename?: 'Mutation';
  addActivity: Scalars['Boolean']['output'];
  addBond: Scalars['Boolean']['output'];
  addConfig: Scalars['Boolean']['output'];
  addDepositAccount: Scalars['Boolean']['output'];
  addFaq: Scalars['Boolean']['output'];
  /** @deprecated This mutation is not used anymore */
  addImage: Scalars['Boolean']['output'];
  addKycQuestionnaire: Scalars['Boolean']['output'];
  addOrder: Scalars['Boolean']['output'];
  addPortfolio: Scalars['Boolean']['output'];
  addPreviousPurchase: Scalars['Boolean']['output'];
  addSaving: Scalars['Boolean']['output'];
  addStock: Scalars['Boolean']['output'];
  addSuggestion: Scalars['Boolean']['output'];
  addSurvey: Scalars['Boolean']['output'];
  addUser: Scalars['Boolean']['output'];
  applyFees?: Maybe<Scalars['Boolean']['output']>;
  /** Apply monthly fees for a single user's purchases. */
  applyMonthlyFeesForUser: MonthlyFeeResult;
  /**
   * Excel файлаар олон хэрэглэгчийг нэг дор цэнэглэх.
   * confirm=false бол dry-run (preview), confirm=true бол бодит цэнэглэлт.
   * 300 мөрөөс илүү байвал алдаа өгнө. Нэг ч мөр алдаатай бол бүгд татгалзана.
   */
  bulkAddOrder: BulkAddOrderResult;
  cancelWithdrawalOrderList: Scalars['Boolean']['output'];
  cancelWithdrawalRequest: Scalars['Boolean']['output'];
  changePortfolio: Scalars['Boolean']['output'];
  choosePortfolio: Scalars['Boolean']['output'];
  completeWithdrawalRequestsTransfer: WithdrawalRequestsConfirmationResult;
  confirmOrderList: Scalars['Boolean']['output'];
  /**
   * Confirm new Webauthn device registration.
   * Uses name of Webauthn device and Webauthn response.
   * Returns whether if token is registered properly.
   */
  confirmWebauthnDeviceRegistration: Scalars['Boolean']['output'];
  confirmWithdrawalOrderList: Scalars['Boolean']['output'];
  /** Бондын хүү дахин тооцоолж залруулга хийх */
  correctBondInterest: CorrectionResult;
  /** Бэлэн мөнгө / Худалдан авалтаас үлдсэн дүнгээс зарлага хийх залруулга */
  correctCashWithdrawal: CorrectionResult;
  /** Хувьцааны position засах залруулга */
  correctStockPosition: CorrectionResult;
  /**
   * Create account invoice. Must be called only if broker account request is created.
   * Returns QPay invoice data only if corresponding payment method is chosen.
   */
  createBrokerAccountInvoice: AccountInvoice;
  createOrderList: Scalars['Boolean']['output'];
  createWithdrawalOrderList: Scalars['Boolean']['output'];
  createWithdrawalRequest: Scalars['ID']['output'];
  deleteActivity: Scalars['Boolean']['output'];
  deleteBond: Scalars['Boolean']['output'];
  deleteConfig: Scalars['Boolean']['output'];
  deleteContract: Scalars['Boolean']['output'];
  deleteDepositAccount: Scalars['Boolean']['output'];
  deleteFaq: Scalars['Boolean']['output'];
  deleteGroupActivity: Scalars['Boolean']['output'];
  /** @deprecated This mutation is not used anymore */
  deleteImage: Scalars['Boolean']['output'];
  deleteKYC: Scalars['Boolean']['output'];
  deleteKycQuestionnaire: Scalars['Boolean']['output'];
  deletePortfolio: Scalars['Boolean']['output'];
  deleteSaving: Scalars['Boolean']['output'];
  deleteStock: Scalars['Boolean']['output'];
  deleteSuggestion: Scalars['Boolean']['output'];
  deleteSurvey: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  dismissUnmatchedDeposit: Scalars['Boolean']['output'];
  /**
   * Dispatch MSCD account creation for users who have deposits but no MSCD account.
   * startDate: Only include orders created on or after this date (timestamp in ms)
   */
  dispatchAccountCreationForDepositors: DispatchAccountCreationResult;
  /**
   * Dispatch monthly fee tasks via Cloud Tasks for all eligible users.
   * Returns immediately after dispatching tasks.
   */
  dispatchMonthlyFees: DispatchMonthlyFeeResult;
  /**
   * Distribute dividends to all users who own the stock at the time of record date.
   * recordDate must be in format 'YYYY-MM-DD'.
   */
  distributeDividends: PrepareReportResult;
  downloadFeeReport: PrepareReportResult;
  downloadInterestPayoutReport: PrepareReportResult;
  /** Download user's withdrawal requests and confirmations as Excel file. */
  downloadUserWithdrawals: Scalars['String']['output'];
  downloadWithdrawalConfirmationReport: Scalars['String']['output'];
  downloadWithdrawalPreReport: Scalars['String']['output'];
  editActivity: Scalars['Boolean']['output'];
  editBond: Scalars['Boolean']['output'];
  editConfig: Scalars['Boolean']['output'];
  editDepositAccount: Scalars['Boolean']['output'];
  editFaq: Scalars['Boolean']['output'];
  editKYC: Scalars['Boolean']['output'];
  editKycQuestionnaire: Scalars['Boolean']['output'];
  editPortfolio: Scalars['Boolean']['output'];
  editSaving: Scalars['Boolean']['output'];
  editStock: Scalars['Boolean']['output'];
  editSurvey: Scalars['Boolean']['output'];
  editUser: Scalars['Boolean']['output'];
  editUserPortfolio: Scalars['Boolean']['output'];
  /**
   * Create hold release report for specific date range.
   * startDate and endDate are inclusive and must be in format YYYYMMDD.
   */
  exportBalanceUnholdReport: PrepareReportResult;
  /** Бүх хэрэглэгчдийн бонд худалдан авалтын задаргаа Excel тайлан */
  exportBondPurchaseReport: PrepareReportResult;
  /** Export client report - харилцагчид өгөх энгийн 1 хуудас PDF тайлан */
  exportClientReport: PrepareReportResult;
  /** Залруулгын тайлан Excel-ээр export хийх */
  exportCorrectionReport: PrepareReportResult;
  exportFeeReport: PrepareReportResult;
  exportFeeReportDetails: PrepareReportResult;
  /**
   * Create fee report for specific date range.
   * startDate and endDate are inclusive and must be in format YYYYMMDD.
   */
  exportFeeReportForDateRange: PrepareReportResult;
  exportInterestPayoutReport: PrepareReportResult;
  /**
   * Create interest payout report for specific date range.
   * startDate and endDate are inclusive and must be in format YYYYMMDD.
   */
  exportInterestPayoutReportForDateRange: PrepareReportResult;
  exportMSCDApiAccountsExcel: PrepareReportResult;
  /** Export infographic report for the authenticated user */
  exportMyInfographicReport: PrepareReportResult;
  /** Export portfolio report for the authenticated user */
  exportMyPortfolioReport: PrepareReportResult;
  /** Export purchase report for the authenticated user */
  exportMyPurchaseReport: PrepareReportResult;
  /**
   * ҮЦТХТ-д нээгдсэн данстай харилцагчдыг "Харилцагчийн мэдээлэл" загвараар,
   * KYC асуумжийн хариултын хамт Excel болгон экспортлох.
   */
  exportSecuritiesCustomersExcel: PrepareReportResult;
  /** Export detailed user report (гараар хийдэгтэй ижил формат Excel) */
  exportUserDetailedReport: PrepareReportResult;
  /**
   * Export detailed user report V2 - 4 хуудастай Excel тайлан
   * (Идэвхтэй хөрөнгө, Худалдан авалтын задаргаа, Бондын дахин худалдан авалт, Хувьцаа зарсан мөнгө)
   */
  exportUserDetailedReportV2: PrepareReportResult;
  /** Export infographic data to Excel for a specific user (Admin/Operator) */
  exportUserInfographicReport: PrepareReportResult;
  /** Export portfolio report to Excel for a specific user (Admin/Operator) */
  exportUserPortfolioReport: PrepareReportResult;
  /** Export purchase report to Excel for a specific user (Admin/Operator) */
  exportUserPurchaseReport: PrepareReportResult;
  /**
   * Update user info for MSCD error correction, then retry UpdateAccounts.
   * Only updates provided (non-null) fields.
   */
  fixAndRetryMSCDAccount: Scalars['Boolean']['output'];
  /**
   * Fix MSCDAccount.accountNo by looking up the correct BDCAccountId
   * from MCSD error accounts (matched by BDCAccountNumber / accountSequentialId).
   */
  fixMSCDAccountNo: Scalars['String']['output'];
  /** Fix missing bank codes for users by looking up bank name in the bank list. */
  fixMissingBankCodes: FixMissingBankCodesResult;
  /** Хэрэглэгчийг хөлдөөх. Шинэ захиалгад оруулахгүй болно. */
  freezeUser: Scalars['Boolean']['output'];
  /**
   * Enqueue an xlsx export of all balances. Returns the task immediately;
   * the heavy lifting runs in a Cloud Tasks worker so the GraphQL request
   * is not held open for minutes. Poll balanceExportTask(taskId) for status.
   */
  generateBalancesDetail: BalanceExportTask;
  generateOrderListDetail: Scalars['String']['output'];
  generateOrderListDetailPerUser: Scalars['String']['output'];
  generateOrderListOrders: Scalars['String']['output'];
  /** This mutation must be used only for testing purposes. */
  internal__createMSCDAccount: Scalars['Boolean']['output'];
  /**
   * Link an unmatched MSCD error account to a local user (DB only, does NOT send to MSCD).
   * Returns the matched userId so the UI can show linked status.
   */
  linkMSCDErrorAccount: Scalars['Boolean']['output'];
  login: Auth;
  logout: Scalars['Boolean']['output'];
  matchUnmatchedDeposit: Scalars['Boolean']['output'];
  payoutPathInterest: Scalars['Boolean']['output'];
  /**
   * Prepare dividend report for a stock. recordDate must be in format 'YYYY-MM-DD'.
   *
   * Call this mutation to prepare a dividend report for a stock.
   * Calculate total dividend amount to call `distributeDividends` mutation.
   */
  prepareDividendReport: PrepareReportResult;
  prepareInterestPayoutReport: PrepareReportResult;
  prepareOrderList: PrepareOrderListResult;
  prepareTest: Scalars['Boolean']['output'];
  /** Бондын хүү дахин тооцоолох preview */
  previewBondInterestRecalc: BondInterestRecalcPreview;
  /** Proceed with KYC verification via DAN. Should be called with the OAuth2 authorization code and state parameter. */
  proceedKYCVerificationViaDAN: Scalars['Boolean']['output'];
  recoverOtp: Scalars['Boolean']['output'];
  /**
   * Regenerate Excel file for an existing OrderList.
   * Returns a signed download URL.
   */
  regenerateOrderListFile: Scalars['String']['output'];
  releaseHoldAmount: Scalars['Boolean']['output'];
  /**
   * Release hold amount for every purchase belonging to the given order list.
   * Returns the number of purchases that were released.
   */
  releaseHoldAmountForOrderList: Scalars['Int']['output'];
  removeOrder: Scalars['Boolean']['output'];
  /** Request an avatar upload URL. Note that the URL is valid for 15 minutes. */
  requestAvatarUpload: FileUploadData;
  /**
   * Request a URL to upload a contract. Can be used either to upload a new contract or to update an existing one.
   * signatureImageName is the name of the image that will be used as a signature. It must exist inside the document.
   */
  requestContractUpload: Scalars['String']['output'];
  requestDeleteUser: RequestDeleteUserResponse;
  /**
   * Request presigned URLs to upload KYC documents.
   * The response will be an array of URLs that can be used for an upload.
   *
   * WARNING: This mutation will clear all previous KYC uploads for the user.
   */
  requestDocumentUpload: Array<FileUploadData>;
  /**
   * Request KYC verification via DAN (https://developer.sso.gov.mn/).
   * Returns a URL that can be used to redirect the user to the DAN system.
   */
  requestKYCVerificationViaDAN: Scalars['String']['output'];
  requestKycQuestionnaireFileUpload: FileUploadData;
  requestOtp: RequestOtpResult;
  /**
   * Request a presigned URL to upload selfie with a document for the KYC.
   * The response will be an URL that can be used for an upload.
   */
  requestSelfieUpload: FileUploadData;
  resendKycQuestionnaire: Scalars['Boolean']['output'];
  resetBalance: Scalars['Boolean']['output'];
  resolveAccountPostPaymentInvoices: PrepareReportResult;
  /** Restore reset balance. Requires new balance to be empty. */
  restoreBalance: Scalars['Boolean']['output'];
  /** Retry MSCD account creation for a user. Deletes the existing MSCDAccount and re-sends the request. */
  retryMSCDAccountCreation: Scalars['Boolean']['output'];
  returnCreateOrderList: Scalars['Boolean']['output'];
  /**
   * Create a withdrawal order. Use `amount` parameter to create a partial withdrawal.
   * Returns full amount if `amount` is not specified.
   */
  returnOrder: Scalars['Boolean']['output'];
  /**
   * Buts Bulk цэнэглэлтийн амжилттай row-ыг буцаах (removeOrder ашиглана).
   * Зөвхөн Done эсвэл DoneWithFailures status-тай batch-д хэрэглэгдэнэ.
   */
  revertBulkAddOrderBatch: BulkAddOrderBatch;
  /** Deactivate fee withdrawal transaction, remove corresponding fee report and add the amount to holdAmount. */
  revertFeeWithdrawal: Scalars['Boolean']['output'];
  sendActivity: Scalars['Boolean']['output'];
  sendGroupActivity: Scalars['Boolean']['output'];
  sendKycQuestionnaireToAllUnresponded: Scalars['Int']['output'];
  sendKycQuestionnaireToSegment: Scalars['Boolean']['output'];
  sendKycQuestionnaireToUser: Scalars['Boolean']['output'];
  /** Create a broker account request. Must be called if user has no pending requests. */
  submitBrokerAccountRequest: Scalars['Boolean']['output'];
  /** Нэг гэрээнд гарын үсэг зурах. Гэрээ бүрт тусдаа дуудна. */
  submitContractSignature: Scalars['Boolean']['output'];
  /** @deprecated Use submitContractSignature instead */
  submitContractsSignature: Scalars['Boolean']['output'];
  submitFCMToken: Scalars['Boolean']['output'];
  submitInstallationAuthToken: Scalars['Boolean']['output'];
  /** Submit new KYC request */
  submitKYC: Scalars['ID']['output'];
  /**
   * In some cases, users are not able to submit KYC by themselves. In this case,
   * admins or operators can use this query to submit KYC for that individual.
   */
  submitKYCForUser: Scalars['ID']['output'];
  submitKycQuestionnaireResponse: Scalars['Boolean']['output'];
  submitSurvey: SubmitSurveyResult;
  syncMSCDAccounts: SyncMscdAccountsResult;
  /**
   * Sync error accounts from MCSD REST API (api.mcsd.mn:1280/getErrorAccounts).
   * Updates MSCDAccount records with error information from MCSD.
   */
  syncMSCDErrorAccounts: SyncMscdErrorAccountsResult;
  /**
   * Бүх гэрээтэй хэрэглэгчдийн contractDate-г цэвэрлэж,
   * дахин гарын үсэг зурах шаардлагатай болгоно.
   * Нөлөөлсөн хэрэглэгчдийн тоог буцаана.
   */
  triggerRecontract: Scalars['Int']['output'];
  /** Хэрэглэгчийн хөлдөөлтийг цуцлах. */
  unfreezeUser: Scalars['Boolean']['output'];
  /** Update KYC request by ID and */
  updateKYC: Scalars['Boolean']['output'];
  /** Manually update MSCDAccount.accountNo (BDCAccountId) for a user. */
  updateMSCDAccountNo: Scalars['Boolean']['output'];
  updateUserBankInfo: Scalars['Boolean']['output'];
  /** This is a no-op mutation */
  version: Scalars['String']['output'];
  /**
   * Send Webauthn challenge response.
   * Returns authentication data.
   */
  webauthnLogin: Auth;
};


export type MutationAddActivityArgs = {
  activity: AddActivityInput;
};


export type MutationAddBondArgs = {
  bond: AddBondInput;
};


export type MutationAddConfigArgs = {
  config: AddConfigInput;
};


export type MutationAddDepositAccountArgs = {
  depositAccount: AddDepositAccountInput;
};


export type MutationAddFaqArgs = {
  faq: AddFaqInput;
};


export type MutationAddImageArgs = {
  image: AddImageInput;
};


export type MutationAddKycQuestionnaireArgs = {
  input: AddKycQuestionnaireInput;
};


export type MutationAddOrderArgs = {
  order: AddOrderInput;
};


export type MutationAddPortfolioArgs = {
  portfolio: AddPortfolioInput;
};


export type MutationAddPreviousPurchaseArgs = {
  currentPurchaseId: Scalars['ID']['input'];
  previousPurchaseId: Scalars['ID']['input'];
};


export type MutationAddSavingArgs = {
  saving: AddSavingInput;
};


export type MutationAddStockArgs = {
  stock: AddStockInput;
};


export type MutationAddSuggestionArgs = {
  suggestion: AddSuggestionInput;
};


export type MutationAddSurveyArgs = {
  survey: AddSurveyInput;
};


export type MutationAddUserArgs = {
  user: AddUserInput;
};


export type MutationApplyFeesArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationApplyMonthlyFeesForUserArgs = {
  month: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type MutationBulkAddOrderArgs = {
  input: BulkAddOrderInput;
};


export type MutationCancelWithdrawalOrderListArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelWithdrawalRequestArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationChangePortfolioArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationChoosePortfolioArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationCompleteWithdrawalRequestsTransferArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationConfirmOrderListArgs = {
  _id: Scalars['ID']['input'];
  totalPurchases: AddPurchasesInput;
};


export type MutationConfirmWebauthnDeviceRegistrationArgs = {
  name: Scalars['String']['input'];
  response: Scalars['String']['input'];
};


export type MutationConfirmWithdrawalOrderListArgs = {
  confirmationData: WithdrawalConfirmationData;
  id: Scalars['ID']['input'];
};


export type MutationCorrectBondInterestArgs = {
  input: BondInterestRecalcInput;
};


export type MutationCorrectCashWithdrawalArgs = {
  input: CashCorrectionInput;
};


export type MutationCorrectStockPositionArgs = {
  input: StockAdjustmentInput;
};


export type MutationCreateBrokerAccountInvoiceArgs = {
  paymentMethod: AccountInvoicePaymentMethod;
};


export type MutationCreateOrderListArgs = {
  balances: Array<Scalars['ID']['input']>;
  usdRate: Scalars['Float']['input'];
};


export type MutationCreateWithdrawalOrderListArgs = {
  withdrawalRequestIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateWithdrawalRequestArgs = {
  request: WithdrawalRequestInput;
};


export type MutationDeleteActivityArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteBondArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteConfigArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteContractArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteDepositAccountArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteFaqArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteGroupActivityArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteImageArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteKycArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteKycQuestionnaireArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeletePortfolioArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteSavingArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteStockArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteSuggestionArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteSurveyArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDismissUnmatchedDepositArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDispatchAccountCreationForDepositorsArgs = {
  startDate?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationDispatchMonthlyFeesArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationDistributeDividendsArgs = {
  dividend: Scalars['Float']['input'];
  expectedTotalDividend: Scalars['Float']['input'];
  recordDate: Scalars['String']['input'];
  stockId: Scalars['ID']['input'];
};


export type MutationDownloadFeeReportArgs = {
  batchId: Scalars['String']['input'];
};


export type MutationDownloadInterestPayoutReportArgs = {
  batchId: Scalars['String']['input'];
};


export type MutationDownloadUserWithdrawalsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDownloadWithdrawalConfirmationReportArgs = {
  orderListId: Scalars['ID']['input'];
};


export type MutationDownloadWithdrawalPreReportArgs = {
  orderListId: Scalars['ID']['input'];
};


export type MutationEditActivityArgs = {
  _id: Scalars['ID']['input'];
  activity: EditActivityInput;
};


export type MutationEditBondArgs = {
  _id: Scalars['ID']['input'];
  bond: EditBondInput;
};


export type MutationEditConfigArgs = {
  _id: Scalars['ID']['input'];
  config: EditConfigInput;
};


export type MutationEditDepositAccountArgs = {
  _id: Scalars['ID']['input'];
  depositAccount: AddDepositAccountInput;
};


export type MutationEditFaqArgs = {
  _id: Scalars['ID']['input'];
  faq: EditFaqInput;
};


export type MutationEditKycArgs = {
  _id: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  status: Status;
};


export type MutationEditKycQuestionnaireArgs = {
  _id: Scalars['ID']['input'];
  input: EditKycQuestionnaireInput;
};


export type MutationEditPortfolioArgs = {
  _id: Scalars['ID']['input'];
  portfolio: EditPortfolioInput;
};


export type MutationEditSavingArgs = {
  _id: Scalars['ID']['input'];
  saving: EditSavingInput;
};


export type MutationEditStockArgs = {
  _id: Scalars['ID']['input'];
  stock: EditStockInput;
};


export type MutationEditSurveyArgs = {
  _id: Scalars['ID']['input'];
  survey: EditSurveyInput;
};


export type MutationEditUserArgs = {
  _id: Scalars['ID']['input'];
  user: EditUserInput;
};


export type MutationEditUserPortfolioArgs = {
  _id: Scalars['ID']['input'];
  portfolioId: Scalars['ID']['input'];
};


export type MutationExportBalanceUnholdReportArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationExportClientReportArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationExportCorrectionReportArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportFeeReportArgs = {
  batchId: Scalars['String']['input'];
};


export type MutationExportFeeReportDetailsArgs = {
  batchId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationExportFeeReportForDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportInterestPayoutReportArgs = {
  batchId: Scalars['String']['input'];
};


export type MutationExportInterestPayoutReportForDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationExportMyInfographicReportArgs = {
  dateRange?: InputMaybe<UserReportDateRange>;
};


export type MutationExportMyPurchaseReportArgs = {
  dateRange?: InputMaybe<UserReportDateRange>;
};


export type MutationExportUserDetailedReportArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationExportUserDetailedReportV2Args = {
  userId: Scalars['ID']['input'];
};


export type MutationExportUserInfographicReportArgs = {
  dateRange?: InputMaybe<UserReportDateRange>;
  userId: Scalars['ID']['input'];
};


export type MutationExportUserPortfolioReportArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationExportUserPurchaseReportArgs = {
  dateRange?: InputMaybe<UserReportDateRange>;
  userId: Scalars['ID']['input'];
};


export type MutationFixAndRetryMscdAccountArgs = {
  bankAccountNo?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationFixMscdAccountNoArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationFreezeUserArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationGenerateBalancesDetailArgs = {
  withMnt?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationGenerateOrderListDetailArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationGenerateOrderListDetailPerUserArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationGenerateOrderListOrdersArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationInternal__CreateMscdAccountArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationLinkMscdErrorAccountArgs = {
  bdcAccountId: Scalars['String']['input'];
  bdcAccountNumber: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  challenge?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
};


export type MutationMatchUnmatchedDepositArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationPayoutPathInterestArgs = {
  batchId: Scalars['String']['input'];
  bondId: Scalars['String']['input'];
};


export type MutationPrepareDividendReportArgs = {
  dividend: Scalars['Float']['input'];
  recordDate: Scalars['String']['input'];
  stockId: Scalars['ID']['input'];
};


export type MutationPrepareInterestPayoutReportArgs = {
  closeDate: Scalars['String']['input'];
};


export type MutationPrepareOrderListArgs = {
  balances: Array<Scalars['ID']['input']>;
};


export type MutationPrepareTestArgs = {
  balances: Array<Scalars['Float']['input']>;
  phoneNumbers: Array<Scalars['String']['input']>;
  portfolios: Array<Scalars['Int']['input']>;
};


export type MutationPreviewBondInterestRecalcArgs = {
  input: BondInterestRecalcInput;
};


export type MutationProceedKycVerificationViaDanArgs = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationRecoverOtpArgs = {
  username: Scalars['String']['input'];
};


export type MutationRegenerateOrderListFileArgs = {
  orderListId: Scalars['ID']['input'];
};


export type MutationReleaseHoldAmountArgs = {
  purchaseId: Scalars['ID']['input'];
};


export type MutationReleaseHoldAmountForOrderListArgs = {
  orderListId: Scalars['ID']['input'];
};


export type MutationRemoveOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestAvatarUploadArgs = {
  file: FileUploadRequest;
};


export type MutationRequestContractUploadArgs = {
  name: Scalars['String']['input'];
  portfolioId?: InputMaybe<Scalars['ID']['input']>;
  signatureImageName: Scalars['String']['input'];
};


export type MutationRequestDocumentUploadArgs = {
  documentType: KycDocumentType;
  files: Array<FileUploadRequest>;
};


export type MutationRequestKycQuestionnaireFileUploadArgs = {
  file: FileUploadRequest;
  questionId: Scalars['ID']['input'];
  sendId: Scalars['ID']['input'];
};


export type MutationRequestOtpArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  phoneNo: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestSelfieUploadArgs = {
  file: FileUploadRequest;
};


export type MutationResendKycQuestionnaireArgs = {
  sendId: Scalars['ID']['input'];
};


export type MutationResetBalanceArgs = {
  user: Scalars['ID']['input'];
};


export type MutationRestoreBalanceArgs = {
  user: Scalars['ID']['input'];
};


export type MutationRetryMscdAccountCreationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationReturnOrderArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRevertBulkAddOrderBatchArgs = {
  batchId: Scalars['ID']['input'];
};


export type MutationRevertFeeWithdrawalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendActivityArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationSendGroupActivityArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationSendKycQuestionnaireToAllUnrespondedArgs = {
  questionnaireId: Scalars['ID']['input'];
};


export type MutationSendKycQuestionnaireToSegmentArgs = {
  questionnaireId: Scalars['ID']['input'];
  segment: KycUserSegmentInput;
};


export type MutationSendKycQuestionnaireToUserArgs = {
  questionnaireId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSubmitBrokerAccountRequestArgs = {
  request: BrokerAccountRequest;
};


export type MutationSubmitContractSignatureArgs = {
  contractName: Scalars['String']['input'];
  dataUrl: Scalars['String']['input'];
};


export type MutationSubmitContractsSignatureArgs = {
  dataUrl: Scalars['String']['input'];
};


export type MutationSubmitFcmTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationSubmitInstallationAuthTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationSubmitKycArgs = {
  kyc: SubmitKycInput;
};


export type MutationSubmitKycForUserArgs = {
  kyc: SubmitKycInput;
  userId: Scalars['ID']['input'];
};


export type MutationSubmitKycQuestionnaireResponseArgs = {
  answers: Array<KycQuestionnaireAnswerInput>;
  sendId: Scalars['ID']['input'];
};


export type MutationSubmitSurveyArgs = {
  _id: Scalars['ID']['input'];
  answers: Array<Scalars['String']['input']>;
};


export type MutationSyncMscdAccountsArgs = {
  beginDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncMscdErrorAccountsArgs = {
  beginDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
};


export type MutationUnfreezeUserArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationUpdateKycArgs = {
  kyc: UpdateKycInput;
};


export type MutationUpdateMscdAccountNoArgs = {
  accountNo: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserBankInfoArgs = {
  _id: Scalars['ID']['input'];
  bankInfo: BankInfo;
};


export type MutationWebauthnLoginArgs = {
  challengeResponse: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type Order = {
  __typename?: 'Order';
  _id?: Maybe<Scalars['ID']['output']>;
  afterBalance: Scalars['Float']['output'];
  amount: Scalars['Float']['output'];
  beforeBalance: Scalars['Float']['output'];
  createdAt: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  isDeletable: Scalars['Boolean']['output'];
  isReturnable: Scalars['Boolean']['output'];
  status: OrderStatus;
  type: OrderType;
  updatedAt?: Maybe<Scalars['Float']['output']>;
  user: User;
};

export type OrderList = {
  __typename?: 'OrderList';
  _id?: Maybe<Scalars['ID']['output']>;
  balances: Array<Balance>;
  createdAt: Scalars['Float']['output'];
  /** @deprecated Use fileUrl field */
  filePath?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  index: Scalars['String']['output'];
  purchases?: Maybe<Array<Purchase>>;
  status: OrderListStatus;
  totalPurchases: TotalPurchases;
  type?: Maybe<PurchaseType>;
  updatedAt?: Maybe<Scalars['Float']['output']>;
};

export enum OrderListStatus {
  Done = 'DONE',
  Inprogress = 'INPROGRESS'
}

export type OrderListStock = {
  __typename?: 'OrderListStock';
  cashAmount: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  stock: Stock;
  totalAmount: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  usdRate: Scalars['Float']['output'];
};

export type OrderListSummary = {
  __typename?: 'OrderListSummary';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  index: Scalars['String']['output'];
  status: OrderListStatus;
  /** Total number of purchases included in the specific order list. */
  totalPurchases: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum OrderStatus {
  /** Order is confirmed and user's balance was updated accordingly. */
  Confirmed = 'CONFIRMED',
  /** Order is awaiting confirmation from operator or admin. */
  Pending = 'PENDING',
  /** Order is processed and was included in order list. */
  Processed = 'PROCESSED',
  Rejected = 'REJECTED'
}

export enum OrderType {
  Income = 'INCOME',
  Withdrawal = 'WITHDRAWAL'
}

export type PaginatedDividendReports = {
  __typename?: 'PaginatedDividendReports';
  reports: Array<DividendReport>;
  totalPages: Scalars['Int']['output'];
};

export type PaginatedOrderListSummary = {
  __typename?: 'PaginatedOrderListSummary';
  orderLists: Array<OrderListSummary>;
  totalPages: Scalars['Int']['output'];
};

export type PendingWithdrawalRequest = {
  __typename?: 'PendingWithdrawalRequest';
  _id: Scalars['ID']['output'];
  portfolioIndex: Scalars['Int']['output'];
  username: Scalars['String']['output'];
  withdrawalType?: Maybe<WithdrawalType>;
};

export type PendingWithdrawalRequestList = {
  __typename?: 'PendingWithdrawalRequestList';
  requests: Array<PendingWithdrawalRequest>;
  totalItems: Scalars['Int']['output'];
};

export type PerformanceMetrics = {
  __typename?: 'PerformanceMetrics';
  bondsPerformance: AssetPerformance;
  currentValue: Scalars['Float']['output'];
  overallROI: Scalars['Float']['output'];
  savingsPerformance: AssetPerformance;
  stocksPerformance: AssetPerformance;
  totalInvested: Scalars['Float']['output'];
  totalProfitLoss: Scalars['Float']['output'];
};

export type Portfolio = {
  __typename?: 'Portfolio';
  _id?: Maybe<Scalars['ID']['output']>;
  active: Scalars['Boolean']['output'];
  bond: PortfolioBond;
  description?: Maybe<Scalars['String']['output']>;
  duration: Duration;
  imagePath?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  localizedDescription?: Maybe<LocalizedString>;
  localizedName?: Maybe<LocalizedString>;
  name?: Maybe<Scalars['String']['output']>;
  riskLevel: Scalars['Int']['output'];
  saving: PortfolioSaving;
  stocks: Array<PortfolioStock>;
};

export type PortfolioBond = {
  __typename?: 'PortfolioBond';
  value: Scalars['Float']['output'];
};

export type PortfolioInfo = {
  __typename?: 'PortfolioInfo';
  changeId?: Maybe<Scalars['String']['output']>;
  currentId?: Maybe<Scalars['String']['output']>;
};

export type PortfolioInfoInput = {
  changeId?: InputMaybe<Scalars['String']['input']>;
  currentId?: InputMaybe<Scalars['String']['input']>;
};

export type PortfolioSaving = {
  __typename?: 'PortfolioSaving';
  value: Scalars['Float']['output'];
};

export type PortfolioStock = {
  __typename?: 'PortfolioStock';
  stock: Stock;
  value: Scalars['Float']['output'];
};

export type PrepareOrderListResult = {
  __typename?: 'PrepareOrderListResult';
  bond: Scalars['Float']['output'];
  savings: Scalars['Float']['output'];
  stocks: Array<PrepareOrderListStock>;
};

export type PrepareOrderListStock = {
  __typename?: 'PrepareOrderListStock';
  symbol: Scalars['String']['output'];
  totalPrice: Scalars['Float']['output'];
  type: StockType;
};

export type PrepareReportResult = {
  __typename?: 'PrepareReportResult';
  reportUrl: Scalars['String']['output'];
};

export type PreviousPurchase = {
  __typename?: 'PreviousPurchase';
  createdAt: Scalars['Float']['output'];
  stocks: Array<PurchaseStock>;
};

export type Purchase = {
  __typename?: 'Purchase';
  _id?: Maybe<Scalars['ID']['output']>;
  bonds?: Maybe<Array<PurchaseBond>>;
  cashAmount: Scalars['Float']['output'];
  createdAt: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  holdAmount: Scalars['Float']['output'];
  previousPurchases?: Maybe<Array<PreviousPurchase>>;
  principleAmount: Scalars['Float']['output'];
  /** Чөлөөлөгдсөн нийт дүн (BalanceUnholdHistory.amount-ийн нийлбэр). */
  releasedAmount: Scalars['Float']['output'];
  savings?: Maybe<Array<PurchaseSaving>>;
  stocks: Array<PurchaseStock>;
  title: Scalars['String']['output'];
  user: User;
};

export type PurchaseBond = {
  __typename?: 'PurchaseBond';
  accumulatedAmount: Scalars['Float']['output'];
  bond: Bond;
  fee: Scalars['Float']['output'];
  principleAmount: Scalars['Float']['output'];
};

export type PurchaseSaving = {
  __typename?: 'PurchaseSaving';
  accumulatedAmount: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  principleAmount: Scalars['Float']['output'];
  saving: Saving;
};

export type PurchaseStock = {
  __typename?: 'PurchaseStock';
  fee: Scalars['Float']['output'];
  holdAmount: Scalars['Float']['output'];
  stock: Stock;
  totalAmount: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  usdRate: Scalars['Float']['output'];
};

export enum PurchaseType {
  Exchange = 'EXCHANGE'
}

export type QPayAppDeeplink = {
  __typename?: 'QPayAppDeeplink';
  description: Scalars['String']['output'];
  link: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QPayInvoice = {
  __typename?: 'QPayInvoice';
  appDeeplinks: Array<QPayAppDeeplink>;
  id: Scalars['String']['output'];
  qrData: Scalars['String']['output'];
  shortUrl: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Dashboard-д зориулсан бүх гэрээний жагсаалт (portfolio filter-гүй). */
  adminContracts: Array<Contract>;
  allPendingWithdrawalRequests: Array<PendingWithdrawalRequest>;
  allWithdrawalRequests?: Maybe<WithdrawalRequestList>;
  /**
   * Look up the status of a balances export started via generateBalancesDetail.
   * Returns a signed download URL once status is DONE.
   */
  balanceExportTask: BalanceExportTask;
  bondHolders: BondHoldersResult;
  bondPayoutBatches: Array<BondPayoutBatch>;
  bondPayoutHistory: BondPayoutHistoryResult;
  bondWithdrawalHistory: BondWithdrawalHistoryResult;
  /** Get list of banks supported by broker account. */
  brokerAccountBankList: Array<BrokerAccountBank>;
  /** Get an amount of fee required to create a broker account. */
  brokerAccountFeeAmount: Scalars['Int']['output'];
  /** Get an account invoice. Returns null if request was not created. */
  brokerAccountInvoice?: Maybe<AccountInvoice>;
  /** Get list of pending post-payments. */
  brokerAccountPendingInvoices: BrokerAccountPendingInvoicesList;
  /**
   * Only for users with old KYC sent via `addKYC` mutation.
   * Returns fields for which user must provide additional info and null if nothing is required.
   */
  brokerAccountRequestMissingInfo?: Maybe<BrokerAccountMissingInfo>;
  contracts: Array<Contract>;
  depositAccounts: Array<DepositAccount>;
  /** Get a bank account and transaction description to place deposits */
  depositInfo: DepositInfo;
  dividendReports: PaginatedDividendReports;
  downloadWithdrawalOrderList: Scalars['String']['output'];
  feeReports: Array<ReportSummary>;
  getActiveSurvey: Survey;
  getActivities: GetActivitiesResult;
  getAllPortfolios?: Maybe<Array<Portfolio>>;
  getAvailableBalances: GetBalancesResult;
  getBalance: Balance;
  /** @deprecated Use userBalance instead */
  getBalanceByUserId: Balance;
  getBalanceInfo: Balance;
  getBalanceUnholdHistories: BalanceUnholdHistoryResult;
  getBalances: GetBalancesResult;
  getBond: Bond;
  getBonds: GetBondsResult;
  /** Bulk цэнэглэлтийн batch-ыг ID-аар авах (UI polling-д хэрэглэнэ). */
  getBulkAddOrderBatch: BulkAddOrderBatch;
  /** Идэвхтэй болон сүүлийн bulk batch-уудыг жагсаах. */
  getBulkAddOrderBatches: Array<BulkAddOrderBatch>;
  getConfig: Config;
  getConfigByKey: Config;
  getConfigs?: Maybe<Array<Config>>;
  /** Залруулгын гүйлгээнүүдийг жагсаах (admin only) */
  getCorrectionOrders: CorrectionOrdersResult;
  getDashboardData: DashboardData;
  getFaq: Faq;
  getFaqs?: Maybe<Array<Faq>>;
  getGroupActivities: GetGroupActivitiesResult;
  getGroupActivity: GroupActivity;
  /** @deprecated This query is not used anymore */
  getImages: ImageListResult;
  getKYC: Kyc;
  getKYCByUser: Kyc;
  getKYCs: GetKyCsResult;
  getKycQuestionnaire: KycQuestionnaire;
  getKycQuestionnaireSend: KycQuestionnaireSend;
  getKycQuestionnaireSends: GetKycQuestionnaireSendsResult;
  getKycQuestionnaireSendsByUser: GetKycQuestionnaireSendsResult;
  getKycQuestionnaires: GetKycQuestionnairesResult;
  getMSCDApiAccounts: MscdApiAccountsResult;
  /**
   * Fetch error accounts directly from MCSD REST API (api.mcsd.mn:1280).
   * beginDate/endDate in YYYYMMDD format. API is queried month-by-month internally.
   */
  getMSCDErrorAccounts: Array<MscdErrorAccount>;
  getMscdAccountStatus: Scalars['String']['output'];
  getMyKycQuestionnaireSend: KycQuestionnaireSend;
  getMyKycQuestionnaireSends: Array<KycQuestionnaireSend>;
  getOrder: Order;
  getOrderHistory: GetOrderHistoryResult;
  getOrderList: OrderList;
  /** @deprecated Use orderLists query */
  getOrderLists: GetOrderListResult;
  getOrders: GetOrderHistoryResult;
  getPortfolio: Portfolio;
  getPortfolios: GetPortfoliosResult;
  getRecommendedPortfolios?: Maybe<Array<GetRecommendedPortfoliosResult>>;
  getSaving: Saving;
  getSavings: GetSavingsResult;
  getStock: Stock;
  getStocks: GetStocksResult;
  getSurvey: Survey;
  getSurveys?: Maybe<Array<Survey>>;
  getUser: User;
  getUserDeletionRequests: GetUserDeletionRequestResponse;
  getUserMSCDAccount?: Maybe<MscdAccountInfo>;
  getUserMSCDApiAccount?: Maybe<MscdApiAccount>;
  getUsers: GetUsersResult;
  getUsersExcel: Array<UserExcelData>;
  interestPayoutReports: Array<ReportSummary>;
  me: User;
  /** Get infographic data for the authenticated user */
  myInfographicReport: UserInfographicReport;
  /** Get portfolio report for the authenticated user */
  myPortfolioReport: UserPortfolioReport;
  /** Get purchase report for the authenticated user */
  myPurchaseReport: UserPurchaseReport;
  orderLists: PaginatedOrderListSummary;
  pendingWithdrawalRequests: PendingWithdrawalRequestList;
  previewKycQuestionnaireSegment: SegmentPreviewResult;
  previewKycQuestionnaireUnrespondedCount: Scalars['Int']['output'];
  previewWithdrawalOrderList: WithdrawalOrderListTotals;
  previewWithdrawalOrderListInterests: WithdrawalOrderListInterestPreview;
  previewWithdrawalOrderListTransfers: Array<WithdrawalOrderListTransfer>;
  purchases: Array<Purchase>;
  /**
   * Request new Webauthn device registration.
   * Returns JSON challenge which should be passed to Webauthn device.
   */
  registerWebauthnDeviceChallenge: Scalars['String']['output'];
  /** Find purchase that is related to the given bond history entry. */
  relatedBondPurchase: Purchase;
  /** Find purchase that is related to the given saving history entry. */
  relatedSavingPurchase: Purchase;
  /**
   * Search for a user to link with MSCD error account.
   * Searches by bdcAccountId/bdcAccountNumber in MSCDAccount, then by phoneNo/registerNo in User/KYC.
   * Returns user info for admin review before linking.
   */
  searchUserForMSCDLink?: Maybe<MscdLinkCandidate>;
  suggestions?: Maybe<Array<Suggestion>>;
  unmatchedDeposits: UnmatchedDepositsResult;
  usdRate: Scalars['Float']['output'];
  userAddress: Scalars['String']['output'];
  userBalance?: Maybe<Balance>;
  /** Хэрэглэгчийн тухайн гэрээний татах URL авах. */
  userContractUrl: Scalars['String']['output'];
  /** Хэрэглэгчийн зурсан гэрээнүүдийн түүх. */
  userContracts: Array<UserContract>;
  /** Get infographic data showing how user's balance was formed (Admin/Operator) */
  userInfographicReport: UserInfographicReport;
  /** Get portfolio report with current holdings and performance metrics (Admin/Operator) */
  userPortfolioReport: UserPortfolioReport;
  /** Get purchase report for a user with all transactions (Admin/Operator) */
  userPurchaseReport: UserPurchaseReport;
  userRegisterNo: Scalars['String']['output'];
  userTaxPayerNo?: Maybe<Scalars['String']['output']>;
  /** Get withdrawal requests for a specific user. Admin only. */
  userWithdrawalRequests: Array<WithdrawalRequest>;
  /** Get current app version */
  version: Scalars['String']['output'];
  /**
   * Request new Webauthn login challenge.
   * Returns JSON challenge which should be passed to Webauthn device.
   * Returns null when there are no authenticators available.
   */
  webauthnLoginChallenge?: Maybe<Scalars['String']['output']>;
  /** Return percentage of interest that will be yielded on withdrawal. */
  withdrawalInterestPercentage: Scalars['Float']['output'];
  withdrawalOrderList?: Maybe<WithdrawalOrderList>;
  withdrawalOrderLists: WithdrawalOrderListData;
  withdrawalRequest?: Maybe<WithdrawalRequest>;
  withdrawalRequests: Array<WithdrawalRequest>;
  withdrawalRequestsByStatus: Array<WithdrawalRequest>;
};


export type QueryAllWithdrawalRequestsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WithdrawalStatus>;
};


export type QueryBalanceExportTaskArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryBondHoldersArgs = {
  bondId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryBondPayoutBatchesArgs = {
  bondId: Scalars['ID']['input'];
};


export type QueryBondPayoutHistoryArgs = {
  bondId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryBondWithdrawalHistoryArgs = {
  bondId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryBrokerAccountPendingInvoicesArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryDividendReportsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryDownloadWithdrawalOrderListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetActivitiesArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  type?: InputMaybe<ActivityType>;
};


export type QueryGetAvailableBalancesArgs = {
  advanced: GetAvailableBalancesAdvancedInput;
  limit: Scalars['Int']['input'];
  options: GetAvailableBalancesOptionsInput;
  page: Scalars['Int']['input'];
};


export type QueryGetBalanceArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetBalanceByUserIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetBalanceUnholdHistoriesArgs = {
  date?: InputMaybe<DateRange>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetBalancesArgs = {
  advanced: GetAvailableBalancesAdvancedInput;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetBondArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetBondsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetBulkAddOrderBatchArgs = {
  batchId: Scalars['ID']['input'];
};


export type QueryGetBulkAddOrderBatchesArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetConfigArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetConfigByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetCorrectionOrdersArgs = {
  filter?: InputMaybe<GetCorrectionOrdersInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetFaqArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetGroupActivitiesArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetGroupActivityArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetImagesArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetKycArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetKycByUserArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetKyCsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  status?: InputMaybe<Status>;
};


export type QueryGetKycQuestionnaireArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetKycQuestionnaireSendArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetKycQuestionnaireSendsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  questionnaireId: Scalars['ID']['input'];
  status?: InputMaybe<KycQuestionnaireSendStatus>;
};


export type QueryGetKycQuestionnaireSendsByUserArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetKycQuestionnairesArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetMscdApiAccountsArgs = {
  filter?: InputMaybe<MscdApiAccountFilterInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetMscdErrorAccountsArgs = {
  beginDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
};


export type QueryGetMscdAccountStatusArgs = {
  accountNumber: Scalars['String']['input'];
};


export type QueryGetMyKycQuestionnaireSendArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetOrderArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetOrderHistoryArgs = {
  endDate?: InputMaybe<Scalars['Float']['input']>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<OrderStatus>;
};


export type QueryGetOrderListArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetOrderListsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  status: OrderListStatus;
};


export type QueryGetOrdersArgs = {
  advanced: GetOrders;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetPortfolioArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetPortfoliosArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetSavingArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetSavingsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetStockArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetStocksArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetSurveyArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetUserArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetUserDeletionRequestsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetUserMscdAccountArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUserMscdApiAccountArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUsersArgs = {
  advanced: AdvancedSearchInput;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryMyInfographicReportArgs = {
  dateRange?: InputMaybe<UserReportDateRange>;
};


export type QueryMyPurchaseReportArgs = {
  dateRange?: InputMaybe<UserReportDateRange>;
};


export type QueryOrderListsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  status: OrderListStatus;
};


export type QueryPendingWithdrawalRequestsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryPreviewKycQuestionnaireSegmentArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  segment: KycUserSegmentInput;
};


export type QueryPreviewKycQuestionnaireUnrespondedCountArgs = {
  questionnaireId: Scalars['ID']['input'];
};


export type QueryPreviewWithdrawalOrderListArgs = {
  withdrawalRequestIds: Array<Scalars['ID']['input']>;
};


export type QueryPreviewWithdrawalOrderListInterestsArgs = {
  orderListId: Scalars['ID']['input'];
};


export type QueryPreviewWithdrawalOrderListTransfersArgs = {
  orderListId: Scalars['ID']['input'];
};


export type QueryPurchasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRegisterWebauthnDeviceChallengeArgs = {
  username: Scalars['String']['input'];
};


export type QueryRelatedBondPurchaseArgs = {
  balanceId: Scalars['ID']['input'];
  historyEntryId: Scalars['ID']['input'];
};


export type QueryRelatedSavingPurchaseArgs = {
  balanceId: Scalars['ID']['input'];
  historyEntryId: Scalars['ID']['input'];
};


export type QuerySearchUserForMscdLinkArgs = {
  bdcAccountId: Scalars['String']['input'];
  bdcAccountNumber: Scalars['Int']['input'];
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  registerNo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUnmatchedDepositsArgs = {
  bank?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<UnmatchedDepositStatus>;
};


export type QueryUserAddressArgs = {
  kycId: Scalars['ID']['input'];
};


export type QueryUserBalanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserContractUrlArgs = {
  contractName: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryUserContractsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserInfographicReportArgs = {
  dateRange?: InputMaybe<UserReportDateRange>;
  userId: Scalars['ID']['input'];
};


export type QueryUserPortfolioReportArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserPurchaseReportArgs = {
  dateRange?: InputMaybe<UserReportDateRange>;
  userId: Scalars['ID']['input'];
};


export type QueryUserRegisterNoArgs = {
  kycId: Scalars['ID']['input'];
};


export type QueryUserTaxPayerNoArgs = {
  kycId: Scalars['ID']['input'];
};


export type QueryUserWithdrawalRequestsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryWebauthnLoginChallengeArgs = {
  username: Scalars['String']['input'];
};


export type QueryWithdrawalOrderListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWithdrawalOrderListsArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  status?: InputMaybe<WithdrawalStatus>;
};


export type QueryWithdrawalRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWithdrawalRequestsByStatusArgs = {
  status?: InputMaybe<WithdrawalStatus>;
};

export type Question = {
  __typename?: 'Question';
  answers: Array<Answer>;
  localizedQuestion?: Maybe<LocalizedString>;
  question: Scalars['String']['output'];
};

export type QuestionInput = {
  answers?: InputMaybe<Array<AnswerInput>>;
  localizedQuestion: LocalizedStringInput;
  question: Scalars['String']['input'];
};

export type ReportSummary = {
  __typename?: 'ReportSummary';
  batchId: Scalars['String']['output'];
};

export type RequestDeleteUserResponse = {
  __typename?: 'RequestDeleteUserResponse';
  status: Scalars['String']['output'];
};

export type RequestOtpResult = {
  __typename?: 'RequestOtpResult';
  challenge: Scalars['String']['output'];
  retryAfter: Scalars['Int']['output'];
  sent: Scalars['Boolean']['output'];
};

export enum Role {
  Admin = 'ADMIN',
  Finance = 'FINANCE',
  Operator = 'OPERATOR',
  User = 'USER'
}

export type Saving = {
  __typename?: 'Saving';
  _id?: Maybe<Scalars['ID']['output']>;
  accountNo: Scalars['String']['output'];
  balance: Scalars['Float']['output'];
  bankName: Scalars['String']['output'];
  currency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  /** String in format of "1y 2m" */
  duration?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use duration instead */
  endDate?: Maybe<Scalars['Float']['output']>;
  interestRate: Scalars['Float']['output'];
  /** @deprecated Use duration instead */
  startDate?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SegmentPreviewResult = {
  __typename?: 'SegmentPreviewResult';
  userCount: Scalars['Int']['output'];
  users: Array<User>;
};

export enum Status {
  Confirmed = 'CONFIRMED',
  Notrequested = 'NOTREQUESTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type Stock = {
  __typename?: 'Stock';
  _id?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  /** @deprecated This field never used. */
  image?: Maybe<Image>;
  localizedDescription: LocalizedString;
  localizedName: LocalizedString;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  type: StockType;
  unitPrice: Scalars['Float']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type StockAdjustmentInput = {
  historyIndex: Scalars['Int']['input'];
  newTotalAmount: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
  stockIndex: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type StockDetail = {
  __typename?: 'StockDetail';
  unitPrice: Scalars['Float']['output'];
};

export enum StockType {
  Domestic = 'DOMESTIC',
  International = 'INTERNATIONAL'
}

export type SubmitKycInput = {
  address: Scalars['String']['input'];
  bankAccountNo: Scalars['String']['input'];
  /** bankCode must be a bank code provided by DBX */
  bankCode: Scalars['String']['input'];
  /** bankName must be a bank from list provided by DBX */
  bankName: Scalars['String']['input'];
  /** Must be an ISO-formatted datetime string */
  birthDate: Scalars['String']['input'];
  /** Emergency contact name */
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  /** Emergency contact phone number */
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Emergency contact relationship */
  emergencyContactRelationship?: InputMaybe<Scalars['String']['input']>;
  images: Array<Scalars['String']['input']>;
  /** Whether if person is a Politically Exposed Person. In other words, if person is related to politics. */
  isPEP?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required if user didn't use phone number for sign in. */
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  registerNo: Scalars['String']['input'];
  taxPayerNo: Scalars['String']['input'];
  /** The name of work place. For example: "Accumulus Capital LLC" */
  workplace?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitSurveyResult = {
  __typename?: 'SubmitSurveyResult';
  recommendedPortfolios?: Maybe<Array<GetRecommendedPortfoliosResult>>;
};

export type Suggestion = {
  __typename?: 'Suggestion';
  _id: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expireAt: Scalars['Float']['output'];
  portfolioInfos: Array<Maybe<PortfolioInfo>>;
  stocks: Array<Scalars['String']['output']>;
  suggestionCount: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Survey = {
  __typename?: 'Survey';
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  completeText: Scalars['String']['output'];
  introText: Scalars['String']['output'];
  localizedCompleteText?: Maybe<LocalizedString>;
  localizedIntroText?: Maybe<LocalizedString>;
  localizedName?: Maybe<LocalizedString>;
  name: Scalars['String']['output'];
  questions: Array<Question>;
};

export type SyncMscdAccountsResult = {
  __typename?: 'SyncMSCDAccountsResult';
  modified: Scalars['Int']['output'];
  synced: Scalars['Int']['output'];
  upserted: Scalars['Int']['output'];
};

export type SyncMscdErrorAccountsResult = {
  __typename?: 'SyncMSCDErrorAccountsResult';
  fetched: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type TotalBond = {
  __typename?: 'TotalBond';
  amount: Scalars['Float']['output'];
};

export type TotalPurchases = {
  __typename?: 'TotalPurchases';
  bond: TotalBond;
  cashAmount: Scalars['Float']['output'];
  saving: TotalSaving;
  stocks: Array<TotalStock>;
};

export type TotalSaving = {
  __typename?: 'TotalSaving';
  amount: Scalars['Float']['output'];
};

export type TotalStock = {
  __typename?: 'TotalStock';
  availableTotalPrice: Scalars['Float']['output'];
  stock: Stock;
  totalPrice: Scalars['Float']['output'];
  usdRate: Scalars['Float']['output'];
};

export type TransactionTimelineItem = {
  __typename?: 'TransactionTimelineItem';
  _id: Scalars['ID']['output'];
  afterBalance: Scalars['Float']['output'];
  amount: Scalars['Float']['output'];
  beforeBalance: Scalars['Float']['output'];
  date: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  status: OrderStatus;
  type: UserReportTransactionType;
};

export type UnmatchedDeposit = {
  __typename?: 'UnmatchedDeposit';
  _id: Scalars['ID']['output'];
  account: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  bank: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  matchedAt?: Maybe<Scalars['String']['output']>;
  matchedBy?: Maybe<Scalars['ID']['output']>;
  matchedDepositId?: Maybe<Scalars['ID']['output']>;
  parsedExternalId?: Maybe<Scalars['String']['output']>;
  reason: UnmatchedDepositReason;
  status: UnmatchedDepositStatus;
  transactionDate: Scalars['String']['output'];
  transactionDescription: Scalars['String']['output'];
  transactionUniqueId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum UnmatchedDepositReason {
  AmountTooLow = 'amount_too_low',
  NoRegexMatch = 'no_regex_match',
  UserNotFound = 'user_not_found'
}

export enum UnmatchedDepositStatus {
  Dismissed = 'dismissed',
  Matched = 'matched',
  Pending = 'pending'
}

export type UnmatchedDepositsResult = {
  __typename?: 'UnmatchedDepositsResult';
  items: Array<UnmatchedDeposit>;
  total: Scalars['Int']['output'];
};

export type UpdateKycInput = {
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  emergencyContactRelationship?: InputMaybe<Scalars['String']['input']>;
  gender: Gender;
  isPEP: Scalars['Boolean']['input'];
  workplace: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  bankInfo?: Maybe<UserBankInfo>;
  birthDate?: Maybe<Scalars['Float']['output']>;
  brokerAccountStatus: BrokerAccountStatus;
  chosenPortfolio?: Maybe<Portfolio>;
  /**
   * User's signed contract date in format YYYY-MM-DD.
   * This field is null if user has not signed the contract.
   */
  contractDate?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Float']['output']>;
  /** User's broker account number. */
  dbxAccountNumber?: Maybe<Scalars['String']['output']>;
  /** The code that user can use for depositing money to the AvtaMata account. */
  depositCode: Scalars['String']['output'];
  durationLevel?: Maybe<Duration>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /**
   * Хэрэглэгчийг хөлдөөсөн эсэх.
   * true бол шинэ захиалгад оруулахгүй.
   */
  isFrozen: Scalars['Boolean']['output'];
  /** Whether if user has signed the contract and the server is processing the contract. */
  isProcessingContract?: Maybe<Scalars['Boolean']['output']>;
  kycInfo: UserKycInfo;
  /**
   * User's submitted KYC version.
   * Version 1 is a current implementation.
   * Version 2 is a new implementation with additional fields such as `workplace` and `isPEP`.
   */
  kycVersion: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * MSCD account-ийн сүүлийн алдааны мэдээлэл.
   * Null бол алдаагүй.
   */
  mscdLastError?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  riskLevel?: Maybe<Scalars['Int']['output']>;
  role: Role;
  type?: Maybe<UserType>;
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /**
   * User's current verification stage.
   * For more information, see description for VerificationStage enum values.
   */
  verificationStage: VerificationStage;
};

export type UserBankInfo = {
  __typename?: 'UserBankInfo';
  accountName?: Maybe<Scalars['String']['output']>;
  accountNo?: Maybe<Scalars['String']['output']>;
  /** Bank codes are provided by DBX API. Please refer to `brokerAccountBankList` query. */
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
};

export type UserContract = {
  __typename?: 'UserContract';
  _id: Scalars['ID']['output'];
  contractName: Scalars['String']['output'];
  contractNo: Scalars['String']['output'];
  signedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type UserDeletionRequest = {
  __typename?: 'UserDeletionRequest';
  _id?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Float']['output'];
  user: User;
};

export type UserExcelData = {
  __typename?: 'UserExcelData';
  address?: Maybe<Scalars['String']['output']>;
  bond?: Maybe<Scalars['Int']['output']>;
  dia?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  estate?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fx?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  portfolioIndex?: Maybe<Scalars['Int']['output']>;
  registerNo?: Maybe<Scalars['String']['output']>;
  vde?: Maybe<Scalars['Int']['output']>;
  vti?: Maybe<Scalars['Int']['output']>;
  vug?: Maybe<Scalars['Int']['output']>;
  vxf?: Maybe<Scalars['Int']['output']>;
  xoz?: Maybe<Scalars['Int']['output']>;
};

export type UserInfographicReport = {
  __typename?: 'UserInfographicReport';
  generatedAt: Scalars['Float']['output'];
  summary: InfographicSummary;
  timeline: Array<BalanceFormationItem>;
  userId: Scalars['ID']['output'];
};

export type UserKycInfo = {
  __typename?: 'UserKYCInfo';
  description?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type UserPortfolioReport = {
  __typename?: 'UserPortfolioReport';
  closedPositions: Array<ClosedPosition>;
  currentHoldings: Array<HoldingItem>;
  generatedAt: Scalars['Float']['output'];
  performanceMetrics: PerformanceMetrics;
  userId: Scalars['ID']['output'];
};

export type UserPurchaseReport = {
  __typename?: 'UserPurchaseReport';
  generatedAt: Scalars['Float']['output'];
  totalPurchases: Scalars['Float']['output'];
  totalReturns: Scalars['Float']['output'];
  transactions: Array<TransactionTimelineItem>;
  userId: Scalars['ID']['output'];
};

export enum UserReportAssetType {
  Bond = 'BOND',
  Saving = 'SAVING',
  Stock = 'STOCK'
}

export type UserReportDateRange = {
  endDate?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Float']['input']>;
};

export enum UserReportTransactionType {
  Fee = 'FEE',
  Income = 'INCOME',
  InterestPayout = 'INTEREST_PAYOUT',
  Purchase = 'PURCHASE',
  Return = 'RETURN',
  Withdrawal = 'WITHDRAWAL'
}

export enum UserType {
  Company = 'COMPANY',
  Person = 'PERSON',
  Test = 'TEST'
}

export enum VerificationStage {
  /** User should pay brokerage account fee */
  BrokerAccountFee = 'BrokerAccountFee',
  /**
   * User should fill required inforation for broker account
   * Also see `brokerAccountRequestMissingInfo` query
   */
  BrokerAccountInfo = 'BrokerAccountInfo',
  /**
   * User should sign the contracts.
   *
   * Available since app version 2.13.0.
   */
  Contracts = 'Contracts',
  /** User should submit KYC */
  Kyc = 'KYC',
  /**
   * User should submit new fields introduced in KYCv2.
   *
   * Available since app version 2.13.0.
   */
  KyCv2 = 'KYCv2',
  /** User should choose a portfolio */
  Portfolio = 'Portfolio',
  /** User should fill profile information: first/last name and email */
  Profile = 'Profile',
  /** User should fill survey */
  Survey = 'Survey',
  Verified = 'Verified'
}

export type WithdrawalAssetInput = {
  assetId: Scalars['ID']['input'];
  /** This field's value can be obtained from the balance history, refer to: BalanceBondHistory._id or BalanceSavingHistory._id */
  balanceHistoryRecordId: Scalars['ID']['input'];
};

export type WithdrawalConfirmationData = {
  stocks: Array<WithdrawalConfirmationStock>;
  usdRate: Scalars['Int']['input'];
};

export type WithdrawalConfirmationDetail = {
  __typename?: 'WithdrawalConfirmationDetail';
  bonds?: Maybe<Array<Maybe<WithdrawalDetailConfirmationBond>>>;
  estate?: Maybe<Array<Maybe<WithdrawalDetailConfirmationEstate>>>;
  stocks?: Maybe<Array<Maybe<WithdrawalDetailConfirmationStock>>>;
};

export type WithdrawalConfirmationStock = {
  comission: Scalars['String']['input'];
  price: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  symbol: Scalars['String']['input'];
  /** Total price for the specific stock. Refer to "Proceeds" column in the order confirmation sheet. */
  totalPrice: Scalars['String']['input'];
};

export type WithdrawalDetailConfirmationBond = {
  __typename?: 'WithdrawalDetailConfirmationBond';
  assetId: Scalars['ID']['output'];
  feeAmount: Scalars['Float']['output'];
  interestAmount: Scalars['Float']['output'];
  principleAmount: Scalars['Float']['output'];
  purchasedAt: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type WithdrawalDetailConfirmationEstate = {
  __typename?: 'WithdrawalDetailConfirmationEstate';
  assetId: Scalars['ID']['output'];
  feeAmount: Scalars['Float']['output'];
  interestAmount: Scalars['Float']['output'];
  principleAmount: Scalars['Float']['output'];
  purchasedAt: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type WithdrawalDetailConfirmationStock = {
  __typename?: 'WithdrawalDetailConfirmationStock';
  assetId: Scalars['ID']['output'];
  purchasedAt: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalComission: Scalars['Float']['output'];
  totalFee: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
};

export type WithdrawalOrderList = {
  __typename?: 'WithdrawalOrderList';
  _id: Scalars['ID']['output'];
  bondTotals: Array<WithdrawalOrderListBondTotals>;
  createdAt: Scalars['Float']['output'];
  estateTotals: Array<WithdrawalOrderListEstateTotals>;
  isProcessing: Scalars['Boolean']['output'];
  /** Number of withdrawals that are confirmed */
  processedWithdrawals: Scalars['Int']['output'];
  status: WithdrawalStatus;
  stockTotals: Array<WithdrawalOrderListStockTotals>;
  totalWithdrawals: Scalars['Int']['output'];
  updatedAt: Scalars['Float']['output'];
  /** withdrawalInterestPercentage value at the time of order list creation. */
  withdrawalInterestPercentage: Scalars['Float']['output'];
  withdrawalRequests: Array<WithdrawalRequest>;
  withdrawalType?: Maybe<WithdrawalType>;
};

export type WithdrawalOrderListBondTotals = {
  __typename?: 'WithdrawalOrderListBondTotals';
  asset: Bond;
  totalAmount: Scalars['Float']['output'];
};

export type WithdrawalOrderListData = {
  __typename?: 'WithdrawalOrderListData';
  data: Array<WithdrawalOrderList>;
  totalItems: Scalars['Int']['output'];
};

export type WithdrawalOrderListEstateTotals = {
  __typename?: 'WithdrawalOrderListEstateTotals';
  asset: Saving;
  totalAmount: Scalars['Float']['output'];
};

export type WithdrawalOrderListInterestInterestPreviewDetails = {
  __typename?: 'WithdrawalOrderListInterestInterestPreviewDetails';
  assetId: Scalars['ID']['output'];
  /** Total amount including interest and tax. */
  totalAmount: Scalars['Float']['output'];
  totalInterest: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
};

export type WithdrawalOrderListInterestPreview = {
  __typename?: 'WithdrawalOrderListInterestPreview';
  bonds: Array<Maybe<WithdrawalOrderListInterestInterestPreviewDetails>>;
  estate: Array<Maybe<WithdrawalOrderListInterestInterestPreviewDetails>>;
};

export type WithdrawalOrderListStockTotals = {
  __typename?: 'WithdrawalOrderListStockTotals';
  stock: Stock;
  totalQuantity: Scalars['Float']['output'];
};

export type WithdrawalOrderListTotals = {
  __typename?: 'WithdrawalOrderListTotals';
  bondTotals: Array<WithdrawalOrderListBondTotals>;
  estateTotals: Array<WithdrawalOrderListEstateTotals>;
  stockTotals: Array<WithdrawalOrderListStockTotals>;
};

export type WithdrawalOrderListTransfer = {
  __typename?: 'WithdrawalOrderListTransfer';
  accountNo?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  registerNo: Scalars['String']['output'];
  totalAmount: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
  withdrawalRequestId: Scalars['ID']['output'];
};

export type WithdrawalRequest = {
  __typename?: 'WithdrawalRequest';
  _id: Scalars['ID']['output'];
  bonds: Array<WithdrawalRequestBond>;
  confirmationDetail?: Maybe<Array<Maybe<WithdrawalConfirmationDetail>>>;
  createdAt: Scalars['Float']['output'];
  estate: Array<WithdrawalRequestEstate>;
  releasedCashAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * Snapshot of holdAmount that was released into cashAmount at the time of
   * this request (for "Withdraw all" flows). Used both for audit and to
   * reverse the operation if the request is canceled.
   */
  releasedHoldAmount?: Maybe<Scalars['Float']['output']>;
  status: WithdrawalStatus;
  stocks: Array<WithdrawalRequestStock>;
  updatedAt: Scalars['Float']['output'];
  user: User;
  withdrawalType?: Maybe<WithdrawalType>;
};

export type WithdrawalRequestBond = {
  __typename?: 'WithdrawalRequestBond';
  amount: Scalars['Float']['output'];
  /**
   * Actual amount for which specific asset was sold.
   * Must be defined if the withdrawal request is approved.
   */
  balanceHistoryRecordId: Scalars['ID']['output'];
  bond: Bond;
  purchasedAt: Scalars['Float']['output'];
  withdrawnAmount?: Maybe<Scalars['Float']['output']>;
};

export type WithdrawalRequestEstate = {
  __typename?: 'WithdrawalRequestEstate';
  amount: Scalars['Float']['output'];
  /**
   * Actual amount for which specific asset was sold.
   * Must be defined if the withdrawal request is approved.
   */
  balanceHistoryRecordId: Scalars['ID']['output'];
  estate: Saving;
  purchasedAt: Scalars['Float']['output'];
  withdrawnAmount?: Maybe<Scalars['Float']['output']>;
};

export type WithdrawalRequestInput = {
  bonds: Array<WithdrawalAssetInput>;
  estate: Array<WithdrawalAssetInput>;
  /**
   * When true, also release any holdAmount on the user's balance
   * (transferring it to cashAmount). Used for "Withdraw all" flows so the
   * user's frozen cash also gets unlocked alongside their securities.
   */
  releaseHeldCash?: InputMaybe<Scalars['Boolean']['input']>;
  stocks: Array<WithdrawalAssetInput>;
  type?: InputMaybe<WithdrawalType>;
};

export type WithdrawalRequestList = {
  __typename?: 'WithdrawalRequestList';
  requests: Array<WithdrawalRequest>;
  totalItems: Scalars['Int']['output'];
};

export type WithdrawalRequestStock = {
  __typename?: 'WithdrawalRequestStock';
  purchasedAt: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  stock: Stock;
  /**
   * Actual amount for which specific asset was sold.
   * Must be defined if the withdrawal request is approved.
   */
  withdrawnAmount?: Maybe<Scalars['Float']['output']>;
};

export type WithdrawalRequestsConfirmationResult = {
  __typename?: 'WithdrawalRequestsConfirmationResult';
  orderListComplete: Scalars['Boolean']['output'];
};

export enum WithdrawalStatus {
  Canceled = 'Canceled',
  Done = 'Done',
  Pending = 'Pending',
  Processing = 'Processing',
  TransferPending = 'TransferPending'
}

export enum WithdrawalType {
  Custom = 'Custom',
  Suggested = 'Suggested'
}

export type AddActivityMutationVariables = Exact<{
  activity: AddActivityInput;
}>;


export type AddActivityMutation = { __typename?: 'Mutation', addActivity: boolean };

export type RegisterWebauthnDeviceQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type RegisterWebauthnDeviceQuery = { __typename?: 'Query', registerWebauthnDeviceChallenge: string };

export type ConfirmWebauthnDeviceRegistrationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  response: Scalars['String']['input'];
}>;


export type ConfirmWebauthnDeviceRegistrationMutation = { __typename?: 'Mutation', confirmWebauthnDeviceRegistration: boolean };

export type WebauthnLoginChallengeQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type WebauthnLoginChallengeQuery = { __typename?: 'Query', webauthnLoginChallenge?: string | null };

export type WebauthnLoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  response: Scalars['String']['input'];
}>;


export type WebauthnLoginMutation = { __typename?: 'Mutation', webauthnLogin: { __typename?: 'Auth', token: string, user: { __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null, birthDate?: number | null, role: Role, type?: UserType | null, riskLevel?: number | null, contractDate?: string | null, durationLevel?: Duration | null, mscdLastError?: string | null, isFrozen: boolean, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null }, bankInfo?: { __typename?: 'UserBankInfo', bankName?: string | null, bankCode?: string | null, accountNo?: string | null, accountName?: string | null } | null } } };

export type LoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
  challenge: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'Auth', token: string, user: { __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null, birthDate?: number | null, role: Role, type?: UserType | null, riskLevel?: number | null, contractDate?: string | null, durationLevel?: Duration | null, mscdLastError?: string | null, isFrozen: boolean, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null }, bankInfo?: { __typename?: 'UserBankInfo', bankName?: string | null, bankCode?: string | null, accountNo?: string | null, accountName?: string | null } | null } } };

export type PurchaseStockDataFragment = { __typename?: 'PurchaseStock', totalAmount: number, totalPrice: number, holdAmount: number, unitPrice: number, fee: number, stock: { __typename?: 'Stock', name: string, symbol: string } };

export type PurchaseDataFragment = { __typename?: 'Purchase', releasedAmount: number, stocks: Array<{ __typename?: 'PurchaseStock', totalAmount: number, totalPrice: number, holdAmount: number, unitPrice: number, fee: number, stock: { __typename?: 'Stock', name: string, symbol: string } }>, bonds?: Array<{ __typename?: 'PurchaseBond', principleAmount: number, fee: number, bond: { __typename?: 'Bond', symbol: string, name: string } }> | null, savings?: Array<{ __typename?: 'PurchaseSaving', principleAmount: number, fee: number, saving: { __typename?: 'Saving', bankName: string, accountNo: string } }> | null, previousPurchases?: Array<{ __typename?: 'PreviousPurchase', createdAt: number, stocks: Array<{ __typename?: 'PurchaseStock', totalAmount: number, totalPrice: number, holdAmount: number, unitPrice: number, fee: number, stock: { __typename?: 'Stock', name: string, symbol: string } }> }> | null };

export type GetBalancesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  advanced: GetAvailableBalancesAdvancedInput;
}>;


export type GetBalancesQuery = { __typename?: 'Query', getBalances: { __typename?: 'GetBalancesResult', totalPages: number, balances: Array<{ __typename?: 'Balance', _id?: string | null, fee: number, netAssetValue: number, cashAmount: number, holdAmount: number, user: { __typename?: 'User', _id: string, phoneNo?: string | null }, bonds: Array<{ __typename?: 'BalanceBond', bond: { __typename?: 'Bond', _id?: string | null } }>, stocks: Array<{ __typename?: 'BalanceStock', stock: { __typename?: 'Stock', _id?: string | null } }>, savings: Array<{ __typename?: 'BalanceSaving', saving: { __typename?: 'Saving', _id?: string | null } }>, orderHistory: Array<{ __typename?: 'Order', _id?: string | null }> }> } };

export type GetBalanceByUserIdQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetBalanceByUserIdQuery = { __typename?: 'Query', getBalanceByUserId: { __typename?: 'Balance', _id?: string | null, fee: number, netAssetValue: number, cashAmount: number, holdAmount: number, totalDeposit?: number | null, user: { __typename?: 'User', _id: string, phoneNo?: string | null, chosenPortfolio?: { __typename?: 'Portfolio', _id?: string | null, index: number } | null }, bonds: Array<{ __typename?: 'BalanceBond', principleAmount: number, accumulatedAmount: number, estimatedTotalEarnings: number, fee: number, bond: { __typename?: 'Bond', name: string, symbol: string }, history: Array<{ __typename?: 'BalanceBondHistory', _id: string, principleAmount: number, fee: number, createdAt: number }> }>, stocks: Array<{ __typename?: 'BalanceStock', totalAmount: number, totalPrice: number, unitPrice: number, fee: number, stock: { __typename?: 'Stock', name: string, symbol: string }, history: Array<{ __typename?: 'BalanceStockHistory', usdRate: number, holdAmount: number, totalAmount: number, totalPrice: number, unitPrice: number, fee: number, createdAt: number }> }>, savings: Array<{ __typename?: 'BalanceSaving', principleAmount: number, estimatedTotalEarnings: number, accumulatedAmount: number, fee: number, saving: { __typename?: 'Saving', bankName: string, accountNo: string }, history: Array<{ __typename?: 'BalanceSavingHistory', _id: string, principleAmount: number, fee: number, createdAt: number }> }>, orderHistory: Array<{ __typename?: 'Order', _id?: string | null, status: OrderStatus, type: OrderType, amount: number, beforeBalance: number, afterBalance: number, createdAt: number, updatedAt?: number | null, description: string }>, balanceHistory: Array<{ __typename?: 'Purchase', _id?: string | null, title: string, cashAmount: number, holdAmount: number, principleAmount: number, fee: number, createdAt: number, releasedAmount: number, stocks: Array<{ __typename?: 'PurchaseStock', totalAmount: number, totalPrice: number, holdAmount: number, unitPrice: number, fee: number, stock: { __typename?: 'Stock', name: string, symbol: string } }>, bonds?: Array<{ __typename?: 'PurchaseBond', principleAmount: number, fee: number, bond: { __typename?: 'Bond', symbol: string, name: string } }> | null, savings?: Array<{ __typename?: 'PurchaseSaving', principleAmount: number, fee: number, saving: { __typename?: 'Saving', bankName: string, accountNo: string } }> | null, previousPurchases?: Array<{ __typename?: 'PreviousPurchase', createdAt: number, stocks: Array<{ __typename?: 'PurchaseStock', totalAmount: number, totalPrice: number, holdAmount: number, unitPrice: number, fee: number, stock: { __typename?: 'Stock', name: string, symbol: string } }> }> | null }> } };

export type GetBalanceQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetBalanceQuery = { __typename?: 'Query', getBalance: { __typename?: 'Balance', _id?: string | null, fee: number, netAssetValue: number, cashAmount: number, holdAmount: number, user: { __typename?: 'User', _id: string, phoneNo?: string | null, chosenPortfolio?: { __typename?: 'Portfolio', _id?: string | null, index: number } | null }, bonds: Array<{ __typename?: 'BalanceBond', principleAmount: number, accumulatedAmount: number, estimatedTotalEarnings: number, fee: number, bond: { __typename?: 'Bond', name: string }, history: Array<{ __typename?: 'BalanceBondHistory', _id: string, principleAmount: number, fee: number, createdAt: number }> }>, stocks: Array<{ __typename?: 'BalanceStock', totalAmount: number, totalPrice: number, unitPrice: number, fee: number, stock: { __typename?: 'Stock', name: string }, history: Array<{ __typename?: 'BalanceStockHistory', usdRate: number, holdAmount: number, totalAmount: number, totalPrice: number, unitPrice: number, fee: number, createdAt: number }> }>, savings: Array<{ __typename?: 'BalanceSaving', principleAmount: number, estimatedTotalEarnings: number, accumulatedAmount: number, fee: number, saving: { __typename?: 'Saving', bankName: string, accountNo: string }, history: Array<{ __typename?: 'BalanceSavingHistory', _id: string, principleAmount: number, fee: number, createdAt: number }> }>, orderHistory: Array<{ __typename?: 'Order', _id?: string | null, status: OrderStatus, type: OrderType, amount: number, beforeBalance: number, afterBalance: number, createdAt: number, updatedAt?: number | null }>, balanceHistory: Array<{ __typename?: 'Purchase', _id?: string | null, title: string, cashAmount: number, holdAmount: number, principleAmount: number, fee: number, createdAt: number, releasedAmount: number, stocks: Array<{ __typename?: 'PurchaseStock', totalAmount: number, totalPrice: number, holdAmount: number, unitPrice: number, fee: number, stock: { __typename?: 'Stock', name: string, symbol: string } }>, bonds?: Array<{ __typename?: 'PurchaseBond', principleAmount: number, fee: number, bond: { __typename?: 'Bond', symbol: string, name: string } }> | null, savings?: Array<{ __typename?: 'PurchaseSaving', principleAmount: number, fee: number, saving: { __typename?: 'Saving', bankName: string, accountNo: string } }> | null, previousPurchases?: Array<{ __typename?: 'PreviousPurchase', createdAt: number, stocks: Array<{ __typename?: 'PurchaseStock', totalAmount: number, totalPrice: number, holdAmount: number, unitPrice: number, fee: number, stock: { __typename?: 'Stock', name: string, symbol: string } }> }> | null }> } };

export type GetAvailableBalancesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  options: GetAvailableBalancesOptionsInput;
  advanced: GetAvailableBalancesAdvancedInput;
}>;


export type GetAvailableBalancesQuery = { __typename?: 'Query', getAvailableBalances: { __typename?: 'GetBalancesResult', totalPages: number, balances: Array<{ __typename?: 'Balance', _id?: string | null, cashAmount: number, user: { __typename?: 'User', phoneNo?: string | null, email?: string | null, chosenPortfolio?: { __typename?: 'Portfolio', _id?: string | null, index: number } | null } }> } };

export type RelatedBondPurchaseQueryVariables = Exact<{
  balanceId: Scalars['ID']['input'];
  historyEntryId: Scalars['ID']['input'];
}>;


export type RelatedBondPurchaseQuery = { __typename?: 'Query', relatedBondPurchase: { __typename?: 'Purchase', _id?: string | null } };

export type RelatedSavingPurchaseQueryVariables = Exact<{
  balanceId: Scalars['ID']['input'];
  historyEntryId: Scalars['ID']['input'];
}>;


export type RelatedSavingPurchaseQuery = { __typename?: 'Query', relatedSavingPurchase: { __typename?: 'Purchase', _id?: string | null } };

export type BalanceExportTaskDataFragment = { __typename?: 'BalanceExportTask', _id: string, status: BalanceExportTaskStatus, withMnt: boolean, url?: string | null, error?: string | null, createdAt: number, completedAt?: number | null };

export type GenerateBalancesDetailMutationVariables = Exact<{
  withMnt?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GenerateBalancesDetailMutation = { __typename?: 'Mutation', generateBalancesDetail: { __typename?: 'BalanceExportTask', _id: string, status: BalanceExportTaskStatus, withMnt: boolean, url?: string | null, error?: string | null, createdAt: number, completedAt?: number | null } };

export type BalanceExportTaskQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type BalanceExportTaskQuery = { __typename?: 'Query', balanceExportTask: { __typename?: 'BalanceExportTask', _id: string, status: BalanceExportTaskStatus, withMnt: boolean, url?: string | null, error?: string | null, createdAt: number, completedAt?: number | null } };

export type ResetBalanceMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ResetBalanceMutation = { __typename?: 'Mutation', resetBalance: boolean };

export type CorrectCashWithdrawalMutationVariables = Exact<{
  input: CashCorrectionInput;
}>;


export type CorrectCashWithdrawalMutation = { __typename?: 'Mutation', correctCashWithdrawal: { __typename?: 'CorrectionResult', success: boolean, correctionAmount?: number | null, withdrawalOrderId?: string | null, message?: string | null } };

export type PreviewBondInterestRecalcMutationVariables = Exact<{
  input: BondInterestRecalcInput;
}>;


export type PreviewBondInterestRecalcMutation = { __typename?: 'Mutation', previewBondInterestRecalc: { __typename?: 'BondInterestRecalcPreview', totalCurrentInterest: number, totalCorrectedInterest: number, totalDifference: number, totalPrincipalDifference: number, totalCorrection: number, entries: Array<{ __typename?: 'BondInterestPreview', bondName: string, bondIndex: number, historyEntryId: string, principleAmount: number, currentInterest: number, correctedInterest: number, difference: number, principalDifference: number, purchaseId?: string | null, createdAt: number }> } };

export type CorrectBondInterestMutationVariables = Exact<{
  input: BondInterestRecalcInput;
}>;


export type CorrectBondInterestMutation = { __typename?: 'Mutation', correctBondInterest: { __typename?: 'CorrectionResult', success: boolean, correctionAmount?: number | null, withdrawalOrderId?: string | null, message?: string | null } };

export type CorrectStockPositionMutationVariables = Exact<{
  input: StockAdjustmentInput;
}>;


export type CorrectStockPositionMutation = { __typename?: 'Mutation', correctStockPosition: { __typename?: 'CorrectionResult', success: boolean, correctionAmount?: number | null, withdrawalOrderId?: string | null, message?: string | null } };

export type GetCorrectionOrdersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<GetCorrectionOrdersInput>;
}>;


export type GetCorrectionOrdersQuery = { __typename?: 'Query', getCorrectionOrders: { __typename?: 'CorrectionOrdersResult', totalPages: number, orders: Array<{ __typename?: 'CorrectionOrder', _id: string, amount: number, description: string, correctionType: CorrectionType, reason: string, adminId?: string | null, status: OrderStatus, createdAt: number, oldValue?: number | null, newValue?: number | null, user: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, phoneNo?: string | null } }> } };

export type ExportCorrectionReportMutationVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportCorrectionReportMutation = { __typename?: 'Mutation', exportCorrectionReport: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type GetBondsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetBondsQuery = { __typename?: 'Query', getBonds: { __typename?: 'GetBondsResult', totalPages: number, bonds?: Array<{ __typename?: 'Bond', _id?: string | null, name: string, symbol: string, interestRate: number, duration?: string | null, active: boolean, endDate?: number | null, paymentType?: string | null, paymentSchedules?: Array<string | null> | null, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null } };

export type DeleteBondMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteBondMutation = { __typename?: 'Mutation', deleteBond: boolean };

export type AddBondMutationVariables = Exact<{
  bond: AddBondInput;
}>;


export type AddBondMutation = { __typename?: 'Mutation', addBond: boolean };

export type EditBondMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  bond: EditBondInput;
}>;


export type EditBondMutation = { __typename?: 'Mutation', editBond: boolean };

export type PayoutPathInterestMutationVariables = Exact<{
  batchId: Scalars['String']['input'];
  bondId: Scalars['String']['input'];
}>;


export type PayoutPathInterestMutation = { __typename?: 'Mutation', payoutPathInterest: boolean };

export type GetBondQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetBondQuery = { __typename?: 'Query', getBond: { __typename?: 'Bond', _id?: string | null, name: string, symbol: string, interestRate: number, duration?: string | null, active: boolean, endDate?: number | null, paymentType?: string | null, paymentSchedules?: Array<string | null> | null, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null } };

export type BondHoldersQueryVariables = Exact<{
  bondId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type BondHoldersQuery = { __typename?: 'Query', bondHolders: { __typename?: 'BondHoldersResult', totalCount: number, totalAmount: number, holders: Array<{ __typename?: 'BondHolder', historyId: string, userId: string, lastName?: string | null, firstName?: string | null, phoneNo?: string | null, email?: string | null, registerNo?: string | null, taxPayerNo?: string | null, bondName?: string | null, interestRate?: number | null, principleAmount: number, fee?: number | null, purchaseDate: number, lastPayoutAt?: number | null, totalInterest?: number | null, totalTax?: number | null }> } };

export type BondPayoutHistoryQueryVariables = Exact<{
  bondId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type BondPayoutHistoryQuery = { __typename?: 'Query', bondPayoutHistory: { __typename?: 'BondPayoutHistoryResult', totalCount: number, payouts: Array<{ __typename?: 'BondPayoutEntry', userId: string, lastName?: string | null, firstName?: string | null, batchId: string, principleAmount: number, interest: number, taxAmount: number, createdAt: number }> } };

export type BondWithdrawalHistoryQueryVariables = Exact<{
  bondId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type BondWithdrawalHistoryQuery = { __typename?: 'Query', bondWithdrawalHistory: { __typename?: 'BondWithdrawalHistoryResult', totalCount: number, withdrawals: Array<{ __typename?: 'BondWithdrawalEntry', userId: string, lastName?: string | null, firstName?: string | null, amount: number, withdrawnAmount?: number | null, status: string, purchasedAt: number, createdAt: number }> } };

export type BondPayoutBatchesQueryVariables = Exact<{
  bondId: Scalars['ID']['input'];
}>;


export type BondPayoutBatchesQuery = { __typename?: 'Query', bondPayoutBatches: Array<{ __typename?: 'BondPayoutBatch', _id: string, batchId: string, status: string, totalTasks: number, completedTasks: number, failedTasks: number, initiatedBy?: string | null, startedAt: number, completedAt?: number | null }> };

export type GetConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigsQuery = { __typename?: 'Query', getConfigs?: Array<{ __typename?: 'Config', _id?: string | null, key: string, value: number, description: string }> | null };

export type EditConfigMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  config: EditConfigInput;
}>;


export type EditConfigMutation = { __typename?: 'Mutation', editConfig: boolean };

export type GetConfigByKeyQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type GetConfigByKeyQuery = { __typename?: 'Query', getConfigByKey: { __typename?: 'Config', _id?: string | null, key: string, value: number, description: string } };

export type GetUserDeletionRequestsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetUserDeletionRequestsQuery = { __typename?: 'Query', getUserDeletionRequests: { __typename?: 'GetUserDeletionRequestResponse', totalPages: number, requests: Array<{ __typename?: 'UserDeletionRequest', _id?: string | null, createdAt: number, user: { __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null, birthDate?: number | null, avatar?: string | null, role: Role, type?: UserType | null, riskLevel?: number | null, durationLevel?: Duration | null, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null }, bankInfo?: { __typename?: 'UserBankInfo', bankName?: string | null, accountNo?: string | null } | null } }> } };

export type GetFaqsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFaqsQuery = { __typename?: 'Query', getFaqs?: Array<{ __typename?: 'FAQ', _id?: string | null, question: string, answer: string }> | null };

export type GetFaqQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetFaqQuery = { __typename?: 'Query', getFaq: { __typename?: 'FAQ', _id?: string | null, question: string, answer: string } };

export type AddFaqMutationVariables = Exact<{
  faq: AddFaqInput;
}>;


export type AddFaqMutation = { __typename?: 'Mutation', addFaq: boolean };

export type EditFaqMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  faq: EditFaqInput;
}>;


export type EditFaqMutation = { __typename?: 'Mutation', editFaq: boolean };

export type DeleteFaqMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteFaqMutation = { __typename?: 'Mutation', deleteFaq: boolean };

export type GetGroupActivitiesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetGroupActivitiesQuery = { __typename?: 'Query', getGroupActivities: { __typename?: 'GetGroupActivitiesResult', totalPages: number, groupActivities: Array<{ __typename?: 'GroupActivity', _id?: string | null }> } };

export type GetGroupActivityQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetGroupActivityQuery = { __typename?: 'Query', getGroupActivity: { __typename?: 'GroupActivity', _id?: string | null, activities: Array<{ __typename?: 'Activity', _id?: string | null, title: string, body: string, createdAt: number }> } };

export type DeleteGroupActivityMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteGroupActivityMutation = { __typename?: 'Mutation', deleteGroupActivity: boolean };

export type SendGroupActivityMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type SendGroupActivityMutation = { __typename?: 'Mutation', sendGroupActivity: boolean };

export type GetImagesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetImagesQuery = { __typename?: 'Query', getImages: { __typename?: 'ImageListResult', totalPages: number, images?: Array<{ __typename?: 'Image', _id?: string | null, path: string }> | null } };

export type AddImageMutationVariables = Exact<{
  image: AddImageInput;
}>;


export type AddImageMutation = { __typename?: 'Mutation', addImage: boolean };

export type DeleteImageMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteImageMutation = { __typename?: 'Mutation', deleteImage: boolean };

export type GetKyCsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetKyCsQuery = { __typename?: 'Query', getKYCs: { __typename?: 'GetKYCsResult', totalPages: number, kycs?: Array<{ __typename?: 'KYC', _id?: string | null, registerNo: string, birthDate: number, address: string, user: { __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null, type?: UserType | null, birthDate?: number | null, role: Role, avatar?: string | null, riskLevel?: number | null, durationLevel?: Duration | null, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null } }, info: { __typename?: 'UserKYCInfo', status: Status, description?: string | null } }> | null } };

export type GetKycByUserQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetKycByUserQuery = { __typename?: 'Query', getKYCByUser: { __typename?: 'KYC', _id?: string | null, registerNo: string, taxPayerNo?: string | null, birthDate: number, address: string, imageUrls?: Array<string> | null, user: { __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null }, info: { __typename?: 'UserKYCInfo', status: Status, description?: string | null } } };

export type GetUserRegisterNoQueryVariables = Exact<{
  kycId: Scalars['ID']['input'];
}>;


export type GetUserRegisterNoQuery = { __typename?: 'Query', userRegisterNo: string };

export type GetUserTaxPayerNoQueryVariables = Exact<{
  kycId: Scalars['ID']['input'];
}>;


export type GetUserTaxPayerNoQuery = { __typename?: 'Query', userTaxPayerNo?: string | null };

export type GetUserAddressQueryVariables = Exact<{
  kycId: Scalars['ID']['input'];
}>;


export type GetUserAddressQuery = { __typename?: 'Query', userAddress: string };

export type DeleteKycMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteKycMutation = { __typename?: 'Mutation', deleteKYC: boolean };

export type EditKycMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  status: Status;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditKycMutation = { __typename?: 'Mutation', editKYC: boolean };

export type GetContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractsQuery = { __typename?: 'Query', adminContracts: Array<{ __typename?: 'Contract', name: string, previewUrl: string, createdAt: string, updatedAt?: string | null, portfolio?: { __typename?: 'Portfolio', _id?: string | null, localizedName?: { __typename?: 'LocalizedString', mn?: string | null } | null } | null }> };

export type RequestContractUploadMutationVariables = Exact<{
  name: Scalars['String']['input'];
  signatureImageName: Scalars['String']['input'];
  portfolioId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RequestContractUploadMutation = { __typename?: 'Mutation', requestContractUpload: string };

export type TriggerRecontractMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerRecontractMutation = { __typename?: 'Mutation', triggerRecontract: number };

export type GetUserContractsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserContractsQuery = { __typename?: 'Query', userContracts: Array<{ __typename?: 'UserContract', _id: string, contractName: string, contractNo: string, signedAt: string, version: number }> };

export type GetUserContractUrlQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  contractName: Scalars['String']['input'];
}>;


export type GetUserContractUrlQuery = { __typename?: 'Query', userContractUrl: string };

export type KycQuestionnaireSubQuestionFragment = { __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null };

export type KycQuestionnaireQuestionFragment = { __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null, subQuestions?: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null }> | null };

export type KycQuestionnaireFragment = { __typename?: 'KycQuestionnaire', _id: string, name: string, description: string, active: boolean, createdAt: number, updatedAt: number, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedDescription?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, questions: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null, subQuestions?: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null }> | null }> };

export type KycQuestionnaireSendFragment = { __typename?: 'KycQuestionnaireSend', _id: string, status: KycQuestionnaireSendStatus, sentAt: number, completedAt?: number | null, expiresAt?: number | null, notificationSent: boolean, createdAt: number, updatedAt: number, questionnaire?: { __typename?: 'KycQuestionnaire', _id: string, name: string } | null, user?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, phoneNo?: string | null, email?: string | null } | null, sentBy?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null } | null };

export type KycQuestionnaireAnswerFragment = { __typename?: 'KycQuestionnaireAnswer', questionId: string, type: KycQuestionType, textValue?: string | null, numberValue?: number | null, dateValue?: number | null, selectedOption?: string | null, selectedOptions?: Array<string> | null, additionalText?: string | null, filePath?: string | null, fileName?: string | null, fileUrl?: string | null };

export type KycQuestionnaireResponseFragment = { __typename?: 'KycQuestionnaireResponse', _id: string, send: string, submittedAt: number, createdAt: number, questionnaire?: { __typename?: 'KycQuestionnaire', _id: string, name: string, questions: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null, subQuestions?: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null }> | null }> } | null, user?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null } | null, answers: Array<{ __typename?: 'KycQuestionnaireAnswer', questionId: string, type: KycQuestionType, textValue?: string | null, numberValue?: number | null, dateValue?: number | null, selectedOption?: string | null, selectedOptions?: Array<string> | null, additionalText?: string | null, filePath?: string | null, fileName?: string | null, fileUrl?: string | null }> };

export type GetKycQuestionnairesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetKycQuestionnairesQuery = { __typename?: 'Query', getKycQuestionnaires: { __typename?: 'GetKycQuestionnairesResult', totalPages: number, questionnaires: Array<{ __typename?: 'KycQuestionnaire', _id: string, name: string, description: string, active: boolean, createdAt: number, updatedAt: number, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedDescription?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, questions: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null, subQuestions?: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null }> | null }> }> } };

export type GetKycQuestionnaireQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetKycQuestionnaireQuery = { __typename?: 'Query', getKycQuestionnaire: { __typename?: 'KycQuestionnaire', _id: string, name: string, description: string, active: boolean, createdAt: number, updatedAt: number, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedDescription?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, questions: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null, subQuestions?: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null }> | null }> } };

export type PreviewKycQuestionnaireSegmentQueryVariables = Exact<{
  segment: KycUserSegmentInput;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type PreviewKycQuestionnaireSegmentQuery = { __typename?: 'Query', previewKycQuestionnaireSegment: { __typename?: 'SegmentPreviewResult', userCount: number, users: Array<{ __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, phoneNo?: string | null, email?: string | null, type?: UserType | null, createdAt?: number | null, kycInfo: { __typename?: 'UserKYCInfo', status: Status } }> } };

export type GetKycQuestionnaireSendsQueryVariables = Exact<{
  questionnaireId: Scalars['ID']['input'];
  status?: InputMaybe<KycQuestionnaireSendStatus>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetKycQuestionnaireSendsQuery = { __typename?: 'Query', getKycQuestionnaireSends: { __typename?: 'GetKycQuestionnaireSendsResult', totalPages: number, sends: Array<{ __typename?: 'KycQuestionnaireSend', _id: string, status: KycQuestionnaireSendStatus, sentAt: number, completedAt?: number | null, expiresAt?: number | null, notificationSent: boolean, createdAt: number, updatedAt: number, questionnaire?: { __typename?: 'KycQuestionnaire', _id: string, name: string } | null, user?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, phoneNo?: string | null, email?: string | null } | null, sentBy?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type GetKycQuestionnaireSendQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetKycQuestionnaireSendQuery = { __typename?: 'Query', getKycQuestionnaireSend: { __typename?: 'KycQuestionnaireSend', _id: string, status: KycQuestionnaireSendStatus, sentAt: number, completedAt?: number | null, expiresAt?: number | null, notificationSent: boolean, createdAt: number, updatedAt: number, response?: { __typename?: 'KycQuestionnaireResponse', _id: string, send: string, submittedAt: number, createdAt: number, questionnaire?: { __typename?: 'KycQuestionnaire', _id: string, name: string, questions: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null, subQuestions?: Array<{ __typename?: 'KycQuestionnaireQuestion', _id: string, type: KycQuestionType, question: string, required: boolean, order: number, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, options?: Array<{ __typename?: 'KycQuestionnaireChoiceOption', value: string, requiresInput?: boolean | null, triggersSubQuestions?: boolean | null, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> | null }> | null }> } | null, user?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null } | null, answers: Array<{ __typename?: 'KycQuestionnaireAnswer', questionId: string, type: KycQuestionType, textValue?: string | null, numberValue?: number | null, dateValue?: number | null, selectedOption?: string | null, selectedOptions?: Array<string> | null, additionalText?: string | null, filePath?: string | null, fileName?: string | null, fileUrl?: string | null }> } | null, questionnaire?: { __typename?: 'KycQuestionnaire', _id: string, name: string } | null, user?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, phoneNo?: string | null, email?: string | null } | null, sentBy?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null } | null } };

export type GetKycQuestionnaireSendsByUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetKycQuestionnaireSendsByUserQuery = { __typename?: 'Query', getKycQuestionnaireSendsByUser: { __typename?: 'GetKycQuestionnaireSendsResult', totalPages: number, sends: Array<{ __typename?: 'KycQuestionnaireSend', _id: string, status: KycQuestionnaireSendStatus, sentAt: number, completedAt?: number | null, expiresAt?: number | null, notificationSent: boolean, createdAt: number, updatedAt: number, questionnaire?: { __typename?: 'KycQuestionnaire', _id: string, name: string } | null, user?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, phoneNo?: string | null, email?: string | null } | null, sentBy?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type AddKycQuestionnaireMutationVariables = Exact<{
  input: AddKycQuestionnaireInput;
}>;


export type AddKycQuestionnaireMutation = { __typename?: 'Mutation', addKycQuestionnaire: boolean };

export type EditKycQuestionnaireMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  input: EditKycQuestionnaireInput;
}>;


export type EditKycQuestionnaireMutation = { __typename?: 'Mutation', editKycQuestionnaire: boolean };

export type DeleteKycQuestionnaireMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteKycQuestionnaireMutation = { __typename?: 'Mutation', deleteKycQuestionnaire: boolean };

export type SendKycQuestionnaireToUserMutationVariables = Exact<{
  questionnaireId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type SendKycQuestionnaireToUserMutation = { __typename?: 'Mutation', sendKycQuestionnaireToUser: boolean };

export type SendKycQuestionnaireToSegmentMutationVariables = Exact<{
  questionnaireId: Scalars['ID']['input'];
  segment: KycUserSegmentInput;
}>;


export type SendKycQuestionnaireToSegmentMutation = { __typename?: 'Mutation', sendKycQuestionnaireToSegment: boolean };

export type SendKycQuestionnaireToAllUnrespondedMutationVariables = Exact<{
  questionnaireId: Scalars['ID']['input'];
}>;


export type SendKycQuestionnaireToAllUnrespondedMutation = { __typename?: 'Mutation', sendKycQuestionnaireToAllUnresponded: number };

export type PreviewKycQuestionnaireUnrespondedCountQueryVariables = Exact<{
  questionnaireId: Scalars['ID']['input'];
}>;


export type PreviewKycQuestionnaireUnrespondedCountQuery = { __typename?: 'Query', previewKycQuestionnaireUnrespondedCount: number };

export type ResendKycQuestionnaireMutationVariables = Exact<{
  sendId: Scalars['ID']['input'];
}>;


export type ResendKycQuestionnaireMutation = { __typename?: 'Mutation', resendKycQuestionnaire: boolean };

export type DispatchMonthlyFeesMutationVariables = Exact<{
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
}>;


export type DispatchMonthlyFeesMutation = { __typename?: 'Mutation', dispatchMonthlyFees: { __typename?: 'DispatchMonthlyFeeResult', dispatched: number, batchId: string } };

export type ApplyMonthlyFeesForUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
}>;


export type ApplyMonthlyFeesForUserMutation = { __typename?: 'Mutation', applyMonthlyFeesForUser: { __typename?: 'MonthlyFeeResult', processedCount: number, totalFeeAmount: number, skippedCount: number, errors: Array<{ __typename?: 'MonthlyFeeError', purchaseId: string, error: string }> } };

export type GetMscdApiAccountsQueryVariables = Exact<{
  filter?: InputMaybe<MscdApiAccountFilterInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetMscdApiAccountsQuery = { __typename?: 'Query', getMSCDApiAccounts: { __typename?: 'MSCDApiAccountsResult', totalItems: number, totalPages: number, accounts: Array<{ __typename?: 'MSCDApiAccount', _id: string, accountNumber: string, bdcId: string, bdcAccountId: string, firstName: string, lastName: string, registryNumber: string, clientSuffix: string, mitPrefix: string, country: string, customerType: string, type: string, createdDate: string, msxAccountId: string, syncedAt: number, updatedAt: number }> } };

export type SyncMscdAccountsMutationVariables = Exact<{
  beginDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type SyncMscdAccountsMutation = { __typename?: 'Mutation', syncMSCDAccounts: { __typename?: 'SyncMSCDAccountsResult', synced: number, upserted: number, modified: number } };

export type ExportMscdApiAccountsExcelMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportMscdApiAccountsExcelMutation = { __typename?: 'Mutation', exportMSCDApiAccountsExcel: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type DispatchAccountCreationForDepositorsMutationVariables = Exact<{
  startDate?: InputMaybe<Scalars['Float']['input']>;
}>;


export type DispatchAccountCreationForDepositorsMutation = { __typename?: 'Mutation', dispatchAccountCreationForDepositors: { __typename?: 'DispatchAccountCreationResult', dispatched: number, skipped: number } };

export type FixMscdAccountNoMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type FixMscdAccountNoMutation = { __typename?: 'Mutation', fixMSCDAccountNo: string };

export type UpdateMscdAccountNoMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  accountNo: Scalars['String']['input'];
}>;


export type UpdateMscdAccountNoMutation = { __typename?: 'Mutation', updateMSCDAccountNo: boolean };

export type FixAndRetryMscdAccountMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  bankAccountNo?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type FixAndRetryMscdAccountMutation = { __typename?: 'Mutation', fixAndRetryMSCDAccount: boolean };

export type GetMscdErrorAccountsQueryVariables = Exact<{
  beginDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetMscdErrorAccountsQuery = { __typename?: 'Query', getMSCDErrorAccounts: Array<{ __typename?: 'MSCDErrorAccount', PkId: number, BDCAccountId: string, BDCAccountNumber: number, RegistryNumber: string, FirstName: string, LastName: string, BirthDate?: string | null, Gender?: string | null, HomePhone?: string | null, MobilePhone?: string | null, Occupation?: string | null, HomeAddress?: string | null, BankCode?: string | null, BankName?: string | null, BankAccountNumber?: number | null, Status: number, ErrorMessage?: string | null, RecievedDate?: string | null, CheckStatus?: number | null, localUserId?: string | null, localAccountNo?: string | null, localFirstName?: string | null, localLastName?: string | null, localRegisterNo?: string | null, localBankCode?: string | null, localBankName?: string | null, localBankAccountNo?: string | null, localPhoneNo?: string | null, localBirthDate?: string | null, localGender?: string | null, localOccupation?: string | null, localHomeAddress?: string | null }> };

export type SearchUserForMscdLinkQueryVariables = Exact<{
  bdcAccountId: Scalars['String']['input'];
  bdcAccountNumber: Scalars['Int']['input'];
  registerNo?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchUserForMscdLinkQuery = { __typename?: 'Query', searchUserForMSCDLink?: { __typename?: 'MSCDLinkCandidate', userId: string, firstName?: string | null, lastName?: string | null, phoneNo?: string | null, email?: string | null, matchedBy: string, existingAccountNo?: string | null } | null };

export type LinkMscdErrorAccountMutationVariables = Exact<{
  bdcAccountId: Scalars['String']['input'];
  bdcAccountNumber: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
}>;


export type LinkMscdErrorAccountMutation = { __typename?: 'Mutation', linkMSCDErrorAccount: boolean };

export type GetOrdersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  advanced: GetOrders;
}>;


export type GetOrdersQuery = { __typename?: 'Query', getOrders: { __typename?: 'GetOrderHistoryResult', totalPages: number, orders?: Array<{ __typename?: 'Order', _id?: string | null, status: OrderStatus, type: OrderType, amount: number, description: string, beforeBalance: number, afterBalance: number, isReturnable: boolean, createdAt: number, updatedAt?: number | null, user: { __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, birthDate?: number | null, email?: string | null, phoneNo?: string | null, role: Role, avatar?: string | null, riskLevel?: number | null, durationLevel?: Duration | null, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null }, chosenPortfolio?: { __typename?: 'Portfolio', _id?: string | null, index: number, riskLevel: number, duration: Duration, stocks: Array<{ __typename?: 'PortfolioStock', value: number, stock: { __typename?: 'Stock', _id?: string | null, name: string, symbol: string, type: StockType } }>, bond: { __typename?: 'PortfolioBond', value: number }, saving: { __typename?: 'PortfolioSaving', value: number } } | null } }> | null } };

export type AddOrderMutationVariables = Exact<{
  order: AddOrderInput;
}>;


export type AddOrderMutation = { __typename?: 'Mutation', addOrder: boolean };

export type RemoveOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveOrderMutation = { __typename?: 'Mutation', removeOrder: boolean };

export type ReturnOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ReturnOrderMutation = { __typename?: 'Mutation', returnOrder: boolean };

export type BulkAddOrderMutationVariables = Exact<{
  input: BulkAddOrderInput;
}>;


export type BulkAddOrderMutation = { __typename?: 'Mutation', bulkAddOrder: { __typename?: 'BulkAddOrderResult', batchId?: string | null, totalRows: number, validRows: number, invalidRows: number, totalAmount: number, fileUrl?: string | null, rows: Array<{ __typename?: 'BulkAddOrderRowResult', row: number, email?: string | null, amount?: number | null, description?: string | null, status: BulkAddOrderRowStatus, errorCode?: string | null, errorMessage?: string | null, user?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type GetBulkAddOrderBatchQueryVariables = Exact<{
  batchId: Scalars['ID']['input'];
}>;


export type GetBulkAddOrderBatchQuery = { __typename?: 'Query', getBulkAddOrderBatch: { __typename?: 'BulkAddOrderBatch', batchId: string, filename: string, fileUrl?: string | null, totalRows: number, pendingCount: number, successCount: number, failedCount: number, revertedCount: number, totalAmount: number, status: BulkAddOrderBatchStatus, createdAt: number, updatedAt: number, rows: Array<{ __typename?: 'BulkAddOrderBatchRow', rowNumber: number, email: string, amount: number, description: string, status: BulkAddOrderBatchRowStatus, orderId?: string | null, errorCode?: string | null, errorMessage?: string | null, processedAt?: number | null, reverted: boolean, user?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type RevertBulkAddOrderBatchMutationVariables = Exact<{
  batchId: Scalars['ID']['input'];
}>;


export type RevertBulkAddOrderBatchMutation = { __typename?: 'Mutation', revertBulkAddOrderBatch: { __typename?: 'BulkAddOrderBatch', batchId: string, status: BulkAddOrderBatchStatus, successCount: number, failedCount: number, revertedCount: number } };

export type GetOrderListsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  status: OrderListStatus;
}>;


export type GetOrderListsQuery = { __typename?: 'Query', orderLists: { __typename?: 'PaginatedOrderListSummary', totalPages: number, orderLists: Array<{ __typename?: 'OrderListSummary', _id: string, index: string, status: OrderListStatus, totalPurchases: number, createdAt: string, updatedAt?: string | null }> } };

export type CreateOrderListMutationVariables = Exact<{
  balances: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  usdRate: Scalars['Float']['input'];
}>;


export type CreateOrderListMutation = { __typename?: 'Mutation', createOrderList: boolean };

export type PrepareOrderListMutationVariables = Exact<{
  balances: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PrepareOrderListMutation = { __typename?: 'Mutation', prepareOrderList: { __typename?: 'PrepareOrderListResult', bond: number, savings: number, stocks: Array<{ __typename?: 'PrepareOrderListStock', symbol: string, type: StockType, totalPrice: number }> } };

export type GenerateOrderListDetailMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GenerateOrderListDetailMutation = { __typename?: 'Mutation', generateOrderListDetail: string };

export type GenerateOrderListOrdersMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GenerateOrderListOrdersMutation = { __typename?: 'Mutation', generateOrderListOrders: string };

export type RegenerateOrderListFileMutationVariables = Exact<{
  orderListId: Scalars['ID']['input'];
}>;


export type RegenerateOrderListFileMutation = { __typename?: 'Mutation', regenerateOrderListFile: string };

export type GenerateOrderListDetailPerUserMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GenerateOrderListDetailPerUserMutation = { __typename?: 'Mutation', generateOrderListDetailPerUser: string };

export type GetOrderListQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetOrderListQuery = { __typename?: 'Query', getOrderList: { __typename?: 'OrderList', _id?: string | null, status: OrderListStatus, type?: PurchaseType | null, createdAt: number, updatedAt?: number | null, purchases?: Array<{ __typename?: 'Purchase', _id?: string | null }> | null, totalPurchases: { __typename?: 'TotalPurchases', cashAmount: number, stocks: Array<{ __typename?: 'TotalStock', usdRate: number, totalPrice: number, availableTotalPrice: number, stock: { __typename?: 'Stock', _id?: string | null, name: string, symbol: string, type: StockType } }>, bond: { __typename?: 'TotalBond', amount: number }, saving: { __typename?: 'TotalSaving', amount: number } } } };

export type DownloadOrderListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DownloadOrderListQuery = { __typename?: 'Query', getOrderList: { __typename?: 'OrderList', fileUrl?: string | null } };

export type ConfirmOrderListMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  totalPurchases: AddPurchasesInput;
}>;


export type ConfirmOrderListMutation = { __typename?: 'Mutation', confirmOrderList: boolean };

export type ReleaseHoldAmountMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type ReleaseHoldAmountMutation = { __typename?: 'Mutation', releaseHoldAmount: boolean };

export type ReleaseHoldAmountForOrderListMutationVariables = Exact<{
  orderListId: Scalars['ID']['input'];
}>;


export type ReleaseHoldAmountForOrderListMutation = { __typename?: 'Mutation', releaseHoldAmountForOrderList: number };

export type RequestOtpMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type RequestOtpMutation = { __typename?: 'Mutation', requestOtp: { __typename?: 'RequestOtpResult', sent: boolean, retryAfter: number, challenge: string } };

export type RecoverOtpMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type RecoverOtpMutation = { __typename?: 'Mutation', recoverOtp: boolean };

export type GetPortfolioQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetPortfolioQuery = { __typename?: 'Query', getPortfolio: { __typename?: 'Portfolio', _id?: string | null, active: boolean, name?: string | null, description?: string | null, index: number, riskLevel: number, duration: Duration, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedDescription?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, stocks: Array<{ __typename?: 'PortfolioStock', value: number, stock: { __typename?: 'Stock', _id?: string | null, name: string, description: string, symbol: string, type: StockType, localizedName: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null }, localizedDescription: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } } }>, bond: { __typename?: 'PortfolioBond', value: number }, saving: { __typename?: 'PortfolioSaving', value: number } } };

export type GetAllPortfoliosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPortfoliosQuery = { __typename?: 'Query', getAllPortfolios?: Array<{ __typename?: 'Portfolio', _id?: string | null, active: boolean, name?: string | null, description?: string | null, index: number, riskLevel: number, duration: Duration, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedDescription?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, stocks: Array<{ __typename?: 'PortfolioStock', value: number, stock: { __typename?: 'Stock', _id?: string | null, name: string, description: string, symbol: string, type: StockType, localizedName: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null }, localizedDescription: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } } }>, bond: { __typename?: 'PortfolioBond', value: number }, saving: { __typename?: 'PortfolioSaving', value: number } }> | null };

export type GetPortfoliosQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetPortfoliosQuery = { __typename?: 'Query', getPortfolios: { __typename?: 'GetPortfoliosResult', totalPages: number, portfolios?: Array<{ __typename?: 'Portfolio', _id?: string | null, active: boolean, name?: string | null, description?: string | null, index: number, riskLevel: number, duration: Duration, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedDescription?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, stocks: Array<{ __typename?: 'PortfolioStock', value: number, stock: { __typename?: 'Stock', _id?: string | null, name: string, description: string, symbol: string, type: StockType, localizedName: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null }, localizedDescription: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } } }>, bond: { __typename?: 'PortfolioBond', value: number }, saving: { __typename?: 'PortfolioSaving', value: number } }> | null } };

export type AddPortfolioMutationVariables = Exact<{
  portfolio: AddPortfolioInput;
}>;


export type AddPortfolioMutation = { __typename?: 'Mutation', addPortfolio: boolean };

export type EditPortfolioMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  portfolio: EditPortfolioInput;
}>;


export type EditPortfolioMutation = { __typename?: 'Mutation', editPortfolio: boolean };

export type DeletePortfolioMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeletePortfolioMutation = { __typename?: 'Mutation', deletePortfolio: boolean };

export type InterestPayoutReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type InterestPayoutReportsQuery = { __typename?: 'Query', interestPayoutReports: Array<{ __typename?: 'ReportSummary', batchId: string }> };

export type DownloadInterestPayoutReportMutationVariables = Exact<{
  batchId: Scalars['String']['input'];
}>;


export type DownloadInterestPayoutReportMutation = { __typename?: 'Mutation', downloadInterestPayoutReport: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type FeeReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeeReportsQuery = { __typename?: 'Query', feeReports: Array<{ __typename?: 'ReportSummary', batchId: string }> };

export type DownloadFeeReportMutationVariables = Exact<{
  batchId: Scalars['String']['input'];
}>;


export type DownloadFeeReportMutation = { __typename?: 'Mutation', downloadFeeReport: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type ExportFeeReportForDateRangeMutationVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportFeeReportForDateRangeMutation = { __typename?: 'Mutation', exportFeeReportForDateRange: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type ExportInterestPayoutReportForDateRangeMutationVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ExportInterestPayoutReportForDateRangeMutation = { __typename?: 'Mutation', exportInterestPayoutReportForDateRange: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type ExportInterestPayoutReportMutationVariables = Exact<{
  batchId: Scalars['String']['input'];
}>;


export type ExportInterestPayoutReportMutation = { __typename?: 'Mutation', exportInterestPayoutReport: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type ExportFeeReportMutationVariables = Exact<{
  batchId: Scalars['String']['input'];
}>;


export type ExportFeeReportMutation = { __typename?: 'Mutation', exportFeeReport: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type GetSavingsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetSavingsQuery = { __typename?: 'Query', getSavings: { __typename?: 'GetSavingsResult', totalPages: number, savings?: Array<{ __typename?: 'Saving', _id?: string | null, accountNo: string, bankName: string, currency: Currency, balance: number, interestRate: number }> | null } };

export type GetSavingQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetSavingQuery = { __typename?: 'Query', getSaving: { __typename?: 'Saving', _id?: string | null, accountNo: string, bankName: string, currency: Currency, balance: number, interestRate: number } };

export type AddSavingMutationVariables = Exact<{
  saving: AddSavingInput;
}>;


export type AddSavingMutation = { __typename?: 'Mutation', addSaving: boolean };

export type EditSavingMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  saving: EditSavingInput;
}>;


export type EditSavingMutation = { __typename?: 'Mutation', editSaving: boolean };

export type DeleteSavingMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteSavingMutation = { __typename?: 'Mutation', deleteSaving: boolean };

export type GetStocksQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetStocksQuery = { __typename?: 'Query', getStocks: { __typename?: 'GetStocksResult', totalPages: number, stocks?: Array<{ __typename?: 'Stock', _id?: string | null, name: string, description: string, url?: string | null, symbol: string, type: StockType, localizedName: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null }, localizedDescription: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null }, image?: { __typename?: 'Image', path: string } | null }> | null } };

export type GetAllStocksListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStocksListQuery = { __typename?: 'Query', getStocks: { __typename?: 'GetStocksResult', stocks?: Array<{ __typename?: 'Stock', _id?: string | null, name: string }> | null } };

export type DeleteStockMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteStockMutation = { __typename?: 'Mutation', deleteStock: boolean };

export type AddStockMutationVariables = Exact<{
  stock: AddStockInput;
}>;


export type AddStockMutation = { __typename?: 'Mutation', addStock: boolean };

export type EditStockMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  stock: EditStockInput;
}>;


export type EditStockMutation = { __typename?: 'Mutation', editStock: boolean };

export type GetStockQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetStockQuery = { __typename?: 'Query', getStock: { __typename?: 'Stock', _id?: string | null, name: string, description: string, url?: string | null, symbol: string, type: StockType, localizedName: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null }, localizedDescription: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null }, image?: { __typename?: 'Image', path: string } | null } };

export type GetDividendReportsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetDividendReportsQuery = { __typename?: 'Query', dividendReports: { __typename?: 'PaginatedDividendReports', totalPages: number, reports: Array<{ __typename?: 'DividendReport', id: string, recordDate: string, amount: number, totalAmount: number, createdAt: string, stock: { __typename?: 'Stock', symbol: string } }> } };

export type PrepareDividendReportMutationVariables = Exact<{
  stockId: Scalars['ID']['input'];
  recordDate: Scalars['String']['input'];
  dividend: Scalars['Float']['input'];
}>;


export type PrepareDividendReportMutation = { __typename?: 'Mutation', prepareDividendReport: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type DistributeDividendsMutationVariables = Exact<{
  stockId: Scalars['ID']['input'];
  recordDate: Scalars['String']['input'];
  dividend: Scalars['Float']['input'];
  expectedTotalDividend: Scalars['Float']['input'];
}>;


export type DistributeDividendsMutation = { __typename?: 'Mutation', distributeDividends: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type AddSuggestionMutationVariables = Exact<{
  suggestion: AddSuggestionInput;
}>;


export type AddSuggestionMutation = { __typename?: 'Mutation', addSuggestion: boolean };

export type DeleteSuggestionMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteSuggestionMutation = { __typename?: 'Mutation', deleteSuggestion: boolean };

export type SuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuggestionsQuery = { __typename?: 'Query', suggestions?: Array<{ __typename?: 'Suggestion', _id: string, title?: string | null, description?: string | null, url?: string | null, expireAt: number, suggestionCount: number, stocks: Array<string>, portfolioInfos: Array<{ __typename?: 'PortfolioInfo', currentId?: string | null, changeId?: string | null } | null> }> | null };

export type GetSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSurveysQuery = { __typename?: 'Query', getSurveys?: Array<{ __typename?: 'Survey', _id: string, name: string, active: boolean, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, questions: Array<{ __typename?: 'Question', question: string, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, answers: Array<{ __typename?: 'Answer', value: string, durationPoints: number, riskPoints: number, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> }> }> | null };

export type GetSurveyQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetSurveyQuery = { __typename?: 'Query', getSurvey: { __typename?: 'Survey', _id: string, name: string, introText: string, completeText: string, active: boolean, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedIntroText?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedCompleteText?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, questions: Array<{ __typename?: 'Question', question: string, localizedQuestion?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, answers: Array<{ __typename?: 'Answer', value: string, durationPoints: number, riskPoints: number, localizedValue?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null }> }> } };

export type AddSurveyMutationVariables = Exact<{
  survey: AddSurveyInput;
}>;


export type AddSurveyMutation = { __typename?: 'Mutation', addSurvey: boolean };

export type EditSurveyMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  survey: EditSurveyInput;
}>;


export type EditSurveyMutation = { __typename?: 'Mutation', editSurvey: boolean };

export type DeleteSurveyMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteSurveyMutation = { __typename?: 'Mutation', deleteSurvey: boolean };

export type GetUnmatchedDepositsQueryVariables = Exact<{
  status?: InputMaybe<UnmatchedDepositStatus>;
  bank?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUnmatchedDepositsQuery = { __typename?: 'Query', unmatchedDeposits: { __typename?: 'UnmatchedDepositsResult', total: number, items: Array<{ __typename?: 'UnmatchedDeposit', _id: string, bank: string, account: string, amount: number, currency: string, transactionDate: string, transactionDescription: string, transactionUniqueId: string, reason: UnmatchedDepositReason, parsedExternalId?: string | null, status: UnmatchedDepositStatus, matchedDepositId?: string | null, matchedBy?: string | null, matchedAt?: string | null, createdAt: string }> } };

export type MatchUnmatchedDepositMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type MatchUnmatchedDepositMutation = { __typename?: 'Mutation', matchUnmatchedDeposit: boolean };

export type DismissUnmatchedDepositMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DismissUnmatchedDepositMutation = { __typename?: 'Mutation', dismissUnmatchedDeposit: boolean };

export type UserFragment = { __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null, birthDate?: number | null, role: Role, type?: UserType | null, riskLevel?: number | null, contractDate?: string | null, durationLevel?: Duration | null, mscdLastError?: string | null, isFrozen: boolean, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null }, bankInfo?: { __typename?: 'UserBankInfo', bankName?: string | null, bankCode?: string | null, accountNo?: string | null, accountName?: string | null } | null };

export type ChosenPortfolioFragment = { __typename?: 'Portfolio', _id?: string | null, active: boolean, name?: string | null, description?: string | null, index: number, riskLevel: number, duration: Duration, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedDescription?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, stocks: Array<{ __typename?: 'PortfolioStock', value: number, stock: { __typename?: 'Stock', _id?: string | null, name: string, symbol: string, type: StockType } }>, bond: { __typename?: 'PortfolioBond', value: number }, saving: { __typename?: 'PortfolioSaving', value: number } };

export type AddUserMutationVariables = Exact<{
  user: AddUserInput;
}>;


export type AddUserMutation = { __typename?: 'Mutation', addUser: boolean };

export type EditUserMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  user: EditUserInput;
}>;


export type EditUserMutation = { __typename?: 'Mutation', editUser: boolean };

export type DeleteUserMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type EditUserPortfolioMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  portfolioId: Scalars['ID']['input'];
}>;


export type EditUserPortfolioMutation = { __typename?: 'Mutation', editUserPortfolio: boolean };

export type CereateMscdAccountMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type CereateMscdAccountMutation = { __typename?: 'Mutation', internal__createMSCDAccount: boolean };

export type UpdateUserBankInfoMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  bankInfo: BankInfo;
}>;


export type UpdateUserBankInfoMutation = { __typename?: 'Mutation', updateUserBankInfo: boolean };

export type FreezeUserMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type FreezeUserMutation = { __typename?: 'Mutation', freezeUser: boolean };

export type UnfreezeUserMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type UnfreezeUserMutation = { __typename?: 'Mutation', unfreezeUser: boolean };

export type GetUsersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  advanced: AdvancedSearchInput;
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: { __typename?: 'GetUsersResult', totalPages: number, users?: Array<{ __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null, birthDate?: number | null, role: Role, type?: UserType | null, riskLevel?: number | null, contractDate?: string | null, durationLevel?: Duration | null, mscdLastError?: string | null, isFrozen: boolean, chosenPortfolio?: { __typename?: 'Portfolio', _id?: string | null, active: boolean, name?: string | null, description?: string | null, index: number, riskLevel: number, duration: Duration, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedDescription?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, stocks: Array<{ __typename?: 'PortfolioStock', value: number, stock: { __typename?: 'Stock', _id?: string | null, name: string, symbol: string, type: StockType } }>, bond: { __typename?: 'PortfolioBond', value: number }, saving: { __typename?: 'PortfolioSaving', value: number } } | null, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null }, bankInfo?: { __typename?: 'UserBankInfo', bankName?: string | null, bankCode?: string | null, accountNo?: string | null, accountName?: string | null } | null }> | null } };

export type GetUserQueryVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'User', depositCode: string, dbxAccountNumber?: string | null, _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null, birthDate?: number | null, role: Role, type?: UserType | null, riskLevel?: number | null, contractDate?: string | null, durationLevel?: Duration | null, mscdLastError?: string | null, isFrozen: boolean, chosenPortfolio?: { __typename?: 'Portfolio', _id?: string | null, active: boolean, name?: string | null, description?: string | null, index: number, riskLevel: number, duration: Duration, localizedName?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, localizedDescription?: { __typename?: 'LocalizedString', en?: string | null, mn?: string | null } | null, stocks: Array<{ __typename?: 'PortfolioStock', value: number, stock: { __typename?: 'Stock', _id?: string | null, name: string, symbol: string, type: StockType } }>, bond: { __typename?: 'PortfolioBond', value: number }, saving: { __typename?: 'PortfolioSaving', value: number } } | null, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null }, bankInfo?: { __typename?: 'UserBankInfo', bankName?: string | null, bankCode?: string | null, accountNo?: string | null, accountName?: string | null } | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null, birthDate?: number | null, role: Role, type?: UserType | null, riskLevel?: number | null, contractDate?: string | null, durationLevel?: Duration | null, mscdLastError?: string | null, isFrozen: boolean, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null }, bankInfo?: { __typename?: 'UserBankInfo', bankName?: string | null, bankCode?: string | null, accountNo?: string | null, accountName?: string | null } | null } };

export type GetMscdAccountStatusQueryVariables = Exact<{
  accountNo: Scalars['String']['input'];
}>;


export type GetMscdAccountStatusQuery = { __typename?: 'Query', getMscdAccountStatus: string };

export type GetUserMscdApiAccountQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserMscdApiAccountQuery = { __typename?: 'Query', getUserMSCDApiAccount?: { __typename?: 'MSCDApiAccount', _id: string, accountNumber: string, bdcAccountId: string, registryNumber: string, firstName: string, lastName: string, createdDate: string, syncedAt: number } | null };

export type GetUserMscdAccountQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserMscdAccountQuery = { __typename?: 'Query', getUserMSCDAccount?: { __typename?: 'MSCDAccountInfo', _id: string, accountNo: string, accountSequentialId: number, status: BrokerAccountStatus, lastError?: string | null, lastAttemptAt?: number | null, attemptCount: number, createdAt: number, updatedAt: number, mscdStatus?: string | null, mscdErrorMessage?: string | null } | null };

export type RetryMscdAccountCreationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type RetryMscdAccountCreationMutation = { __typename?: 'Mutation', retryMSCDAccountCreation: boolean };

export type GetDashboardDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardDataQuery = { __typename?: 'Query', getDashboardData: { __typename?: 'DashboardData', totalUser: number, totalValue: number, totalInvestment: number, totalWaitingOrders: number, totalReadyToInvest: number, totalWithdrawal: number, totalFee: number, depositChartData: Array<{ __typename?: 'DailyAmount', date: string, amount: number }>, bondInterestChartData: Array<{ __typename?: 'DailyAmount', date: string, amount: number }>, withdrawalChartData: Array<{ __typename?: 'DailyAmount', date: string, amount: number }> } };

export type GetUsersExcelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersExcelQuery = { __typename?: 'Query', getUsersExcel: Array<{ __typename?: 'UserExcelData', address?: string | null, email?: string | null, lastName?: string | null, firstName?: string | null, registerNo?: string | null, phoneNo?: string | null, portfolioIndex?: number | null, bond?: number | null, vde?: number | null, vxf?: number | null, fx?: number | null, dia?: number | null, vti?: number | null, vug?: number | null, estate?: number | null, xoz?: number | null }> };

export type UserWithdrawalRequestsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserWithdrawalRequestsQuery = { __typename?: 'Query', userWithdrawalRequests: Array<{ __typename?: 'WithdrawalRequest', _id: string, status: WithdrawalStatus, createdAt: number, updatedAt: number, releasedCashAmount?: number | null, releasedHoldAmount?: number | null, stocks: Array<{ __typename?: 'WithdrawalRequestStock', quantity: number, purchasedAt: number, stock: { __typename?: 'Stock', symbol: string, localizedName: { __typename?: 'LocalizedString', en?: string | null } } }>, bonds: Array<{ __typename?: 'WithdrawalRequestBond', amount: number, purchasedAt: number, bond: { __typename?: 'Bond', name: string } }>, estate: Array<{ __typename?: 'WithdrawalRequestEstate', amount: number, purchasedAt: number, estate: { __typename?: 'Saving', bankName: string, description?: string | null } }>, confirmationDetail?: Array<{ __typename?: 'WithdrawalConfirmationDetail', stocks?: Array<{ __typename?: 'WithdrawalDetailConfirmationStock', assetId: string, totalPrice: number, totalAmount: number, totalComission: number, totalFee: number } | null> | null, bonds?: Array<{ __typename?: 'WithdrawalDetailConfirmationBond', assetId: string, principleAmount: number, interestAmount: number, taxAmount: number, feeAmount: number, totalAmount: number } | null> | null, estate?: Array<{ __typename?: 'WithdrawalDetailConfirmationEstate', assetId: string, principleAmount: number, interestAmount: number, taxAmount: number, feeAmount: number, totalAmount: number } | null> | null } | null> | null }> };

export type DownloadUserWithdrawalsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type DownloadUserWithdrawalsMutation = { __typename?: 'Mutation', downloadUserWithdrawals: string };

export type ExportUserDetailedReportV2MutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ExportUserDetailedReportV2Mutation = { __typename?: 'Mutation', exportUserDetailedReportV2: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type ExportClientReportMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ExportClientReportMutation = { __typename?: 'Mutation', exportClientReport: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type ExportSecuritiesCustomersExcelMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportSecuritiesCustomersExcelMutation = { __typename?: 'Mutation', exportSecuritiesCustomersExcel: { __typename?: 'PrepareReportResult', reportUrl: string } };

export type CancelWithdrawalRequestMutationVariables = Exact<{
  requestId: Scalars['ID']['input'];
}>;


export type CancelWithdrawalRequestMutation = { __typename?: 'Mutation', cancelWithdrawalRequest: boolean };

export type DeleteContractMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteContractMutation = { __typename?: 'Mutation', deleteContract: boolean };

export type CreateWithdrawalOrderListMutationVariables = Exact<{
  withdrawalRequestIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateWithdrawalOrderListMutation = { __typename?: 'Mutation', createWithdrawalOrderList: boolean };

export type DownloadWithdrawalOrderListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DownloadWithdrawalOrderListQuery = { __typename?: 'Query', downloadWithdrawalOrderList: string };

export type WithdrawalRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WithdrawalRequestQuery = { __typename?: 'Query', withdrawalRequest?: { __typename?: 'WithdrawalRequest', _id: string, status: WithdrawalStatus, createdAt: number, updatedAt: number, user: { __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null, birthDate?: number | null, role: Role, type?: UserType | null, riskLevel?: number | null, contractDate?: string | null, durationLevel?: Duration | null, mscdLastError?: string | null, isFrozen: boolean, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null }, bankInfo?: { __typename?: 'UserBankInfo', bankName?: string | null, bankCode?: string | null, accountNo?: string | null, accountName?: string | null } | null }, stocks: Array<{ __typename?: 'WithdrawalRequestStock', quantity: number, withdrawnAmount?: number | null, stock: { __typename?: 'Stock', name: string, unitPrice: number, symbol: string } }>, bonds: Array<{ __typename?: 'WithdrawalRequestBond', amount: number, balanceHistoryRecordId: string, withdrawnAmount?: number | null, bond: { __typename?: 'Bond', name: string } }>, estate: Array<{ __typename?: 'WithdrawalRequestEstate', amount: number, balanceHistoryRecordId: string, withdrawnAmount?: number | null, estate: { __typename?: 'Saving', bankName: string } }> } | null };

export type AllPendingWithdrawalRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPendingWithdrawalRequestsQuery = { __typename?: 'Query', allPendingWithdrawalRequests: Array<{ __typename?: 'PendingWithdrawalRequest', _id: string, username: string, portfolioIndex: number }> };

export type AllWithdrawalRequestsQueryVariables = Exact<{
  status?: InputMaybe<WithdrawalStatus>;
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  search: Scalars['String']['input'];
}>;


export type AllWithdrawalRequestsQuery = { __typename?: 'Query', allWithdrawalRequests?: { __typename?: 'WithdrawalRequestList', totalItems: number, requests: Array<{ __typename?: 'WithdrawalRequest', _id: string, status: WithdrawalStatus, withdrawalType?: WithdrawalType | null, releasedHoldAmount?: number | null, releasedCashAmount?: number | null, createdAt: number, updatedAt: number, user: { __typename?: 'User', _id: string, lastName?: string | null, firstName?: string | null, email?: string | null, phoneNo?: string | null, birthDate?: number | null, role: Role, type?: UserType | null, riskLevel?: number | null, contractDate?: string | null, durationLevel?: Duration | null, mscdLastError?: string | null, isFrozen: boolean, kycInfo: { __typename?: 'UserKYCInfo', status: Status, description?: string | null }, bankInfo?: { __typename?: 'UserBankInfo', bankName?: string | null, bankCode?: string | null, accountNo?: string | null, accountName?: string | null } | null }, stocks: Array<{ __typename?: 'WithdrawalRequestStock', quantity: number, withdrawnAmount?: number | null, stock: { __typename?: 'Stock', name: string, unitPrice: number } }>, bonds: Array<{ __typename?: 'WithdrawalRequestBond', amount: number, balanceHistoryRecordId: string, withdrawnAmount?: number | null, bond: { __typename?: 'Bond', name: string } }>, estate: Array<{ __typename?: 'WithdrawalRequestEstate', amount: number, balanceHistoryRecordId: string, withdrawnAmount?: number | null, estate: { __typename?: 'Saving', bankName: string } }> }> } | null };

export type WithdrawalOrderListsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  status?: InputMaybe<WithdrawalStatus>;
}>;


export type WithdrawalOrderListsQuery = { __typename?: 'Query', withdrawalOrderLists: { __typename?: 'WithdrawalOrderListData', totalItems: number, data: Array<{ __typename?: 'WithdrawalOrderList', _id: string, status: WithdrawalStatus, createdAt: number, updatedAt: number, stockTotals: Array<{ __typename?: 'WithdrawalOrderListStockTotals', totalQuantity: number, stock: { __typename?: 'Stock', description: string, name: string, unitPrice: number, symbol: string } }>, bondTotals: Array<{ __typename?: 'WithdrawalOrderListBondTotals', totalAmount: number, asset: { __typename?: 'Bond', _id?: string | null, active: boolean, name: string, description?: string | null, symbol: string, interestRate: number } }>, estateTotals: Array<{ __typename?: 'WithdrawalOrderListEstateTotals', totalAmount: number, asset: { __typename?: 'Saving', _id?: string | null, balance: number, currency: Currency, description?: string | null, bankName: string, accountNo: string, interestRate: number } }>, withdrawalRequests: Array<{ __typename?: 'WithdrawalRequest', _id: string }> }> } };

export type WithdrawalOrderListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WithdrawalOrderListQuery = { __typename?: 'Query', withdrawalOrderList?: { __typename?: 'WithdrawalOrderList', _id: string, status: WithdrawalStatus, createdAt: number, updatedAt: number, stockTotals: Array<{ __typename?: 'WithdrawalOrderListStockTotals', totalQuantity: number, stock: { __typename?: 'Stock', description: string, name: string, unitPrice: number, symbol: string } }>, bondTotals: Array<{ __typename?: 'WithdrawalOrderListBondTotals', totalAmount: number, asset: { __typename?: 'Bond', _id?: string | null, active: boolean, name: string, description?: string | null, symbol: string, interestRate: number } }>, estateTotals: Array<{ __typename?: 'WithdrawalOrderListEstateTotals', totalAmount: number, asset: { __typename?: 'Saving', _id?: string | null, balance: number, currency: Currency, description?: string | null, bankName: string, accountNo: string, interestRate: number } }>, withdrawalRequests: Array<{ __typename?: 'WithdrawalRequest', _id: string, releasedCashAmount?: number | null, releasedHoldAmount?: number | null, user: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNo?: string | null } }> } | null };

export type PreviewWithdrawalOrderListQueryVariables = Exact<{
  withdrawalRequestIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PreviewWithdrawalOrderListQuery = { __typename?: 'Query', previewWithdrawalOrderList: { __typename?: 'WithdrawalOrderListTotals', stockTotals: Array<{ __typename?: 'WithdrawalOrderListStockTotals', totalQuantity: number, stock: { __typename?: 'Stock', _id?: string | null, description: string, name: string, unitPrice: number, symbol: string } }>, bondTotals: Array<{ __typename?: 'WithdrawalOrderListBondTotals', totalAmount: number, asset: { __typename?: 'Bond', _id?: string | null, active: boolean, name: string, description?: string | null, symbol: string, interestRate: number } }>, estateTotals: Array<{ __typename?: 'WithdrawalOrderListEstateTotals', totalAmount: number, asset: { __typename?: 'Saving', _id?: string | null, balance: number, currency: Currency, description?: string | null, bankName: string, accountNo: string, interestRate: number } }> } };

export type PreviewWithdrawalOrderListInterestsQueryVariables = Exact<{
  orderListId: Scalars['ID']['input'];
}>;


export type PreviewWithdrawalOrderListInterestsQuery = { __typename?: 'Query', previewWithdrawalOrderListInterests: { __typename?: 'WithdrawalOrderListInterestPreview', bonds: Array<{ __typename?: 'WithdrawalOrderListInterestInterestPreviewDetails', assetId: string, totalInterest: number, totalTax: number } | null>, estate: Array<{ __typename?: 'WithdrawalOrderListInterestInterestPreviewDetails', assetId: string, totalInterest: number, totalTax: number } | null> } };

export type ConfirmWithdrawalOrderListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  confirmationData: WithdrawalConfirmationData;
}>;


export type ConfirmWithdrawalOrderListMutation = { __typename?: 'Mutation', confirmWithdrawalOrderList: boolean };

export type DownloadWithdrawalConfirmationReportMutationVariables = Exact<{
  orderListId: Scalars['ID']['input'];
}>;


export type DownloadWithdrawalConfirmationReportMutation = { __typename?: 'Mutation', downloadWithdrawalConfirmationReport: string };

export type DownloadWithdrawalPreReportMutationVariables = Exact<{
  orderListId: Scalars['ID']['input'];
}>;


export type DownloadWithdrawalPreReportMutation = { __typename?: 'Mutation', downloadWithdrawalPreReport: string };

export type PreviewWithdrawalOrderListTransfersQueryVariables = Exact<{
  orderListId: Scalars['ID']['input'];
}>;


export type PreviewWithdrawalOrderListTransfersQuery = { __typename?: 'Query', previewWithdrawalOrderListTransfers: Array<{ __typename?: 'WithdrawalOrderListTransfer', firstName: string, lastName: string, registerNo: string, bankCode?: string | null, bankName?: string | null, totalAmount: string, withdrawalRequestId: string, accountNo?: string | null }> };

export type CompleteWithdrawalRequestsTransferMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CompleteWithdrawalRequestsTransferMutation = { __typename?: 'Mutation', completeWithdrawalRequestsTransfer: { __typename?: 'WithdrawalRequestsConfirmationResult', orderListComplete: boolean } };

export type CancelWithdrawalOrderListMutationVariables = Exact<{
  cancelWithdrawalOrderListId: Scalars['ID']['input'];
}>;


export type CancelWithdrawalOrderListMutation = { __typename?: 'Mutation', cancelWithdrawalOrderList: boolean };

export const PurchaseStockDataFragmentDoc = gql`
    fragment PurchaseStockData on PurchaseStock {
  stock {
    name
    symbol
  }
  totalAmount
  totalPrice
  holdAmount
  unitPrice
  fee
}
    `;
export const PurchaseDataFragmentDoc = gql`
    fragment PurchaseData on Purchase {
  stocks {
    ...PurchaseStockData
  }
  bonds {
    bond {
      symbol
      name
    }
    principleAmount
    fee
  }
  savings {
    saving {
      bankName
      accountNo
    }
    principleAmount
    fee
  }
  previousPurchases {
    stocks {
      ...PurchaseStockData
    }
    createdAt
  }
  releasedAmount
}
    ${PurchaseStockDataFragmentDoc}`;
export const BalanceExportTaskDataFragmentDoc = gql`
    fragment BalanceExportTaskData on BalanceExportTask {
  _id
  status
  withMnt
  url
  error
  createdAt
  completedAt
}
    `;
export const KycQuestionnaireSubQuestionFragmentDoc = gql`
    fragment KycQuestionnaireSubQuestion on KycQuestionnaireQuestion {
  _id
  type
  question
  localizedQuestion {
    en
    mn
  }
  required
  options {
    value
    localizedValue {
      en
      mn
    }
    requiresInput
    triggersSubQuestions
  }
  order
}
    `;
export const KycQuestionnaireQuestionFragmentDoc = gql`
    fragment KycQuestionnaireQuestion on KycQuestionnaireQuestion {
  _id
  type
  question
  localizedQuestion {
    en
    mn
  }
  required
  options {
    value
    localizedValue {
      en
      mn
    }
    requiresInput
    triggersSubQuestions
  }
  subQuestions {
    ...KycQuestionnaireSubQuestion
  }
  order
}
    ${KycQuestionnaireSubQuestionFragmentDoc}`;
export const KycQuestionnaireFragmentDoc = gql`
    fragment KycQuestionnaire on KycQuestionnaire {
  _id
  name
  localizedName {
    en
    mn
  }
  description
  localizedDescription {
    en
    mn
  }
  active
  questions {
    ...KycQuestionnaireQuestion
  }
  createdAt
  updatedAt
}
    ${KycQuestionnaireQuestionFragmentDoc}`;
export const KycQuestionnaireSendFragmentDoc = gql`
    fragment KycQuestionnaireSend on KycQuestionnaireSend {
  _id
  questionnaire {
    _id
    name
  }
  user {
    _id
    firstName
    lastName
    phoneNo
    email
  }
  status
  sentBy {
    _id
    firstName
    lastName
  }
  sentAt
  completedAt
  expiresAt
  notificationSent
  createdAt
  updatedAt
}
    `;
export const KycQuestionnaireAnswerFragmentDoc = gql`
    fragment KycQuestionnaireAnswer on KycQuestionnaireAnswer {
  questionId
  type
  textValue
  numberValue
  dateValue
  selectedOption
  selectedOptions
  additionalText
  filePath
  fileName
  fileUrl
}
    `;
export const KycQuestionnaireResponseFragmentDoc = gql`
    fragment KycQuestionnaireResponse on KycQuestionnaireResponse {
  _id
  send
  questionnaire {
    _id
    name
    questions {
      ...KycQuestionnaireQuestion
    }
  }
  user {
    _id
    firstName
    lastName
  }
  answers {
    ...KycQuestionnaireAnswer
  }
  submittedAt
  createdAt
}
    ${KycQuestionnaireQuestionFragmentDoc}
${KycQuestionnaireAnswerFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  _id
  lastName
  firstName
  email
  phoneNo
  birthDate
  role
  type
  riskLevel
  contractDate
  durationLevel
  kycInfo {
    status
    description
  }
  bankInfo {
    bankName
    bankCode
    accountNo
    accountName
  }
  mscdLastError
  isFrozen
}
    `;
export const ChosenPortfolioFragmentDoc = gql`
    fragment ChosenPortfolio on Portfolio {
  _id
  active
  name
  description
  localizedName {
    en
    mn
  }
  localizedDescription {
    en
    mn
  }
  index
  riskLevel
  duration
  stocks {
    stock {
      _id
      name
      symbol
      type
    }
    value
  }
  bond {
    value
  }
  saving {
    value
  }
}
    `;
export const AddActivityDocument = gql`
    mutation addActivity($activity: AddActivityInput!) {
  addActivity(activity: $activity)
}
    `;
export const RegisterWebauthnDeviceDocument = gql`
    query registerWebauthnDevice($username: String!) {
  registerWebauthnDeviceChallenge(username: $username)
}
    `;
export const ConfirmWebauthnDeviceRegistrationDocument = gql`
    mutation confirmWebauthnDeviceRegistration($name: String!, $response: String!) {
  confirmWebauthnDeviceRegistration(name: $name, response: $response)
}
    `;
export const WebauthnLoginChallengeDocument = gql`
    query webauthnLoginChallenge($username: String!) {
  webauthnLoginChallenge(username: $username)
}
    `;
export const WebauthnLoginDocument = gql`
    mutation webauthnLogin($username: String!, $response: String!) {
  webauthnLogin(
    username: $username
    challengeResponse: $response
    channel: "dashboard"
  ) {
    token
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export const LoginDocument = gql`
    mutation login($username: String!, $password: String!, $challenge: String!) {
  login(
    phoneNo: $username
    password: $password
    challenge: $challenge
    channel: "dashboard"
  ) {
    token
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export const GetBalancesDocument = gql`
    query getBalances($page: Int!, $limit: Int!, $advanced: GetAvailableBalancesAdvancedInput!) {
  getBalances(page: $page, limit: $limit, advanced: $advanced) {
    balances {
      _id
      user {
        _id
        phoneNo
      }
      fee
      netAssetValue
      cashAmount
      holdAmount
      bonds {
        bond {
          _id
        }
      }
      stocks {
        stock {
          _id
        }
      }
      savings {
        saving {
          _id
        }
      }
      orderHistory {
        _id
      }
    }
    totalPages
  }
}
    `;
export const GetBalanceByUserIdDocument = gql`
    query getBalanceByUserId($_id: ID!) {
  getBalanceByUserId(_id: $_id) {
    _id
    user {
      _id
      phoneNo
      chosenPortfolio {
        _id
        index
      }
    }
    fee
    netAssetValue
    cashAmount
    holdAmount
    totalDeposit
    bonds {
      bond {
        name
        symbol
      }
      principleAmount
      accumulatedAmount
      estimatedTotalEarnings
      fee
      history {
        _id
        principleAmount
        fee
        createdAt
      }
    }
    stocks {
      stock {
        name
        symbol
      }
      totalAmount
      totalPrice
      unitPrice
      fee
      history {
        usdRate
        holdAmount
        totalAmount
        totalPrice
        unitPrice
        fee
        createdAt
      }
    }
    savings {
      saving {
        bankName
        accountNo
      }
      principleAmount
      estimatedTotalEarnings
      accumulatedAmount
      fee
      history {
        _id
        principleAmount
        fee
        createdAt
      }
    }
    orderHistory {
      _id
      status
      type
      amount
      beforeBalance
      afterBalance
      createdAt
      updatedAt
      description
    }
    balanceHistory {
      _id
      title
      cashAmount
      holdAmount
      principleAmount
      fee
      createdAt
      ...PurchaseData
    }
  }
}
    ${PurchaseDataFragmentDoc}`;
export const GetBalanceDocument = gql`
    query getBalance($_id: ID!) {
  getBalance(_id: $_id) {
    _id
    user {
      _id
      phoneNo
      chosenPortfolio {
        _id
        index
      }
    }
    fee
    netAssetValue
    cashAmount
    holdAmount
    bonds {
      bond {
        name
      }
      principleAmount
      accumulatedAmount
      estimatedTotalEarnings
      fee
      history {
        _id
        principleAmount
        fee
        createdAt
      }
    }
    stocks {
      stock {
        name
      }
      totalAmount
      totalPrice
      unitPrice
      fee
      history {
        usdRate
        holdAmount
        totalAmount
        totalPrice
        unitPrice
        fee
        createdAt
      }
    }
    savings {
      saving {
        bankName
        accountNo
      }
      principleAmount
      estimatedTotalEarnings
      accumulatedAmount
      fee
      history {
        _id
        principleAmount
        fee
        createdAt
      }
    }
    orderHistory {
      _id
      status
      type
      amount
      beforeBalance
      afterBalance
      createdAt
      updatedAt
    }
    balanceHistory {
      _id
      title
      cashAmount
      holdAmount
      principleAmount
      fee
      createdAt
      ...PurchaseData
    }
  }
}
    ${PurchaseDataFragmentDoc}`;
export const GetAvailableBalancesDocument = gql`
    query getAvailableBalances($page: Int!, $limit: Int!, $options: GetAvailableBalancesOptionsInput!, $advanced: GetAvailableBalancesAdvancedInput!) {
  getAvailableBalances(
    page: $page
    limit: $limit
    advanced: $advanced
    options: $options
  ) {
    balances {
      _id
      user {
        phoneNo
        email
        chosenPortfolio {
          _id
          index
        }
      }
      cashAmount
    }
    totalPages
  }
}
    `;
export const RelatedBondPurchaseDocument = gql`
    query relatedBondPurchase($balanceId: ID!, $historyEntryId: ID!) {
  relatedBondPurchase(balanceId: $balanceId, historyEntryId: $historyEntryId) {
    _id
  }
}
    `;
export const RelatedSavingPurchaseDocument = gql`
    query relatedSavingPurchase($balanceId: ID!, $historyEntryId: ID!) {
  relatedSavingPurchase(balanceId: $balanceId, historyEntryId: $historyEntryId) {
    _id
  }
}
    `;
export const GenerateBalancesDetailDocument = gql`
    mutation generateBalancesDetail($withMnt: Boolean) {
  generateBalancesDetail(withMnt: $withMnt) {
    ...BalanceExportTaskData
  }
}
    ${BalanceExportTaskDataFragmentDoc}`;
export const BalanceExportTaskDocument = gql`
    query balanceExportTask($taskId: ID!) {
  balanceExportTask(taskId: $taskId) {
    ...BalanceExportTaskData
  }
}
    ${BalanceExportTaskDataFragmentDoc}`;
export const ResetBalanceDocument = gql`
    mutation resetBalance($userId: ID!) {
  resetBalance(user: $userId)
}
    `;
export const CorrectCashWithdrawalDocument = gql`
    mutation CorrectCashWithdrawal($input: CashCorrectionInput!) {
  correctCashWithdrawal(input: $input) {
    success
    correctionAmount
    withdrawalOrderId
    message
  }
}
    `;
export const PreviewBondInterestRecalcDocument = gql`
    mutation PreviewBondInterestRecalc($input: BondInterestRecalcInput!) {
  previewBondInterestRecalc(input: $input) {
    entries {
      bondName
      bondIndex
      historyEntryId
      principleAmount
      currentInterest
      correctedInterest
      difference
      principalDifference
      purchaseId
      createdAt
    }
    totalCurrentInterest
    totalCorrectedInterest
    totalDifference
    totalPrincipalDifference
    totalCorrection
  }
}
    `;
export const CorrectBondInterestDocument = gql`
    mutation CorrectBondInterest($input: BondInterestRecalcInput!) {
  correctBondInterest(input: $input) {
    success
    correctionAmount
    withdrawalOrderId
    message
  }
}
    `;
export const CorrectStockPositionDocument = gql`
    mutation CorrectStockPosition($input: StockAdjustmentInput!) {
  correctStockPosition(input: $input) {
    success
    correctionAmount
    withdrawalOrderId
    message
  }
}
    `;
export const GetCorrectionOrdersDocument = gql`
    query GetCorrectionOrders($page: Int!, $limit: Int!, $filter: GetCorrectionOrdersInput) {
  getCorrectionOrders(page: $page, limit: $limit, filter: $filter) {
    orders {
      _id
      user {
        _id
        firstName
        lastName
        phoneNo
      }
      amount
      description
      correctionType
      reason
      adminId
      status
      createdAt
      oldValue
      newValue
    }
    totalPages
  }
}
    `;
export const ExportCorrectionReportDocument = gql`
    mutation ExportCorrectionReport($startDate: String!, $endDate: String!) {
  exportCorrectionReport(startDate: $startDate, endDate: $endDate) {
    reportUrl
  }
}
    `;
export const GetBondsDocument = gql`
    query getBonds($page: Int!, $limit: Int!) {
  getBonds(page: $page, limit: $limit) {
    bonds {
      _id
      name
      localizedName {
        en
        mn
      }
      symbol
      interestRate
      duration
      active
      endDate
      paymentType
      paymentSchedules
    }
    totalPages
  }
}
    `;
export const DeleteBondDocument = gql`
    mutation deleteBond($_id: ID!) {
  deleteBond(_id: $_id)
}
    `;
export const AddBondDocument = gql`
    mutation addBond($bond: AddBondInput!) {
  addBond(bond: $bond)
}
    `;
export const EditBondDocument = gql`
    mutation editBond($_id: ID!, $bond: EditBondInput!) {
  editBond(_id: $_id, bond: $bond)
}
    `;
export const PayoutPathInterestDocument = gql`
    mutation payoutPathInterest($batchId: String!, $bondId: String!) {
  payoutPathInterest(batchId: $batchId, bondId: $bondId)
}
    `;
export const GetBondDocument = gql`
    query getBond($_id: ID!) {
  getBond(_id: $_id) {
    _id
    name
    localizedName {
      en
      mn
    }
    symbol
    interestRate
    duration
    active
    endDate
    paymentType
    paymentSchedules
  }
}
    `;
export const BondHoldersDocument = gql`
    query bondHolders($bondId: ID!, $page: Int!, $limit: Int!) {
  bondHolders(bondId: $bondId, page: $page, limit: $limit) {
    holders {
      historyId
      userId
      lastName
      firstName
      phoneNo
      email
      registerNo
      taxPayerNo
      bondName
      interestRate
      principleAmount
      fee
      purchaseDate
      lastPayoutAt
      totalInterest
      totalTax
    }
    totalCount
    totalAmount
  }
}
    `;
export const BondPayoutHistoryDocument = gql`
    query bondPayoutHistory($bondId: ID!, $page: Int!, $limit: Int!) {
  bondPayoutHistory(bondId: $bondId, page: $page, limit: $limit) {
    payouts {
      userId
      lastName
      firstName
      batchId
      principleAmount
      interest
      taxAmount
      createdAt
    }
    totalCount
  }
}
    `;
export const BondWithdrawalHistoryDocument = gql`
    query bondWithdrawalHistory($bondId: ID!, $page: Int!, $limit: Int!) {
  bondWithdrawalHistory(bondId: $bondId, page: $page, limit: $limit) {
    withdrawals {
      userId
      lastName
      firstName
      amount
      withdrawnAmount
      status
      purchasedAt
      createdAt
    }
    totalCount
  }
}
    `;
export const BondPayoutBatchesDocument = gql`
    query bondPayoutBatches($bondId: ID!) {
  bondPayoutBatches(bondId: $bondId) {
    _id
    batchId
    status
    totalTasks
    completedTasks
    failedTasks
    initiatedBy
    startedAt
    completedAt
  }
}
    `;
export const GetConfigsDocument = gql`
    query getConfigs {
  getConfigs {
    _id
    key
    value
    description
  }
}
    `;
export const EditConfigDocument = gql`
    mutation editConfig($_id: ID!, $config: EditConfigInput!) {
  editConfig(_id: $_id, config: $config)
}
    `;
export const GetConfigByKeyDocument = gql`
    query getConfigByKey($key: String!) {
  getConfigByKey(key: $key) {
    _id
    key
    value
    description
  }
}
    `;
export const GetUserDeletionRequestsDocument = gql`
    query getUserDeletionRequests($page: Int!, $limit: Int!) {
  getUserDeletionRequests(page: $page, limit: $limit) {
    totalPages
    requests {
      _id
      user {
        _id
        lastName
        firstName
        email
        phoneNo
        birthDate
        avatar
        role
        type
        riskLevel
        durationLevel
        kycInfo {
          status
          description
        }
        bankInfo {
          bankName
          accountNo
        }
      }
      createdAt
    }
  }
}
    `;
export const GetFaqsDocument = gql`
    query getFaqs {
  getFaqs {
    _id
    question
    answer
  }
}
    `;
export const GetFaqDocument = gql`
    query getFaq($_id: ID!) {
  getFaq(_id: $_id) {
    _id
    question
    answer
  }
}
    `;
export const AddFaqDocument = gql`
    mutation addFaq($faq: AddFAQInput!) {
  addFaq(faq: $faq)
}
    `;
export const EditFaqDocument = gql`
    mutation editFaq($_id: ID!, $faq: EditFAQInput!) {
  editFaq(_id: $_id, faq: $faq)
}
    `;
export const DeleteFaqDocument = gql`
    mutation deleteFaq($_id: ID!) {
  deleteFaq(_id: $_id)
}
    `;
export const GetGroupActivitiesDocument = gql`
    query getGroupActivities($page: Int!, $limit: Int!) {
  getGroupActivities(page: $page, limit: $limit) {
    totalPages
    groupActivities {
      _id
    }
  }
}
    `;
export const GetGroupActivityDocument = gql`
    query getGroupActivity($_id: ID!) {
  getGroupActivity(_id: $_id) {
    _id
    activities {
      _id
      title
      body
      createdAt
    }
  }
}
    `;
export const DeleteGroupActivityDocument = gql`
    mutation deleteGroupActivity($_id: ID!) {
  deleteGroupActivity(_id: $_id)
}
    `;
export const SendGroupActivityDocument = gql`
    mutation sendGroupActivity($_id: ID!) {
  sendGroupActivity(_id: $_id)
}
    `;
export const GetImagesDocument = gql`
    query getImages($page: Int!, $limit: Int!) {
  getImages(page: $page, limit: $limit) {
    images {
      _id
      path
    }
    totalPages
  }
}
    `;
export const AddImageDocument = gql`
    mutation addImage($image: AddImageInput!) {
  addImage(image: $image)
}
    `;
export const DeleteImageDocument = gql`
    mutation deleteImage($_id: ID!) {
  deleteImage(_id: $_id)
}
    `;
export const GetKyCsDocument = gql`
    query getKYCs($page: Int!, $limit: Int!) {
  getKYCs(page: $page, limit: $limit) {
    kycs {
      _id
      user {
        _id
        lastName
        firstName
        email
        phoneNo
        type
        birthDate
        role
        avatar
        riskLevel
        durationLevel
        kycInfo {
          status
          description
        }
      }
      registerNo
      birthDate
      address
      info {
        status
        description
      }
    }
    totalPages
  }
}
    `;
export const GetKycByUserDocument = gql`
    query getKYCByUser($_id: ID!) {
  getKYCByUser(_id: $_id) {
    _id
    user {
      _id
      lastName
      firstName
      email
      phoneNo
    }
    registerNo
    taxPayerNo
    birthDate
    address
    info {
      status
      description
    }
    imageUrls
  }
}
    `;
export const GetUserRegisterNoDocument = gql`
    query getUserRegisterNo($kycId: ID!) {
  userRegisterNo(kycId: $kycId)
}
    `;
export const GetUserTaxPayerNoDocument = gql`
    query getUserTaxPayerNo($kycId: ID!) {
  userTaxPayerNo(kycId: $kycId)
}
    `;
export const GetUserAddressDocument = gql`
    query getUserAddress($kycId: ID!) {
  userAddress(kycId: $kycId)
}
    `;
export const DeleteKycDocument = gql`
    mutation deleteKYC($_id: ID!) {
  deleteKYC(_id: $_id)
}
    `;
export const EditKycDocument = gql`
    mutation editKYC($_id: ID!, $status: Status!, $description: String) {
  editKYC(_id: $_id, status: $status, description: $description)
}
    `;
export const GetContractsDocument = gql`
    query getContracts {
  adminContracts {
    name
    previewUrl
    createdAt
    updatedAt
    portfolio {
      _id
      localizedName {
        mn
      }
    }
  }
}
    `;
export const RequestContractUploadDocument = gql`
    mutation requestContractUpload($name: String!, $signatureImageName: String!, $portfolioId: ID) {
  requestContractUpload(
    name: $name
    signatureImageName: $signatureImageName
    portfolioId: $portfolioId
  )
}
    `;
export const TriggerRecontractDocument = gql`
    mutation triggerRecontract {
  triggerRecontract
}
    `;
export const GetUserContractsDocument = gql`
    query getUserContracts($userId: ID!) {
  userContracts(userId: $userId) {
    _id
    contractName
    contractNo
    signedAt
    version
  }
}
    `;
export const GetUserContractUrlDocument = gql`
    query getUserContractUrl($userId: ID!, $contractName: String!) {
  userContractUrl(userId: $userId, contractName: $contractName)
}
    `;
export const GetKycQuestionnairesDocument = gql`
    query getKycQuestionnaires($page: Int!, $limit: Int!) {
  getKycQuestionnaires(page: $page, limit: $limit) {
    questionnaires {
      ...KycQuestionnaire
    }
    totalPages
  }
}
    ${KycQuestionnaireFragmentDoc}`;
export const GetKycQuestionnaireDocument = gql`
    query getKycQuestionnaire($_id: ID!) {
  getKycQuestionnaire(_id: $_id) {
    ...KycQuestionnaire
  }
}
    ${KycQuestionnaireFragmentDoc}`;
export const PreviewKycQuestionnaireSegmentDocument = gql`
    query previewKycQuestionnaireSegment($segment: KycUserSegmentInput!, $page: Int!, $limit: Int!) {
  previewKycQuestionnaireSegment(segment: $segment, page: $page, limit: $limit) {
    userCount
    users {
      _id
      firstName
      lastName
      phoneNo
      email
      type
      kycInfo {
        status
      }
      createdAt
    }
  }
}
    `;
export const GetKycQuestionnaireSendsDocument = gql`
    query getKycQuestionnaireSends($questionnaireId: ID!, $status: KycQuestionnaireSendStatus, $page: Int!, $limit: Int!) {
  getKycQuestionnaireSends(
    questionnaireId: $questionnaireId
    status: $status
    page: $page
    limit: $limit
  ) {
    sends {
      ...KycQuestionnaireSend
    }
    totalPages
  }
}
    ${KycQuestionnaireSendFragmentDoc}`;
export const GetKycQuestionnaireSendDocument = gql`
    query getKycQuestionnaireSend($_id: ID!) {
  getKycQuestionnaireSend(_id: $_id) {
    ...KycQuestionnaireSend
    response {
      ...KycQuestionnaireResponse
    }
  }
}
    ${KycQuestionnaireSendFragmentDoc}
${KycQuestionnaireResponseFragmentDoc}`;
export const GetKycQuestionnaireSendsByUserDocument = gql`
    query getKycQuestionnaireSendsByUser($userId: ID!, $page: Int!, $limit: Int!) {
  getKycQuestionnaireSendsByUser(userId: $userId, page: $page, limit: $limit) {
    sends {
      ...KycQuestionnaireSend
    }
    totalPages
  }
}
    ${KycQuestionnaireSendFragmentDoc}`;
export const AddKycQuestionnaireDocument = gql`
    mutation addKycQuestionnaire($input: AddKycQuestionnaireInput!) {
  addKycQuestionnaire(input: $input)
}
    `;
export const EditKycQuestionnaireDocument = gql`
    mutation editKycQuestionnaire($_id: ID!, $input: EditKycQuestionnaireInput!) {
  editKycQuestionnaire(_id: $_id, input: $input)
}
    `;
export const DeleteKycQuestionnaireDocument = gql`
    mutation deleteKycQuestionnaire($_id: ID!) {
  deleteKycQuestionnaire(_id: $_id)
}
    `;
export const SendKycQuestionnaireToUserDocument = gql`
    mutation sendKycQuestionnaireToUser($questionnaireId: ID!, $userId: ID!) {
  sendKycQuestionnaireToUser(questionnaireId: $questionnaireId, userId: $userId)
}
    `;
export const SendKycQuestionnaireToSegmentDocument = gql`
    mutation sendKycQuestionnaireToSegment($questionnaireId: ID!, $segment: KycUserSegmentInput!) {
  sendKycQuestionnaireToSegment(
    questionnaireId: $questionnaireId
    segment: $segment
  )
}
    `;
export const SendKycQuestionnaireToAllUnrespondedDocument = gql`
    mutation sendKycQuestionnaireToAllUnresponded($questionnaireId: ID!) {
  sendKycQuestionnaireToAllUnresponded(questionnaireId: $questionnaireId)
}
    `;
export const PreviewKycQuestionnaireUnrespondedCountDocument = gql`
    query previewKycQuestionnaireUnrespondedCount($questionnaireId: ID!) {
  previewKycQuestionnaireUnrespondedCount(questionnaireId: $questionnaireId)
}
    `;
export const ResendKycQuestionnaireDocument = gql`
    mutation resendKycQuestionnaire($sendId: ID!) {
  resendKycQuestionnaire(sendId: $sendId)
}
    `;
export const DispatchMonthlyFeesDocument = gql`
    mutation dispatchMonthlyFees($year: Int!, $month: Int!) {
  dispatchMonthlyFees(year: $year, month: $month) {
    dispatched
    batchId
  }
}
    `;
export const ApplyMonthlyFeesForUserDocument = gql`
    mutation applyMonthlyFeesForUser($userId: ID!, $year: Int!, $month: Int!) {
  applyMonthlyFeesForUser(userId: $userId, year: $year, month: $month) {
    processedCount
    totalFeeAmount
    skippedCount
    errors {
      purchaseId
      error
    }
  }
}
    `;
export const GetMscdApiAccountsDocument = gql`
    query getMSCDApiAccounts($filter: MSCDApiAccountFilterInput, $limit: Int!, $page: Int!) {
  getMSCDApiAccounts(filter: $filter, limit: $limit, page: $page) {
    accounts {
      _id
      accountNumber
      bdcId
      bdcAccountId
      firstName
      lastName
      registryNumber
      clientSuffix
      mitPrefix
      country
      customerType
      type
      createdDate
      msxAccountId
      syncedAt
      updatedAt
    }
    totalItems
    totalPages
  }
}
    `;
export const SyncMscdAccountsDocument = gql`
    mutation syncMSCDAccounts($beginDate: String, $endDate: String) {
  syncMSCDAccounts(beginDate: $beginDate, endDate: $endDate) {
    synced
    upserted
    modified
  }
}
    `;
export const ExportMscdApiAccountsExcelDocument = gql`
    mutation exportMSCDApiAccountsExcel {
  exportMSCDApiAccountsExcel {
    reportUrl
  }
}
    `;
export const DispatchAccountCreationForDepositorsDocument = gql`
    mutation dispatchAccountCreationForDepositors($startDate: Float) {
  dispatchAccountCreationForDepositors(startDate: $startDate) {
    dispatched
    skipped
  }
}
    `;
export const FixMscdAccountNoDocument = gql`
    mutation fixMSCDAccountNo($userId: ID!) {
  fixMSCDAccountNo(userId: $userId)
}
    `;
export const UpdateMscdAccountNoDocument = gql`
    mutation updateMSCDAccountNo($userId: ID!, $accountNo: String!) {
  updateMSCDAccountNo(userId: $userId, accountNo: $accountNo)
}
    `;
export const FixAndRetryMscdAccountDocument = gql`
    mutation fixAndRetryMSCDAccount($userId: ID!, $bankAccountNo: String, $bankCode: String, $bankName: String, $firstName: String, $lastName: String, $phoneNo: String, $birthDate: String) {
  fixAndRetryMSCDAccount(
    userId: $userId
    bankAccountNo: $bankAccountNo
    bankCode: $bankCode
    bankName: $bankName
    firstName: $firstName
    lastName: $lastName
    phoneNo: $phoneNo
    birthDate: $birthDate
  )
}
    `;
export const GetMscdErrorAccountsDocument = gql`
    query getMSCDErrorAccounts($beginDate: String!, $endDate: String!) {
  getMSCDErrorAccounts(beginDate: $beginDate, endDate: $endDate) {
    PkId
    BDCAccountId
    BDCAccountNumber
    RegistryNumber
    FirstName
    LastName
    BirthDate
    Gender
    HomePhone
    MobilePhone
    Occupation
    HomeAddress
    BankCode
    BankName
    BankAccountNumber
    Status
    ErrorMessage
    RecievedDate
    CheckStatus
    localUserId
    localAccountNo
    localFirstName
    localLastName
    localRegisterNo
    localBankCode
    localBankName
    localBankAccountNo
    localPhoneNo
    localBirthDate
    localGender
    localOccupation
    localHomeAddress
  }
}
    `;
export const SearchUserForMscdLinkDocument = gql`
    query searchUserForMSCDLink($bdcAccountId: String!, $bdcAccountNumber: Int!, $registerNo: String, $phoneNo: String) {
  searchUserForMSCDLink(
    bdcAccountId: $bdcAccountId
    bdcAccountNumber: $bdcAccountNumber
    registerNo: $registerNo
    phoneNo: $phoneNo
  ) {
    userId
    firstName
    lastName
    phoneNo
    email
    matchedBy
    existingAccountNo
  }
}
    `;
export const LinkMscdErrorAccountDocument = gql`
    mutation linkMSCDErrorAccount($bdcAccountId: String!, $bdcAccountNumber: Int!, $userId: ID!) {
  linkMSCDErrorAccount(
    bdcAccountId: $bdcAccountId
    bdcAccountNumber: $bdcAccountNumber
    userId: $userId
  )
}
    `;
export const GetOrdersDocument = gql`
    query getOrders($page: Int!, $limit: Int!, $advanced: GetOrders!) {
  getOrders(page: $page, limit: $limit, advanced: $advanced) {
    orders {
      _id
      status
      type
      amount
      description
      beforeBalance
      afterBalance
      isReturnable
      user {
        _id
        lastName
        firstName
        birthDate
        email
        phoneNo
        role
        avatar
        riskLevel
        durationLevel
        kycInfo {
          status
          description
        }
        chosenPortfolio {
          _id
          index
          riskLevel
          duration
          stocks {
            stock {
              _id
              name
              symbol
              type
            }
            value
          }
          bond {
            value
          }
          saving {
            value
          }
        }
      }
      createdAt
      updatedAt
    }
    totalPages
  }
}
    `;
export const AddOrderDocument = gql`
    mutation addOrder($order: AddOrderInput!) {
  addOrder(order: $order)
}
    `;
export const RemoveOrderDocument = gql`
    mutation removeOrder($id: ID!) {
  removeOrder(id: $id)
}
    `;
export const ReturnOrderDocument = gql`
    mutation returnOrder($id: ID!, $amount: Float) {
  returnOrder(id: $id, amount: $amount)
}
    `;
export const BulkAddOrderDocument = gql`
    mutation bulkAddOrder($input: BulkAddOrderInput!) {
  bulkAddOrder(input: $input) {
    batchId
    totalRows
    validRows
    invalidRows
    totalAmount
    fileUrl
    rows {
      row
      email
      amount
      description
      status
      errorCode
      errorMessage
      user {
        _id
        firstName
        lastName
      }
    }
  }
}
    `;
export const GetBulkAddOrderBatchDocument = gql`
    query getBulkAddOrderBatch($batchId: ID!) {
  getBulkAddOrderBatch(batchId: $batchId) {
    batchId
    filename
    fileUrl
    totalRows
    pendingCount
    successCount
    failedCount
    revertedCount
    totalAmount
    status
    createdAt
    updatedAt
    rows {
      rowNumber
      email
      amount
      description
      status
      orderId
      errorCode
      errorMessage
      processedAt
      reverted
      user {
        _id
        firstName
        lastName
      }
    }
  }
}
    `;
export const RevertBulkAddOrderBatchDocument = gql`
    mutation revertBulkAddOrderBatch($batchId: ID!) {
  revertBulkAddOrderBatch(batchId: $batchId) {
    batchId
    status
    successCount
    failedCount
    revertedCount
  }
}
    `;
export const GetOrderListsDocument = gql`
    query getOrderLists($page: Int!, $limit: Int!, $status: OrderListStatus!) {
  orderLists(page: $page, limit: $limit, status: $status) {
    orderLists {
      _id
      index
      status
      totalPurchases
      createdAt
      updatedAt
    }
    totalPages
  }
}
    `;
export const CreateOrderListDocument = gql`
    mutation createOrderList($balances: [ID!]!, $usdRate: Float!) {
  createOrderList(balances: $balances, usdRate: $usdRate)
}
    `;
export const PrepareOrderListDocument = gql`
    mutation prepareOrderList($balances: [ID!]!) {
  prepareOrderList(balances: $balances) {
    bond
    savings
    stocks {
      symbol
      type
      totalPrice
    }
  }
}
    `;
export const GenerateOrderListDetailDocument = gql`
    mutation generateOrderListDetail($_id: ID!) {
  generateOrderListDetail(_id: $_id)
}
    `;
export const GenerateOrderListOrdersDocument = gql`
    mutation generateOrderListOrders($_id: ID!) {
  generateOrderListOrders(_id: $_id)
}
    `;
export const RegenerateOrderListFileDocument = gql`
    mutation regenerateOrderListFile($orderListId: ID!) {
  regenerateOrderListFile(orderListId: $orderListId)
}
    `;
export const GenerateOrderListDetailPerUserDocument = gql`
    mutation generateOrderListDetailPerUser($_id: ID!) {
  generateOrderListDetailPerUser(_id: $_id)
}
    `;
export const GetOrderListDocument = gql`
    query getOrderList($_id: ID!) {
  getOrderList(_id: $_id) {
    _id
    status
    type
    purchases {
      _id
    }
    totalPurchases {
      cashAmount
      stocks {
        stock {
          _id
          name
          symbol
          type
        }
        usdRate
        totalPrice
        availableTotalPrice
      }
      bond {
        amount
      }
      saving {
        amount
      }
    }
    createdAt
    updatedAt
  }
}
    `;
export const DownloadOrderListDocument = gql`
    query downloadOrderList($id: ID!) {
  getOrderList(_id: $id) {
    fileUrl
  }
}
    `;
export const ConfirmOrderListDocument = gql`
    mutation confirmOrderList($_id: ID!, $totalPurchases: AddPurchasesInput!) {
  confirmOrderList(_id: $_id, totalPurchases: $totalPurchases)
}
    `;
export const ReleaseHoldAmountDocument = gql`
    mutation releaseHoldAmount($_id: ID!) {
  releaseHoldAmount(purchaseId: $_id)
}
    `;
export const ReleaseHoldAmountForOrderListDocument = gql`
    mutation releaseHoldAmountForOrderList($orderListId: ID!) {
  releaseHoldAmountForOrderList(orderListId: $orderListId)
}
    `;
export const RequestOtpDocument = gql`
    mutation requestOtp($username: String!) {
  requestOtp(phoneNo: "", username: $username, channel: "dashboard") {
    sent
    retryAfter
    challenge
  }
}
    `;
export const RecoverOtpDocument = gql`
    mutation recoverOtp($username: String!) {
  recoverOtp(username: $username)
}
    `;
export const GetPortfolioDocument = gql`
    query getPortfolio($_id: ID!) {
  getPortfolio(_id: $_id) {
    _id
    active
    name
    description
    localizedName {
      en
      mn
    }
    localizedDescription {
      en
      mn
    }
    index
    riskLevel
    duration
    stocks {
      stock {
        _id
        name
        description
        localizedName {
          en
          mn
        }
        localizedDescription {
          en
          mn
        }
        symbol
        type
      }
      value
    }
    bond {
      value
    }
    saving {
      value
    }
  }
}
    `;
export const GetAllPortfoliosDocument = gql`
    query getAllPortfolios {
  getAllPortfolios {
    _id
    active
    name
    description
    localizedName {
      en
      mn
    }
    localizedDescription {
      en
      mn
    }
    index
    riskLevel
    duration
    stocks {
      stock {
        _id
        name
        description
        localizedName {
          en
          mn
        }
        localizedDescription {
          en
          mn
        }
        symbol
        type
      }
      value
    }
    bond {
      value
    }
    saving {
      value
    }
  }
}
    `;
export const GetPortfoliosDocument = gql`
    query getPortfolios($page: Int!, $limit: Int!) {
  getPortfolios(page: $page, limit: $limit) {
    portfolios {
      _id
      active
      name
      description
      localizedName {
        en
        mn
      }
      localizedDescription {
        en
        mn
      }
      index
      riskLevel
      duration
      stocks {
        stock {
          _id
          name
          description
          localizedName {
            en
            mn
          }
          localizedDescription {
            en
            mn
          }
          symbol
          type
        }
        value
      }
      bond {
        value
      }
      saving {
        value
      }
    }
    totalPages
  }
}
    `;
export const AddPortfolioDocument = gql`
    mutation addPortfolio($portfolio: AddPortfolioInput!) {
  addPortfolio(portfolio: $portfolio)
}
    `;
export const EditPortfolioDocument = gql`
    mutation editPortfolio($_id: ID!, $portfolio: EditPortfolioInput!) {
  editPortfolio(_id: $_id, portfolio: $portfolio)
}
    `;
export const DeletePortfolioDocument = gql`
    mutation deletePortfolio($_id: ID!) {
  deletePortfolio(_id: $_id)
}
    `;
export const InterestPayoutReportsDocument = gql`
    query interestPayoutReports {
  interestPayoutReports {
    batchId
  }
}
    `;
export const DownloadInterestPayoutReportDocument = gql`
    mutation downloadInterestPayoutReport($batchId: String!) {
  downloadInterestPayoutReport(batchId: $batchId) {
    reportUrl
  }
}
    `;
export const FeeReportsDocument = gql`
    query feeReports {
  feeReports {
    batchId
  }
}
    `;
export const DownloadFeeReportDocument = gql`
    mutation downloadFeeReport($batchId: String!) {
  downloadFeeReport(batchId: $batchId) {
    reportUrl
  }
}
    `;
export const ExportFeeReportForDateRangeDocument = gql`
    mutation exportFeeReportForDateRange($startDate: String!, $endDate: String!) {
  exportFeeReportForDateRange(startDate: $startDate, endDate: $endDate) {
    reportUrl
  }
}
    `;
export const ExportInterestPayoutReportForDateRangeDocument = gql`
    mutation exportInterestPayoutReportForDateRange($startDate: String!, $endDate: String!) {
  exportInterestPayoutReportForDateRange(startDate: $startDate, endDate: $endDate) {
    reportUrl
  }
}
    `;
export const ExportInterestPayoutReportDocument = gql`
    mutation exportInterestPayoutReport($batchId: String!) {
  exportInterestPayoutReport(batchId: $batchId) {
    reportUrl
  }
}
    `;
export const ExportFeeReportDocument = gql`
    mutation exportFeeReport($batchId: String!) {
  exportFeeReport(batchId: $batchId) {
    reportUrl
  }
}
    `;
export const GetSavingsDocument = gql`
    query getSavings($page: Int!, $limit: Int!) {
  getSavings(page: $page, limit: $limit) {
    savings {
      _id
      accountNo
      bankName
      currency
      balance
      interestRate
    }
    totalPages
  }
}
    `;
export const GetSavingDocument = gql`
    query getSaving($_id: ID!) {
  getSaving(_id: $_id) {
    _id
    accountNo
    bankName
    currency
    balance
    interestRate
  }
}
    `;
export const AddSavingDocument = gql`
    mutation addSaving($saving: AddSavingInput!) {
  addSaving(saving: $saving)
}
    `;
export const EditSavingDocument = gql`
    mutation editSaving($_id: ID!, $saving: EditSavingInput!) {
  editSaving(_id: $_id, saving: $saving)
}
    `;
export const DeleteSavingDocument = gql`
    mutation deleteSaving($_id: ID!) {
  deleteSaving(_id: $_id)
}
    `;
export const GetStocksDocument = gql`
    query getStocks($page: Int!, $limit: Int!) {
  getStocks(page: $page, limit: $limit) {
    stocks {
      _id
      name
      description
      localizedName {
        en
        mn
      }
      localizedDescription {
        en
        mn
      }
      url
      symbol
      type
      image {
        path
      }
    }
    totalPages
  }
}
    `;
export const GetAllStocksListDocument = gql`
    query getAllStocksList {
  getStocks(page: 0, limit: 100) {
    stocks {
      _id
      name
    }
  }
}
    `;
export const DeleteStockDocument = gql`
    mutation deleteStock($_id: ID!) {
  deleteStock(_id: $_id)
}
    `;
export const AddStockDocument = gql`
    mutation addStock($stock: AddStockInput!) {
  addStock(stock: $stock)
}
    `;
export const EditStockDocument = gql`
    mutation editStock($_id: ID!, $stock: EditStockInput!) {
  editStock(_id: $_id, stock: $stock)
}
    `;
export const GetStockDocument = gql`
    query getStock($_id: ID!) {
  getStock(_id: $_id) {
    _id
    name
    description
    localizedName {
      en
      mn
    }
    localizedDescription {
      en
      mn
    }
    url
    symbol
    type
    image {
      path
    }
  }
}
    `;
export const GetDividendReportsDocument = gql`
    query getDividendReports($page: Int!, $limit: Int!) {
  dividendReports(page: $page, limit: $limit) {
    reports {
      id
      stock {
        symbol
      }
      recordDate
      amount
      totalAmount
      createdAt
    }
    totalPages
  }
}
    `;
export const PrepareDividendReportDocument = gql`
    mutation prepareDividendReport($stockId: ID!, $recordDate: String!, $dividend: Float!) {
  prepareDividendReport(
    stockId: $stockId
    recordDate: $recordDate
    dividend: $dividend
  ) {
    reportUrl
  }
}
    `;
export const DistributeDividendsDocument = gql`
    mutation distributeDividends($stockId: ID!, $recordDate: String!, $dividend: Float!, $expectedTotalDividend: Float!) {
  distributeDividends(
    stockId: $stockId
    recordDate: $recordDate
    dividend: $dividend
    expectedTotalDividend: $expectedTotalDividend
  ) {
    reportUrl
  }
}
    `;
export const AddSuggestionDocument = gql`
    mutation AddSuggestion($suggestion: AddSuggestionInput!) {
  addSuggestion(suggestion: $suggestion)
}
    `;
export const DeleteSuggestionDocument = gql`
    mutation deleteSuggestion($_id: ID!) {
  deleteSuggestion(_id: $_id)
}
    `;
export const SuggestionsDocument = gql`
    query suggestions {
  suggestions {
    _id
    title
    description
    url
    expireAt
    suggestionCount
    stocks
    portfolioInfos {
      currentId
      changeId
    }
  }
}
    `;
export const GetSurveysDocument = gql`
    query getSurveys {
  getSurveys {
    _id
    name
    localizedName {
      en
      mn
    }
    active
    questions {
      question
      localizedQuestion {
        en
        mn
      }
      answers {
        value
        localizedValue {
          en
          mn
        }
        durationPoints
        riskPoints
      }
    }
  }
}
    `;
export const GetSurveyDocument = gql`
    query getSurvey($_id: ID!) {
  getSurvey(_id: $_id) {
    _id
    name
    localizedName {
      en
      mn
    }
    introText
    localizedIntroText {
      en
      mn
    }
    completeText
    localizedCompleteText {
      en
      mn
    }
    active
    questions {
      question
      localizedQuestion {
        en
        mn
      }
      answers {
        value
        localizedValue {
          en
          mn
        }
        durationPoints
        riskPoints
      }
    }
  }
}
    `;
export const AddSurveyDocument = gql`
    mutation addSurvey($survey: AddSurveyInput!) {
  addSurvey(survey: $survey)
}
    `;
export const EditSurveyDocument = gql`
    mutation editSurvey($_id: ID!, $survey: EditSurveyInput!) {
  editSurvey(_id: $_id, survey: $survey)
}
    `;
export const DeleteSurveyDocument = gql`
    mutation deleteSurvey($_id: ID!) {
  deleteSurvey(_id: $_id)
}
    `;
export const GetUnmatchedDepositsDocument = gql`
    query getUnmatchedDeposits($status: UnmatchedDepositStatus, $bank: String, $skip: Int, $limit: Int) {
  unmatchedDeposits(status: $status, bank: $bank, skip: $skip, limit: $limit) {
    items {
      _id
      bank
      account
      amount
      currency
      transactionDate
      transactionDescription
      transactionUniqueId
      reason
      parsedExternalId
      status
      matchedDepositId
      matchedBy
      matchedAt
      createdAt
    }
    total
  }
}
    `;
export const MatchUnmatchedDepositDocument = gql`
    mutation matchUnmatchedDeposit($id: ID!, $userId: ID!) {
  matchUnmatchedDeposit(id: $id, userId: $userId)
}
    `;
export const DismissUnmatchedDepositDocument = gql`
    mutation dismissUnmatchedDeposit($id: ID!) {
  dismissUnmatchedDeposit(id: $id)
}
    `;
export const AddUserDocument = gql`
    mutation addUser($user: AddUserInput!) {
  addUser(user: $user)
}
    `;
export const EditUserDocument = gql`
    mutation editUser($_id: ID!, $user: EditUserInput!) {
  editUser(_id: $_id, user: $user)
}
    `;
export const DeleteUserDocument = gql`
    mutation deleteUser($_id: ID!) {
  deleteUser(_id: $_id)
}
    `;
export const EditUserPortfolioDocument = gql`
    mutation editUserPortfolio($_id: ID!, $portfolioId: ID!) {
  editUserPortfolio(_id: $_id, portfolioId: $portfolioId)
}
    `;
export const CereateMscdAccountDocument = gql`
    mutation cereateMSCDAccount($userId: ID!) {
  internal__createMSCDAccount(userId: $userId)
}
    `;
export const UpdateUserBankInfoDocument = gql`
    mutation updateUserBankInfo($_id: ID!, $bankInfo: BankInfo!) {
  updateUserBankInfo(_id: $_id, bankInfo: $bankInfo)
}
    `;
export const FreezeUserDocument = gql`
    mutation freezeUser($_id: ID!) {
  freezeUser(_id: $_id)
}
    `;
export const UnfreezeUserDocument = gql`
    mutation unfreezeUser($_id: ID!) {
  unfreezeUser(_id: $_id)
}
    `;
export const GetUsersDocument = gql`
    query getUsers($page: Int!, $limit: Int!, $advanced: AdvancedSearchInput!) {
  getUsers(page: $page, limit: $limit, advanced: $advanced) {
    users {
      ...User
      chosenPortfolio {
        ...ChosenPortfolio
      }
    }
    totalPages
  }
}
    ${UserFragmentDoc}
${ChosenPortfolioFragmentDoc}`;
export const GetUserDocument = gql`
    query getUser($_id: ID!) {
  getUser(_id: $_id) {
    ...User
    depositCode
    dbxAccountNumber
    chosenPortfolio {
      ...ChosenPortfolio
    }
  }
}
    ${UserFragmentDoc}
${ChosenPortfolioFragmentDoc}`;
export const MeDocument = gql`
    query me {
  me {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const GetMscdAccountStatusDocument = gql`
    query getMscdAccountStatus($accountNo: String!) {
  getMscdAccountStatus(accountNumber: $accountNo)
}
    `;
export const GetUserMscdApiAccountDocument = gql`
    query getUserMSCDApiAccount($userId: ID!) {
  getUserMSCDApiAccount(userId: $userId) {
    _id
    accountNumber
    bdcAccountId
    registryNumber
    firstName
    lastName
    createdDate
    syncedAt
  }
}
    `;
export const GetUserMscdAccountDocument = gql`
    query getUserMSCDAccount($userId: ID!) {
  getUserMSCDAccount(userId: $userId) {
    _id
    accountNo
    accountSequentialId
    status
    lastError
    lastAttemptAt
    attemptCount
    createdAt
    updatedAt
    mscdStatus
    mscdErrorMessage
  }
}
    `;
export const RetryMscdAccountCreationDocument = gql`
    mutation retryMSCDAccountCreation($userId: ID!) {
  retryMSCDAccountCreation(userId: $userId)
}
    `;
export const GetDashboardDataDocument = gql`
    query getDashboardData {
  getDashboardData {
    totalUser
    totalValue
    totalInvestment
    totalWaitingOrders
    totalReadyToInvest
    totalWithdrawal
    totalFee
    depositChartData {
      date
      amount
    }
    bondInterestChartData {
      date
      amount
    }
    withdrawalChartData {
      date
      amount
    }
  }
}
    `;
export const GetUsersExcelDocument = gql`
    query getUsersExcel {
  getUsersExcel {
    address
    email
    lastName
    firstName
    registerNo
    phoneNo
    portfolioIndex
    bond
    vde
    vxf
    fx
    dia
    vti
    vug
    estate
    xoz
  }
}
    `;
export const UserWithdrawalRequestsDocument = gql`
    query userWithdrawalRequests($userId: ID!) {
  userWithdrawalRequests(userId: $userId) {
    _id
    status
    createdAt
    updatedAt
    releasedCashAmount
    releasedHoldAmount
    stocks {
      stock {
        symbol
        localizedName {
          en
        }
      }
      quantity
      purchasedAt
    }
    bonds {
      bond {
        name
      }
      amount
      purchasedAt
    }
    estate {
      estate {
        bankName
        description
      }
      amount
      purchasedAt
    }
    confirmationDetail {
      stocks {
        assetId
        totalPrice
        totalAmount
        totalComission
        totalFee
      }
      bonds {
        assetId
        principleAmount
        interestAmount
        taxAmount
        feeAmount
        totalAmount
      }
      estate {
        assetId
        principleAmount
        interestAmount
        taxAmount
        feeAmount
        totalAmount
      }
    }
  }
}
    `;
export const DownloadUserWithdrawalsDocument = gql`
    mutation downloadUserWithdrawals($userId: ID!) {
  downloadUserWithdrawals(userId: $userId)
}
    `;
export const ExportUserDetailedReportV2Document = gql`
    mutation exportUserDetailedReportV2($userId: ID!) {
  exportUserDetailedReportV2(userId: $userId) {
    reportUrl
  }
}
    `;
export const ExportClientReportDocument = gql`
    mutation exportClientReport($userId: ID!) {
  exportClientReport(userId: $userId) {
    reportUrl
  }
}
    `;
export const ExportSecuritiesCustomersExcelDocument = gql`
    mutation exportSecuritiesCustomersExcel {
  exportSecuritiesCustomersExcel {
    reportUrl
  }
}
    `;
export const CancelWithdrawalRequestDocument = gql`
    mutation cancelWithdrawalRequest($requestId: ID!) {
  cancelWithdrawalRequest(requestId: $requestId)
}
    `;
export const DeleteContractDocument = gql`
    mutation deleteContract($name: String!) {
  deleteContract(name: $name)
}
    `;
export const CreateWithdrawalOrderListDocument = gql`
    mutation createWithdrawalOrderList($withdrawalRequestIds: [ID!]!) {
  createWithdrawalOrderList(withdrawalRequestIds: $withdrawalRequestIds)
}
    `;
export const DownloadWithdrawalOrderListDocument = gql`
    query downloadWithdrawalOrderList($id: ID!) {
  downloadWithdrawalOrderList(id: $id)
}
    `;
export const WithdrawalRequestDocument = gql`
    query withdrawalRequest($id: ID!) {
  withdrawalRequest(id: $id) {
    _id
    user {
      ...User
    }
    status
    stocks {
      stock {
        name
        unitPrice
        symbol
      }
      quantity
      withdrawnAmount
    }
    bonds {
      bond {
        name
      }
      amount
      balanceHistoryRecordId
      withdrawnAmount
    }
    estate {
      estate {
        bankName
      }
      amount
      balanceHistoryRecordId
      withdrawnAmount
    }
    createdAt
    updatedAt
  }
}
    ${UserFragmentDoc}`;
export const AllPendingWithdrawalRequestsDocument = gql`
    query allPendingWithdrawalRequests {
  allPendingWithdrawalRequests {
    _id
    username
    portfolioIndex
  }
}
    `;
export const AllWithdrawalRequestsDocument = gql`
    query allWithdrawalRequests($status: WithdrawalStatus, $page: Int!, $limit: Int!, $search: String!) {
  allWithdrawalRequests(
    status: $status
    page: $page
    limit: $limit
    search: $search
  ) {
    requests {
      _id
      user {
        ...User
      }
      status
      withdrawalType
      stocks {
        stock {
          name
          unitPrice
        }
        quantity
        withdrawnAmount
      }
      bonds {
        bond {
          name
        }
        amount
        balanceHistoryRecordId
        withdrawnAmount
      }
      estate {
        estate {
          bankName
        }
        amount
        balanceHistoryRecordId
        withdrawnAmount
      }
      releasedHoldAmount
      releasedCashAmount
      createdAt
      updatedAt
    }
    totalItems
  }
}
    ${UserFragmentDoc}`;
export const WithdrawalOrderListsDocument = gql`
    query withdrawalOrderLists($page: Int!, $limit: Int!, $status: WithdrawalStatus) {
  withdrawalOrderLists(page: $page, limit: $limit, status: $status) {
    data {
      _id
      status
      stockTotals {
        stock {
          description
          name
          unitPrice
          symbol
        }
        totalQuantity
      }
      bondTotals {
        asset {
          _id
          active
          name
          description
          symbol
          interestRate
        }
        totalAmount
      }
      estateTotals {
        asset {
          _id
          balance
          currency
          description
          bankName
          accountNo
          interestRate
        }
        totalAmount
      }
      withdrawalRequests {
        _id
      }
      createdAt
      updatedAt
    }
    totalItems
  }
}
    `;
export const WithdrawalOrderListDocument = gql`
    query withdrawalOrderList($id: ID!) {
  withdrawalOrderList(id: $id) {
    _id
    status
    stockTotals {
      stock {
        description
        name
        unitPrice
        symbol
      }
      totalQuantity
    }
    bondTotals {
      asset {
        _id
        active
        name
        description
        symbol
        interestRate
      }
      totalAmount
    }
    estateTotals {
      asset {
        _id
        balance
        currency
        description
        bankName
        accountNo
        interestRate
      }
      totalAmount
    }
    withdrawalRequests {
      _id
      releasedCashAmount
      releasedHoldAmount
      user {
        _id
        firstName
        lastName
        email
        phoneNo
      }
    }
    createdAt
    updatedAt
  }
}
    `;
export const PreviewWithdrawalOrderListDocument = gql`
    query previewWithdrawalOrderList($withdrawalRequestIds: [ID!]!) {
  previewWithdrawalOrderList(withdrawalRequestIds: $withdrawalRequestIds) {
    stockTotals {
      stock {
        _id
        description
        name
        unitPrice
        symbol
      }
      totalQuantity
    }
    bondTotals {
      asset {
        _id
        active
        name
        description
        symbol
        interestRate
      }
      totalAmount
    }
    estateTotals {
      asset {
        _id
        balance
        currency
        description
        bankName
        accountNo
        interestRate
      }
      totalAmount
    }
  }
}
    `;
export const PreviewWithdrawalOrderListInterestsDocument = gql`
    query previewWithdrawalOrderListInterests($orderListId: ID!) {
  previewWithdrawalOrderListInterests(orderListId: $orderListId) {
    bonds {
      assetId
      totalInterest
      totalTax
    }
    estate {
      assetId
      totalInterest
      totalTax
    }
  }
}
    `;
export const ConfirmWithdrawalOrderListDocument = gql`
    mutation confirmWithdrawalOrderList($id: ID!, $confirmationData: WithdrawalConfirmationData!) {
  confirmWithdrawalOrderList(id: $id, confirmationData: $confirmationData)
}
    `;
export const DownloadWithdrawalConfirmationReportDocument = gql`
    mutation downloadWithdrawalConfirmationReport($orderListId: ID!) {
  downloadWithdrawalConfirmationReport(orderListId: $orderListId)
}
    `;
export const DownloadWithdrawalPreReportDocument = gql`
    mutation downloadWithdrawalPreReport($orderListId: ID!) {
  downloadWithdrawalPreReport(orderListId: $orderListId)
}
    `;
export const PreviewWithdrawalOrderListTransfersDocument = gql`
    query previewWithdrawalOrderListTransfers($orderListId: ID!) {
  previewWithdrawalOrderListTransfers(orderListId: $orderListId) {
    firstName
    lastName
    registerNo
    bankCode
    bankName
    totalAmount
    withdrawalRequestId
    accountNo
  }
}
    `;
export const CompleteWithdrawalRequestsTransferDocument = gql`
    mutation completeWithdrawalRequestsTransfer($ids: [ID!]!) {
  completeWithdrawalRequestsTransfer(ids: $ids) {
    orderListComplete
  }
}
    `;
export const CancelWithdrawalOrderListDocument = gql`
    mutation cancelWithdrawalOrderList($cancelWithdrawalOrderListId: ID!) {
  cancelWithdrawalOrderList(id: $cancelWithdrawalOrderListId)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addActivity(variables: AddActivityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddActivityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddActivityMutation>(AddActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addActivity', 'mutation', variables);
    },
    registerWebauthnDevice(variables: RegisterWebauthnDeviceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegisterWebauthnDeviceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterWebauthnDeviceQuery>(RegisterWebauthnDeviceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registerWebauthnDevice', 'query', variables);
    },
    confirmWebauthnDeviceRegistration(variables: ConfirmWebauthnDeviceRegistrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConfirmWebauthnDeviceRegistrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmWebauthnDeviceRegistrationMutation>(ConfirmWebauthnDeviceRegistrationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'confirmWebauthnDeviceRegistration', 'mutation', variables);
    },
    webauthnLoginChallenge(variables: WebauthnLoginChallengeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WebauthnLoginChallengeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WebauthnLoginChallengeQuery>(WebauthnLoginChallengeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'webauthnLoginChallenge', 'query', variables);
    },
    webauthnLogin(variables: WebauthnLoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WebauthnLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WebauthnLoginMutation>(WebauthnLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'webauthnLogin', 'mutation', variables);
    },
    login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>(LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'login', 'mutation', variables);
    },
    getBalances(variables: GetBalancesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBalancesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBalancesQuery>(GetBalancesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBalances', 'query', variables);
    },
    getBalanceByUserId(variables: GetBalanceByUserIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBalanceByUserIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBalanceByUserIdQuery>(GetBalanceByUserIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBalanceByUserId', 'query', variables);
    },
    getBalance(variables: GetBalanceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBalanceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBalanceQuery>(GetBalanceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBalance', 'query', variables);
    },
    getAvailableBalances(variables: GetAvailableBalancesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAvailableBalancesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAvailableBalancesQuery>(GetAvailableBalancesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAvailableBalances', 'query', variables);
    },
    relatedBondPurchase(variables: RelatedBondPurchaseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RelatedBondPurchaseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RelatedBondPurchaseQuery>(RelatedBondPurchaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'relatedBondPurchase', 'query', variables);
    },
    relatedSavingPurchase(variables: RelatedSavingPurchaseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RelatedSavingPurchaseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RelatedSavingPurchaseQuery>(RelatedSavingPurchaseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'relatedSavingPurchase', 'query', variables);
    },
    generateBalancesDetail(variables?: GenerateBalancesDetailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateBalancesDetailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateBalancesDetailMutation>(GenerateBalancesDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateBalancesDetail', 'mutation', variables);
    },
    balanceExportTask(variables: BalanceExportTaskQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BalanceExportTaskQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BalanceExportTaskQuery>(BalanceExportTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'balanceExportTask', 'query', variables);
    },
    resetBalance(variables: ResetBalanceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ResetBalanceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResetBalanceMutation>(ResetBalanceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'resetBalance', 'mutation', variables);
    },
    CorrectCashWithdrawal(variables: CorrectCashWithdrawalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CorrectCashWithdrawalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CorrectCashWithdrawalMutation>(CorrectCashWithdrawalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CorrectCashWithdrawal', 'mutation', variables);
    },
    PreviewBondInterestRecalc(variables: PreviewBondInterestRecalcMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewBondInterestRecalcMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewBondInterestRecalcMutation>(PreviewBondInterestRecalcDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PreviewBondInterestRecalc', 'mutation', variables);
    },
    CorrectBondInterest(variables: CorrectBondInterestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CorrectBondInterestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CorrectBondInterestMutation>(CorrectBondInterestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CorrectBondInterest', 'mutation', variables);
    },
    CorrectStockPosition(variables: CorrectStockPositionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CorrectStockPositionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CorrectStockPositionMutation>(CorrectStockPositionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CorrectStockPosition', 'mutation', variables);
    },
    GetCorrectionOrders(variables: GetCorrectionOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCorrectionOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCorrectionOrdersQuery>(GetCorrectionOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCorrectionOrders', 'query', variables);
    },
    ExportCorrectionReport(variables: ExportCorrectionReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportCorrectionReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportCorrectionReportMutation>(ExportCorrectionReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ExportCorrectionReport', 'mutation', variables);
    },
    getBonds(variables: GetBondsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBondsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBondsQuery>(GetBondsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBonds', 'query', variables);
    },
    deleteBond(variables: DeleteBondMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteBondMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteBondMutation>(DeleteBondDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteBond', 'mutation', variables);
    },
    addBond(variables: AddBondMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddBondMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddBondMutation>(AddBondDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addBond', 'mutation', variables);
    },
    editBond(variables: EditBondMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditBondMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditBondMutation>(EditBondDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editBond', 'mutation', variables);
    },
    payoutPathInterest(variables: PayoutPathInterestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PayoutPathInterestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PayoutPathInterestMutation>(PayoutPathInterestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'payoutPathInterest', 'mutation', variables);
    },
    getBond(variables: GetBondQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBondQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBondQuery>(GetBondDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBond', 'query', variables);
    },
    bondHolders(variables: BondHoldersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BondHoldersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BondHoldersQuery>(BondHoldersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bondHolders', 'query', variables);
    },
    bondPayoutHistory(variables: BondPayoutHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BondPayoutHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BondPayoutHistoryQuery>(BondPayoutHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bondPayoutHistory', 'query', variables);
    },
    bondWithdrawalHistory(variables: BondWithdrawalHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BondWithdrawalHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BondWithdrawalHistoryQuery>(BondWithdrawalHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bondWithdrawalHistory', 'query', variables);
    },
    bondPayoutBatches(variables: BondPayoutBatchesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BondPayoutBatchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BondPayoutBatchesQuery>(BondPayoutBatchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bondPayoutBatches', 'query', variables);
    },
    getConfigs(variables?: GetConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetConfigsQuery>(GetConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getConfigs', 'query', variables);
    },
    editConfig(variables: EditConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditConfigMutation>(EditConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editConfig', 'mutation', variables);
    },
    getConfigByKey(variables: GetConfigByKeyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetConfigByKeyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetConfigByKeyQuery>(GetConfigByKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getConfigByKey', 'query', variables);
    },
    getUserDeletionRequests(variables: GetUserDeletionRequestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserDeletionRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserDeletionRequestsQuery>(GetUserDeletionRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserDeletionRequests', 'query', variables);
    },
    getFaqs(variables?: GetFaqsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetFaqsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFaqsQuery>(GetFaqsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFaqs', 'query', variables);
    },
    getFaq(variables: GetFaqQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetFaqQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFaqQuery>(GetFaqDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getFaq', 'query', variables);
    },
    addFaq(variables: AddFaqMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddFaqMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddFaqMutation>(AddFaqDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addFaq', 'mutation', variables);
    },
    editFaq(variables: EditFaqMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditFaqMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditFaqMutation>(EditFaqDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editFaq', 'mutation', variables);
    },
    deleteFaq(variables: DeleteFaqMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteFaqMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFaqMutation>(DeleteFaqDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFaq', 'mutation', variables);
    },
    getGroupActivities(variables: GetGroupActivitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetGroupActivitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGroupActivitiesQuery>(GetGroupActivitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGroupActivities', 'query', variables);
    },
    getGroupActivity(variables: GetGroupActivityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetGroupActivityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGroupActivityQuery>(GetGroupActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGroupActivity', 'query', variables);
    },
    deleteGroupActivity(variables: DeleteGroupActivityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteGroupActivityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteGroupActivityMutation>(DeleteGroupActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteGroupActivity', 'mutation', variables);
    },
    sendGroupActivity(variables: SendGroupActivityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendGroupActivityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendGroupActivityMutation>(SendGroupActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendGroupActivity', 'mutation', variables);
    },
    getImages(variables: GetImagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetImagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetImagesQuery>(GetImagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getImages', 'query', variables);
    },
    addImage(variables: AddImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddImageMutation>(AddImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addImage', 'mutation', variables);
    },
    deleteImage(variables: DeleteImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteImageMutation>(DeleteImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteImage', 'mutation', variables);
    },
    getKYCs(variables: GetKyCsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetKyCsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetKyCsQuery>(GetKyCsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getKYCs', 'query', variables);
    },
    getKYCByUser(variables: GetKycByUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetKycByUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetKycByUserQuery>(GetKycByUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getKYCByUser', 'query', variables);
    },
    getUserRegisterNo(variables: GetUserRegisterNoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserRegisterNoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserRegisterNoQuery>(GetUserRegisterNoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserRegisterNo', 'query', variables);
    },
    getUserTaxPayerNo(variables: GetUserTaxPayerNoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserTaxPayerNoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserTaxPayerNoQuery>(GetUserTaxPayerNoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserTaxPayerNo', 'query', variables);
    },
    getUserAddress(variables: GetUserAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserAddressQuery>(GetUserAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserAddress', 'query', variables);
    },
    deleteKYC(variables: DeleteKycMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteKycMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteKycMutation>(DeleteKycDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteKYC', 'mutation', variables);
    },
    editKYC(variables: EditKycMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditKycMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditKycMutation>(EditKycDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editKYC', 'mutation', variables);
    },
    getContracts(variables?: GetContractsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetContractsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetContractsQuery>(GetContractsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getContracts', 'query', variables);
    },
    requestContractUpload(variables: RequestContractUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequestContractUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestContractUploadMutation>(RequestContractUploadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'requestContractUpload', 'mutation', variables);
    },
    triggerRecontract(variables?: TriggerRecontractMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TriggerRecontractMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TriggerRecontractMutation>(TriggerRecontractDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'triggerRecontract', 'mutation', variables);
    },
    getUserContracts(variables: GetUserContractsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserContractsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserContractsQuery>(GetUserContractsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserContracts', 'query', variables);
    },
    getUserContractUrl(variables: GetUserContractUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserContractUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserContractUrlQuery>(GetUserContractUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserContractUrl', 'query', variables);
    },
    getKycQuestionnaires(variables: GetKycQuestionnairesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetKycQuestionnairesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetKycQuestionnairesQuery>(GetKycQuestionnairesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getKycQuestionnaires', 'query', variables);
    },
    getKycQuestionnaire(variables: GetKycQuestionnaireQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetKycQuestionnaireQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetKycQuestionnaireQuery>(GetKycQuestionnaireDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getKycQuestionnaire', 'query', variables);
    },
    previewKycQuestionnaireSegment(variables: PreviewKycQuestionnaireSegmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewKycQuestionnaireSegmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewKycQuestionnaireSegmentQuery>(PreviewKycQuestionnaireSegmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewKycQuestionnaireSegment', 'query', variables);
    },
    getKycQuestionnaireSends(variables: GetKycQuestionnaireSendsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetKycQuestionnaireSendsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetKycQuestionnaireSendsQuery>(GetKycQuestionnaireSendsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getKycQuestionnaireSends', 'query', variables);
    },
    getKycQuestionnaireSend(variables: GetKycQuestionnaireSendQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetKycQuestionnaireSendQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetKycQuestionnaireSendQuery>(GetKycQuestionnaireSendDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getKycQuestionnaireSend', 'query', variables);
    },
    getKycQuestionnaireSendsByUser(variables: GetKycQuestionnaireSendsByUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetKycQuestionnaireSendsByUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetKycQuestionnaireSendsByUserQuery>(GetKycQuestionnaireSendsByUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getKycQuestionnaireSendsByUser', 'query', variables);
    },
    addKycQuestionnaire(variables: AddKycQuestionnaireMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddKycQuestionnaireMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddKycQuestionnaireMutation>(AddKycQuestionnaireDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addKycQuestionnaire', 'mutation', variables);
    },
    editKycQuestionnaire(variables: EditKycQuestionnaireMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditKycQuestionnaireMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditKycQuestionnaireMutation>(EditKycQuestionnaireDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editKycQuestionnaire', 'mutation', variables);
    },
    deleteKycQuestionnaire(variables: DeleteKycQuestionnaireMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteKycQuestionnaireMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteKycQuestionnaireMutation>(DeleteKycQuestionnaireDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteKycQuestionnaire', 'mutation', variables);
    },
    sendKycQuestionnaireToUser(variables: SendKycQuestionnaireToUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendKycQuestionnaireToUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendKycQuestionnaireToUserMutation>(SendKycQuestionnaireToUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendKycQuestionnaireToUser', 'mutation', variables);
    },
    sendKycQuestionnaireToSegment(variables: SendKycQuestionnaireToSegmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendKycQuestionnaireToSegmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendKycQuestionnaireToSegmentMutation>(SendKycQuestionnaireToSegmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendKycQuestionnaireToSegment', 'mutation', variables);
    },
    sendKycQuestionnaireToAllUnresponded(variables: SendKycQuestionnaireToAllUnrespondedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendKycQuestionnaireToAllUnrespondedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendKycQuestionnaireToAllUnrespondedMutation>(SendKycQuestionnaireToAllUnrespondedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendKycQuestionnaireToAllUnresponded', 'mutation', variables);
    },
    previewKycQuestionnaireUnrespondedCount(variables: PreviewKycQuestionnaireUnrespondedCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewKycQuestionnaireUnrespondedCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewKycQuestionnaireUnrespondedCountQuery>(PreviewKycQuestionnaireUnrespondedCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewKycQuestionnaireUnrespondedCount', 'query', variables);
    },
    resendKycQuestionnaire(variables: ResendKycQuestionnaireMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ResendKycQuestionnaireMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResendKycQuestionnaireMutation>(ResendKycQuestionnaireDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'resendKycQuestionnaire', 'mutation', variables);
    },
    dispatchMonthlyFees(variables: DispatchMonthlyFeesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchMonthlyFeesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchMonthlyFeesMutation>(DispatchMonthlyFeesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchMonthlyFees', 'mutation', variables);
    },
    applyMonthlyFeesForUser(variables: ApplyMonthlyFeesForUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplyMonthlyFeesForUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyMonthlyFeesForUserMutation>(ApplyMonthlyFeesForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyMonthlyFeesForUser', 'mutation', variables);
    },
    getMSCDApiAccounts(variables: GetMscdApiAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMscdApiAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMscdApiAccountsQuery>(GetMscdApiAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMSCDApiAccounts', 'query', variables);
    },
    syncMSCDAccounts(variables?: SyncMscdAccountsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SyncMscdAccountsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncMscdAccountsMutation>(SyncMscdAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'syncMSCDAccounts', 'mutation', variables);
    },
    exportMSCDApiAccountsExcel(variables?: ExportMscdApiAccountsExcelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportMscdApiAccountsExcelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportMscdApiAccountsExcelMutation>(ExportMscdApiAccountsExcelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exportMSCDApiAccountsExcel', 'mutation', variables);
    },
    dispatchAccountCreationForDepositors(variables?: DispatchAccountCreationForDepositorsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchAccountCreationForDepositorsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchAccountCreationForDepositorsMutation>(DispatchAccountCreationForDepositorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchAccountCreationForDepositors', 'mutation', variables);
    },
    fixMSCDAccountNo(variables: FixMscdAccountNoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FixMscdAccountNoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FixMscdAccountNoMutation>(FixMscdAccountNoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fixMSCDAccountNo', 'mutation', variables);
    },
    updateMSCDAccountNo(variables: UpdateMscdAccountNoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMscdAccountNoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMscdAccountNoMutation>(UpdateMscdAccountNoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMSCDAccountNo', 'mutation', variables);
    },
    fixAndRetryMSCDAccount(variables: FixAndRetryMscdAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FixAndRetryMscdAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FixAndRetryMscdAccountMutation>(FixAndRetryMscdAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fixAndRetryMSCDAccount', 'mutation', variables);
    },
    getMSCDErrorAccounts(variables: GetMscdErrorAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMscdErrorAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMscdErrorAccountsQuery>(GetMscdErrorAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMSCDErrorAccounts', 'query', variables);
    },
    searchUserForMSCDLink(variables: SearchUserForMscdLinkQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchUserForMscdLinkQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchUserForMscdLinkQuery>(SearchUserForMscdLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchUserForMSCDLink', 'query', variables);
    },
    linkMSCDErrorAccount(variables: LinkMscdErrorAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LinkMscdErrorAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinkMscdErrorAccountMutation>(LinkMscdErrorAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'linkMSCDErrorAccount', 'mutation', variables);
    },
    getOrders(variables: GetOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrdersQuery>(GetOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrders', 'query', variables);
    },
    addOrder(variables: AddOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddOrderMutation>(AddOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addOrder', 'mutation', variables);
    },
    removeOrder(variables: RemoveOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOrderMutation>(RemoveOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOrder', 'mutation', variables);
    },
    returnOrder(variables: ReturnOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReturnOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReturnOrderMutation>(ReturnOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'returnOrder', 'mutation', variables);
    },
    bulkAddOrder(variables: BulkAddOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkAddOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkAddOrderMutation>(BulkAddOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkAddOrder', 'mutation', variables);
    },
    getBulkAddOrderBatch(variables: GetBulkAddOrderBatchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBulkAddOrderBatchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBulkAddOrderBatchQuery>(GetBulkAddOrderBatchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBulkAddOrderBatch', 'query', variables);
    },
    revertBulkAddOrderBatch(variables: RevertBulkAddOrderBatchMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RevertBulkAddOrderBatchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevertBulkAddOrderBatchMutation>(RevertBulkAddOrderBatchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'revertBulkAddOrderBatch', 'mutation', variables);
    },
    getOrderLists(variables: GetOrderListsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderListsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderListsQuery>(GetOrderListsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderLists', 'query', variables);
    },
    createOrderList(variables: CreateOrderListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderListMutation>(CreateOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderList', 'mutation', variables);
    },
    prepareOrderList(variables: PrepareOrderListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrepareOrderListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrepareOrderListMutation>(PrepareOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'prepareOrderList', 'mutation', variables);
    },
    generateOrderListDetail(variables: GenerateOrderListDetailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateOrderListDetailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateOrderListDetailMutation>(GenerateOrderListDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateOrderListDetail', 'mutation', variables);
    },
    generateOrderListOrders(variables: GenerateOrderListOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateOrderListOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateOrderListOrdersMutation>(GenerateOrderListOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateOrderListOrders', 'mutation', variables);
    },
    regenerateOrderListFile(variables: RegenerateOrderListFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegenerateOrderListFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegenerateOrderListFileMutation>(RegenerateOrderListFileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'regenerateOrderListFile', 'mutation', variables);
    },
    generateOrderListDetailPerUser(variables: GenerateOrderListDetailPerUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateOrderListDetailPerUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateOrderListDetailPerUserMutation>(GenerateOrderListDetailPerUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateOrderListDetailPerUser', 'mutation', variables);
    },
    getOrderList(variables: GetOrderListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderListQuery>(GetOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderList', 'query', variables);
    },
    downloadOrderList(variables: DownloadOrderListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadOrderListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadOrderListQuery>(DownloadOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'downloadOrderList', 'query', variables);
    },
    confirmOrderList(variables: ConfirmOrderListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConfirmOrderListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmOrderListMutation>(ConfirmOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'confirmOrderList', 'mutation', variables);
    },
    releaseHoldAmount(variables: ReleaseHoldAmountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReleaseHoldAmountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReleaseHoldAmountMutation>(ReleaseHoldAmountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'releaseHoldAmount', 'mutation', variables);
    },
    releaseHoldAmountForOrderList(variables: ReleaseHoldAmountForOrderListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReleaseHoldAmountForOrderListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReleaseHoldAmountForOrderListMutation>(ReleaseHoldAmountForOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'releaseHoldAmountForOrderList', 'mutation', variables);
    },
    requestOtp(variables: RequestOtpMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequestOtpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestOtpMutation>(RequestOtpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'requestOtp', 'mutation', variables);
    },
    recoverOtp(variables: RecoverOtpMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecoverOtpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecoverOtpMutation>(RecoverOtpDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'recoverOtp', 'mutation', variables);
    },
    getPortfolio(variables: GetPortfolioQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPortfolioQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPortfolioQuery>(GetPortfolioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPortfolio', 'query', variables);
    },
    getAllPortfolios(variables?: GetAllPortfoliosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllPortfoliosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllPortfoliosQuery>(GetAllPortfoliosDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllPortfolios', 'query', variables);
    },
    getPortfolios(variables: GetPortfoliosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPortfoliosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPortfoliosQuery>(GetPortfoliosDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPortfolios', 'query', variables);
    },
    addPortfolio(variables: AddPortfolioMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddPortfolioMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddPortfolioMutation>(AddPortfolioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addPortfolio', 'mutation', variables);
    },
    editPortfolio(variables: EditPortfolioMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditPortfolioMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditPortfolioMutation>(EditPortfolioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editPortfolio', 'mutation', variables);
    },
    deletePortfolio(variables: DeletePortfolioMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeletePortfolioMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePortfolioMutation>(DeletePortfolioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePortfolio', 'mutation', variables);
    },
    interestPayoutReports(variables?: InterestPayoutReportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InterestPayoutReportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InterestPayoutReportsQuery>(InterestPayoutReportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'interestPayoutReports', 'query', variables);
    },
    downloadInterestPayoutReport(variables: DownloadInterestPayoutReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadInterestPayoutReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadInterestPayoutReportMutation>(DownloadInterestPayoutReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'downloadInterestPayoutReport', 'mutation', variables);
    },
    feeReports(variables?: FeeReportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FeeReportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FeeReportsQuery>(FeeReportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'feeReports', 'query', variables);
    },
    downloadFeeReport(variables: DownloadFeeReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadFeeReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadFeeReportMutation>(DownloadFeeReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'downloadFeeReport', 'mutation', variables);
    },
    exportFeeReportForDateRange(variables: ExportFeeReportForDateRangeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportFeeReportForDateRangeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportFeeReportForDateRangeMutation>(ExportFeeReportForDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exportFeeReportForDateRange', 'mutation', variables);
    },
    exportInterestPayoutReportForDateRange(variables: ExportInterestPayoutReportForDateRangeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportInterestPayoutReportForDateRangeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportInterestPayoutReportForDateRangeMutation>(ExportInterestPayoutReportForDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exportInterestPayoutReportForDateRange', 'mutation', variables);
    },
    exportInterestPayoutReport(variables: ExportInterestPayoutReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportInterestPayoutReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportInterestPayoutReportMutation>(ExportInterestPayoutReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exportInterestPayoutReport', 'mutation', variables);
    },
    exportFeeReport(variables: ExportFeeReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportFeeReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportFeeReportMutation>(ExportFeeReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exportFeeReport', 'mutation', variables);
    },
    getSavings(variables: GetSavingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSavingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSavingsQuery>(GetSavingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSavings', 'query', variables);
    },
    getSaving(variables: GetSavingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSavingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSavingQuery>(GetSavingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSaving', 'query', variables);
    },
    addSaving(variables: AddSavingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddSavingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddSavingMutation>(AddSavingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addSaving', 'mutation', variables);
    },
    editSaving(variables: EditSavingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditSavingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditSavingMutation>(EditSavingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editSaving', 'mutation', variables);
    },
    deleteSaving(variables: DeleteSavingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteSavingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSavingMutation>(DeleteSavingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSaving', 'mutation', variables);
    },
    getStocks(variables: GetStocksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStocksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStocksQuery>(GetStocksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStocks', 'query', variables);
    },
    getAllStocksList(variables?: GetAllStocksListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllStocksListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllStocksListQuery>(GetAllStocksListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllStocksList', 'query', variables);
    },
    deleteStock(variables: DeleteStockMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteStockMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteStockMutation>(DeleteStockDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteStock', 'mutation', variables);
    },
    addStock(variables: AddStockMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddStockMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddStockMutation>(AddStockDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addStock', 'mutation', variables);
    },
    editStock(variables: EditStockMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditStockMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditStockMutation>(EditStockDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editStock', 'mutation', variables);
    },
    getStock(variables: GetStockQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStockQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStockQuery>(GetStockDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStock', 'query', variables);
    },
    getDividendReports(variables: GetDividendReportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDividendReportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDividendReportsQuery>(GetDividendReportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDividendReports', 'query', variables);
    },
    prepareDividendReport(variables: PrepareDividendReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PrepareDividendReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PrepareDividendReportMutation>(PrepareDividendReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'prepareDividendReport', 'mutation', variables);
    },
    distributeDividends(variables: DistributeDividendsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DistributeDividendsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DistributeDividendsMutation>(DistributeDividendsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'distributeDividends', 'mutation', variables);
    },
    AddSuggestion(variables: AddSuggestionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddSuggestionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddSuggestionMutation>(AddSuggestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddSuggestion', 'mutation', variables);
    },
    deleteSuggestion(variables: DeleteSuggestionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteSuggestionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSuggestionMutation>(DeleteSuggestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSuggestion', 'mutation', variables);
    },
    suggestions(variables?: SuggestionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SuggestionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuggestionsQuery>(SuggestionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'suggestions', 'query', variables);
    },
    getSurveys(variables?: GetSurveysQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSurveysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSurveysQuery>(GetSurveysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSurveys', 'query', variables);
    },
    getSurvey(variables: GetSurveyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSurveyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSurveyQuery>(GetSurveyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSurvey', 'query', variables);
    },
    addSurvey(variables: AddSurveyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddSurveyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddSurveyMutation>(AddSurveyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addSurvey', 'mutation', variables);
    },
    editSurvey(variables: EditSurveyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditSurveyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditSurveyMutation>(EditSurveyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editSurvey', 'mutation', variables);
    },
    deleteSurvey(variables: DeleteSurveyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteSurveyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSurveyMutation>(DeleteSurveyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSurvey', 'mutation', variables);
    },
    getUnmatchedDeposits(variables?: GetUnmatchedDepositsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUnmatchedDepositsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUnmatchedDepositsQuery>(GetUnmatchedDepositsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUnmatchedDeposits', 'query', variables);
    },
    matchUnmatchedDeposit(variables: MatchUnmatchedDepositMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MatchUnmatchedDepositMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatchUnmatchedDepositMutation>(MatchUnmatchedDepositDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchUnmatchedDeposit', 'mutation', variables);
    },
    dismissUnmatchedDeposit(variables: DismissUnmatchedDepositMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DismissUnmatchedDepositMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DismissUnmatchedDepositMutation>(DismissUnmatchedDepositDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dismissUnmatchedDeposit', 'mutation', variables);
    },
    addUser(variables: AddUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserMutation>(AddUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUser', 'mutation', variables);
    },
    editUser(variables: EditUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditUserMutation>(EditUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editUser', 'mutation', variables);
    },
    deleteUser(variables: DeleteUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUserMutation>(DeleteUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteUser', 'mutation', variables);
    },
    editUserPortfolio(variables: EditUserPortfolioMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditUserPortfolioMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditUserPortfolioMutation>(EditUserPortfolioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editUserPortfolio', 'mutation', variables);
    },
    cereateMSCDAccount(variables: CereateMscdAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CereateMscdAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CereateMscdAccountMutation>(CereateMscdAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cereateMSCDAccount', 'mutation', variables);
    },
    updateUserBankInfo(variables: UpdateUserBankInfoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserBankInfoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserBankInfoMutation>(UpdateUserBankInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserBankInfo', 'mutation', variables);
    },
    freezeUser(variables: FreezeUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FreezeUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FreezeUserMutation>(FreezeUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'freezeUser', 'mutation', variables);
    },
    unfreezeUser(variables: UnfreezeUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnfreezeUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnfreezeUserMutation>(UnfreezeUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unfreezeUser', 'mutation', variables);
    },
    getUsers(variables: GetUsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsersQuery>(GetUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUsers', 'query', variables);
    },
    getUser(variables: GetUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserQuery>(GetUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUser', 'query', variables);
    },
    me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>(MeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'me', 'query', variables);
    },
    getMscdAccountStatus(variables: GetMscdAccountStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMscdAccountStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMscdAccountStatusQuery>(GetMscdAccountStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMscdAccountStatus', 'query', variables);
    },
    getUserMSCDApiAccount(variables: GetUserMscdApiAccountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserMscdApiAccountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserMscdApiAccountQuery>(GetUserMscdApiAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserMSCDApiAccount', 'query', variables);
    },
    getUserMSCDAccount(variables: GetUserMscdAccountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserMscdAccountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserMscdAccountQuery>(GetUserMscdAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserMSCDAccount', 'query', variables);
    },
    retryMSCDAccountCreation(variables: RetryMscdAccountCreationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RetryMscdAccountCreationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RetryMscdAccountCreationMutation>(RetryMscdAccountCreationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'retryMSCDAccountCreation', 'mutation', variables);
    },
    getDashboardData(variables?: GetDashboardDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDashboardDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDashboardDataQuery>(GetDashboardDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDashboardData', 'query', variables);
    },
    getUsersExcel(variables?: GetUsersExcelQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUsersExcelQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsersExcelQuery>(GetUsersExcelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUsersExcel', 'query', variables);
    },
    userWithdrawalRequests(variables: UserWithdrawalRequestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserWithdrawalRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserWithdrawalRequestsQuery>(UserWithdrawalRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userWithdrawalRequests', 'query', variables);
    },
    downloadUserWithdrawals(variables: DownloadUserWithdrawalsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadUserWithdrawalsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadUserWithdrawalsMutation>(DownloadUserWithdrawalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'downloadUserWithdrawals', 'mutation', variables);
    },
    exportUserDetailedReportV2(variables: ExportUserDetailedReportV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportUserDetailedReportV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportUserDetailedReportV2Mutation>(ExportUserDetailedReportV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exportUserDetailedReportV2', 'mutation', variables);
    },
    exportClientReport(variables: ExportClientReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportClientReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportClientReportMutation>(ExportClientReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exportClientReport', 'mutation', variables);
    },
    exportSecuritiesCustomersExcel(variables?: ExportSecuritiesCustomersExcelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportSecuritiesCustomersExcelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportSecuritiesCustomersExcelMutation>(ExportSecuritiesCustomersExcelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exportSecuritiesCustomersExcel', 'mutation', variables);
    },
    cancelWithdrawalRequest(variables: CancelWithdrawalRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CancelWithdrawalRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelWithdrawalRequestMutation>(CancelWithdrawalRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelWithdrawalRequest', 'mutation', variables);
    },
    deleteContract(variables: DeleteContractMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteContractMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteContractMutation>(DeleteContractDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteContract', 'mutation', variables);
    },
    createWithdrawalOrderList(variables: CreateWithdrawalOrderListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWithdrawalOrderListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWithdrawalOrderListMutation>(CreateWithdrawalOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWithdrawalOrderList', 'mutation', variables);
    },
    downloadWithdrawalOrderList(variables: DownloadWithdrawalOrderListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadWithdrawalOrderListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadWithdrawalOrderListQuery>(DownloadWithdrawalOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'downloadWithdrawalOrderList', 'query', variables);
    },
    withdrawalRequest(variables: WithdrawalRequestQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WithdrawalRequestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawalRequestQuery>(WithdrawalRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawalRequest', 'query', variables);
    },
    allPendingWithdrawalRequests(variables?: AllPendingWithdrawalRequestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AllPendingWithdrawalRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllPendingWithdrawalRequestsQuery>(AllPendingWithdrawalRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allPendingWithdrawalRequests', 'query', variables);
    },
    allWithdrawalRequests(variables: AllWithdrawalRequestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AllWithdrawalRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllWithdrawalRequestsQuery>(AllWithdrawalRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allWithdrawalRequests', 'query', variables);
    },
    withdrawalOrderLists(variables: WithdrawalOrderListsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WithdrawalOrderListsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawalOrderListsQuery>(WithdrawalOrderListsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawalOrderLists', 'query', variables);
    },
    withdrawalOrderList(variables: WithdrawalOrderListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WithdrawalOrderListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawalOrderListQuery>(WithdrawalOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawalOrderList', 'query', variables);
    },
    previewWithdrawalOrderList(variables: PreviewWithdrawalOrderListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewWithdrawalOrderListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewWithdrawalOrderListQuery>(PreviewWithdrawalOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewWithdrawalOrderList', 'query', variables);
    },
    previewWithdrawalOrderListInterests(variables: PreviewWithdrawalOrderListInterestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewWithdrawalOrderListInterestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewWithdrawalOrderListInterestsQuery>(PreviewWithdrawalOrderListInterestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewWithdrawalOrderListInterests', 'query', variables);
    },
    confirmWithdrawalOrderList(variables: ConfirmWithdrawalOrderListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConfirmWithdrawalOrderListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmWithdrawalOrderListMutation>(ConfirmWithdrawalOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'confirmWithdrawalOrderList', 'mutation', variables);
    },
    downloadWithdrawalConfirmationReport(variables: DownloadWithdrawalConfirmationReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadWithdrawalConfirmationReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadWithdrawalConfirmationReportMutation>(DownloadWithdrawalConfirmationReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'downloadWithdrawalConfirmationReport', 'mutation', variables);
    },
    downloadWithdrawalPreReport(variables: DownloadWithdrawalPreReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadWithdrawalPreReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadWithdrawalPreReportMutation>(DownloadWithdrawalPreReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'downloadWithdrawalPreReport', 'mutation', variables);
    },
    previewWithdrawalOrderListTransfers(variables: PreviewWithdrawalOrderListTransfersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewWithdrawalOrderListTransfersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewWithdrawalOrderListTransfersQuery>(PreviewWithdrawalOrderListTransfersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewWithdrawalOrderListTransfers', 'query', variables);
    },
    completeWithdrawalRequestsTransfer(variables: CompleteWithdrawalRequestsTransferMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompleteWithdrawalRequestsTransferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteWithdrawalRequestsTransferMutation>(CompleteWithdrawalRequestsTransferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeWithdrawalRequestsTransfer', 'mutation', variables);
    },
    cancelWithdrawalOrderList(variables: CancelWithdrawalOrderListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CancelWithdrawalOrderListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelWithdrawalOrderListMutation>(CancelWithdrawalOrderListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cancelWithdrawalOrderList', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;